import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import noImage from "../images/clicktoAdd.png";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  CHECK_PAYMENT_TYPE,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_WAREHOUSE,
  DEMO_VALUE,
  NEW_ENTRY,
  NOT_APPLICABLE_ENTRY,
} from "../ds/App_Constants";
import {
  BaseBean,
  MasterAttributeBean,
  NodeData,
  RestReportBean,
} from "../ds/client_ds.js";
import {
  AccountReceivableBean,
  AccountReceivableCardDetailBean,
  AccountReceivableCheckDetailBean,
  AccountReceivableLineBean,
  AccountReceivablePaymentDetailBean,
  AccountReceivableWireTransferDetailBean,
  AddressBean,
  CertificateOfOriginInvoicePrintRequest,
  CheckPaymentDetailsPaymentInquiryCriteriaBean,
  CommercialInvoicePrintRequest,
  CustomerAgingOpenInvoicesPrintRequest,
  CustomerAndFabricSalesDetailPrintRequest,
  CustomerBean,
  CustomerInvoiceInquiryCriteriaBean,
  CustomerPaymentAgingHistoryCriteriaBean,
  CustomerSalesDataRequest,
  CustomerSalesOnOrderSearchCriteria,
  CustomerSearchCriteria,
  CustomerStatisticsInquiryCriteriaBean,
  CustomerTransactionAccountSummarySearchCriteria,
  CustomerTransactionDataRequest,
  FabricStyleBean,
  FabricStyleDetailInquiryCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InvoiceBean,
  InvoiceCommissionBean,
  InvoiceExtraChargesBean,
  InvoiceLineBean,
  InvoiceModuleDependenciesBean,
  InvoiceNonMerchandiseLineBean,
  InvoicePaymentHistoryPrintOutRequest,
  InvoiceRollLineBean,
  InvoiceSearchCriteria,
  InvoiceServiceLineBean,
  InvoiceShipmentBoxDetailBean,
  MailInfoBean,
  MostRecentFabricInquiryCriteriaBean,
  PageListBean,
  PickTicketBean,
  PickTicketSearchCriteria,
  PopupCustomerTransactionCreditMemoDetailsPrintRequest,
  PurchaseOrderSearchCriteria,
  ReasonBean,
  RestCustomerListRequest,
  RestCustomerSalesOnOrderListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestInvoiceListRequest,
  RestInvoiceMailInfoBeanRequest,
  RestInvoiceRequest,
  RestPageListBean,
  RestPickTicketListRequest,
  RestPrintInputRequest,
  RestReadRequest,
  SKUBatchInventorySearchCriteria,
  RestInvoiceServiceLineCancelRequest,
  InvoiceLineSearchCriteria,
  InvoiceImageBean,
  InvoiceDocumentBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { AddIcon, DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  BootstrapDataGridColumnDefinition,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  dateFormate,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InvoiceLookupHandlers } from "../lookup/InvoiceLookupHandlers.js";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { InvoiceModuleToolBar } from "../toolBar/InvoiceModuleToolBar.js";
import {
  BaseNodeBar,
  BaseNotification,
  BaseToolBar,
  ModuleToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";

import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import { CameraIcon, UploadDocIcon } from "../gui_components/Icons.js";
import {
  PopupAtsInq,
  PopupCustomerCurrentAgingInq,
  PopUpCustomerInfoInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerOnOrderInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
  PopupFabricInventoryPositionInq,
  PopupFabricPurchaseHistoryInq,
  PopupItemCurrentInventoryInq,
  PopupPurchaseAndSlesDetailsInq,
} from "../Inquiry/InquiryUtil.js";
import { PickTicketLineLookupHandler } from "../lookup/PickTicketLineLookupHandler.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import {
  PopupARModule,
  PopupCreditMemoModule,
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupLogisticOrderModule,
  PopupLogisticReceiptModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { CustomerService } from "../services/CustomerService.js";
import { InventoryService } from "../services/InventoryService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
import { CreditCardLookupHandler } from "../lookup/CreditCardLookupHandler.js";
class InvoiceList extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.entryFormRef = React.createRef();
    this.lineDetailDialogRef = React.createRef();
    this.shippingInformationFormRef = React.createRef();
    this.billingInformationFormRef = React.createRef();
    this.popUpRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.unApproveReasonDialogRef = React.createRef();
    this.paymentDialogRef = React.createRef();
    this.boxDetailDialogRef = React.createRef();
    this.fabricpopUpRef = React.createRef();
    this.lineDetailDialogStyles = {
      width: "90%",
      height: "calc(80% - 90px)",
      marginTop: "-230px",
      marginLeft: "-46%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.paymentDialogStyles = {
      width: "80%",
      height: "calc(80% - 50px)",
      marginTop: "-200px",
      marginLeft: "-40%",
      overflowX: "none",
      top: "45%",
      overflowY: "scroll",
    };
    this.boxDetailDialogStyles = {
      width: "90%",
      height: "calc(80% - 90px)",
      marginTop: "-230px",
      marginLeft: "-46%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.state = {
      pageTitle: "InvoiceMaintenance",
      moduleKeyCode: NEW_ENTRY,
      selectedNodeKey: "headerView",
      moduleCaption: "Invoice",
      isLoading: false,
      isEntryFormOpen: false,
      isListFormOpen: true,
      isShippingInformationFormOpened: false,
      isPaymentDetailsFormOpened: false,
      isChangesHistoryFormOpened: false,
      isPaymentHistoryFormOpened: false,
      isCommissionFormOpened: false,
      isServiceFormOpened: false,
      isShowModuleSearchContainer: false,
      isShowNodes: false,
      isShowAlertLvl5: false,
      isShowAlertLvl1: false,
      invoiceList: [],
      nodeList: [],
      invoiceListUpdateNeeded: false,
      invoiceData: new InvoiceBean(),
      invoiceLineData: new InvoiceLineBean(),
      pageList: new PageListBean(),
      invoiceCriteria: new InvoiceSearchCriteria(),
      dependenciesBean: new InvoiceModuleDependenciesBean(),
      invoiceBoxLineData: new InvoiceShipmentBoxDetailBean(),
      salesCommissionData: new InvoiceCommissionBean(),
      skuBatchInventories: [],
      salesPersonList: [],
      isShowLineCancelReasonPopup: false,
      cityList: [],
      stateList: [],
      countryList: [],
      freightMethods: [],
      shipVias: [],
      shipTos: [],
      billTos: [],
      boxTypes: [],
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unApproveReasons: [],
      paymentTypes: [],
      isShowSaveButton: true,
      isShowBackButton: false,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowPayButton: false,
      isShowCancelButton: false,

      creditCardTypes: [],
      arData: new AccountReceivableBean(),
      cardDetail: new AccountReceivableCardDetailBean(),
      checkDetail: new AccountReceivableCheckDetailBean(),
      wireTransferDetail: new AccountReceivableWireTransferDetailBean(),
      isCheckPayment: false,
      isCardPayment: false,
      isCashPayment: false,
      isWirePayment: false,
      isAchPayment: false,

      accountReceivablePaymentDetails: [],
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,

      moduleForPopup: [],

      isShowLinePopup: false,
      isShowBoxPopup: false,
      isShowPaymentPopup: false,
      simplePopupContent: [],

      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      invoiceLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      isResetView: true,
      moduleOrderStatus: "",
      disablePurchaseOrderFormFields: false,
      isShowModifyCommentPopup: false,

      isShowMailInvoiceButton: false,
      isShowModifyCommentButton: false,
      isShowGenerateSalesCommButton: false,
      isShowCommInvButton: false,
      isShowModifyButton: false,
      isShowPrintNaftaButton: false,

      isShowMailInvoicePopup: false,
      mailInfoData: new MailInfoBean(),
      isShowModifyPopup: false,
      criteria: new PurchaseOrderSearchCriteria(),

      isShowFabricStyleModule: false,
      isReseted: false,
      // isShowCustomerFabricSalesPopup: false,
      // isShowFabricCurrentInvPopup: false,
      // isShowFabricInventoryPosPopup: false,

      // isShowFabricPurchaseHistoryPopup: false,
      // isShowFabricAtsPopup: false,
      isDisableFields: false,
      isFocusLineDetail: false,
      isOpen: false,
      disableLineDetailPopUp: false,
      disableFabricPurchasePopUp: false,
      isMaintenanceMode: true,
      isDisabledFields: false,
      isShowRollDetails: false,

      isShowExtraChargePopup: false,
      invoiceExtraChargeData: new InvoiceExtraChargesBean(),
      extraChargeReasons: [],
      showAutoCompleteExtraChargeList: false,
      extraChargePageListForAutoCompleteList: [],
      isShowPopupAlert: false,

      isShowNonMerchandisePopup: false,
      merchandiseData: new InvoiceNonMerchandiseLineBean(),
      nonMerchandiseReasons: [],
      showAutoCompleteNonMercList: false,
      nonMercPageListForAutoCompleteList: [],

      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isShowCustomerCurrentAgingInq: false,
      isShowCustomerInfoInq: false,

      showAutoCompleteBoxTypeList: false,
      boxTypePageListForAutoCompleteList: [],

      addressData: new AddressBean(),
      billToAddressData: new AddressBean(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: [],
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: [],
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: [],

      showAutoCompleteSalesPersonList: false,
      salesPersonPageListForAutoCompleteList: [],

      showAutoCompletePaymentTypeList: true,
      paymentTypePageListForAutoCompleteList: new Array(),
      invoiceServiceLineData: new InvoiceServiceLineBean(),
      uoms: [],
      services: [],
      serviceLookupHandler: null,
      uomLookupHandler: null,
      invoiceServiceLineList: [],
      isShowAutoCompleteInvoiceUomList: false,
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      is3PL: false,
      isTarrifDisable: true,
      showAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipToList: false,
      shipToPageListForAutoCompleteList: new Array(),
      showAutoCompleteBillToList: false,
      billToPageListForAutoCompleteList: new Array(),
      showAutoCompletePickTicketList: false,
      pickTicketPageListForAutoCompleteList: new Array(),
      pickTicketData: new PickTicketBean(),
      isShowPtLineLookup: false,
      pickTicketLineLookupHandler: null,
      isPtDisable: false,
      isDisableAddLine: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      showAutoCompletePaymentTermList: false,
      paymentTermPageListForAutoCompleteList: new Array(),
      paymentTerms: [],

      isShowCustomerSalesHistoryInq: false,
      isShowItemInventoryPositionInq: false,
      isShowItemCurrentInventoryInq: false,
      isShowFabricPurchaseHistoryInq: false,
      isShowAtsInq: false,
      isShowfabricAndCustomerSalesDetails: false,
      order: "asc",
      sortField: "",

      customerServicesList: new Array(),
      isViewMode: false,
      isShowPOModule: false,
      isShowPOReceiptModule: false,



      isShowLogisticOrderModule: false,
      isShowLogisticReceiptModule: false,
      isShowExcelButton: false,

      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteColourList: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      colorLookupHandler: null,
      fabricStyleData: new FabricStyleBean(),
      customerData: new CustomerBean(),
      isCustomerNotFound: false,
      isShowColorLookup: false,

      showAutoCompleteUOMList: false,

      uomPageListForAutoCompleteList: new Array(),
      isShowUomLookup: false,
      isShowAutoCompleteCurrencyCodeList: false,
      currencyCodePageListForAutoCompleteList: new Array(),
      currencies: [],
      _skuBatchInventories: new Array(),
      _rollLines: new Array(),
      _invoiceLineData: new InvoiceLineBean(),
      isShowAlertLvl6: false,
      isShowCopyInvoicePopup: false,
      isShowCopyInvoiceButton: false,
      copyInvoiceNumber: "",

      showAutoCompleteInvoiceList: false,
      invoicePageListForAutoCompleteList: new Array(),

      invoicePrintoutTypes: [],

      isShowAutoCompletePrintoutTypeList: false,
      printoutTypePageListForAutoCompleteList: [],

      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,

      showAutoCompleteTypeList: false,
      typePageListForAutoCompleteList: new Array(),
      //  patternTypeLookupHandler:null,
      patternTypes: [],
      isTexco: false, // change it While integreation

      images: [],
      preview_Url: [],
      isImageFormOpened: false,
      tempIndex: null,

      documents: [],
      preview_Docs: [],
      isImageFormOpened: false,
      tempIndex: null,
      isServiceLineDisablesFields: false,

      imageEntity: new InvoiceImageBean(),

      invoiceTypes: [],
      invoiceTypeLookupHandler: null,
      isShowAutoCompleteInvoiceTypeList: false,
      invoiceTypePageListForAutoCompleteList: [],
      isShowCustomerButton: false,
      isShowCustomerModifyAlert: false,
      showAutoCompleteModifyCustomerList: false,
      customerCodeModifyPageListForAutoCompleteList: [],
      isShowCustomerModifyPopup: false,


      customerCreditCards: [],
      customerCreditCardLookUpHandler: null,
      isShowCustomerCreditCardLookup: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }
    ModuleUtils.getInvoiceStatusList();
    ModuleUtils.getInvoiceServiceLineStatusList();
    this.state.invoiceCriteria = new InvoiceSearchCriteria();
    this.state.invoiceCriteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    this.loadCacheDetails();

    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;

    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }

    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    // this.loadInvoices();

    if (this.props.invoiceCode !== "" && this.props.invoiceCode !== undefined) {
      this.code = this.props.invoiceCode;
      this.editInvoice(this.props.invoiceCode);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      //this.loadInvoices();
      //this.openEntryForm();
      this.addNewEntry();
    }
    setTimeout(() => {
      this.initLookupHandlers();
    }, 100);
  }
  componentDidUpdate() {
    // this.popUpRef.component.focus();
    // ReactDOM.findDOMNode(this.refs.divFocus).focus();
  }
  initLookupHandlers = () => {
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "Invoice"
    );
    this.setState({ invoiceLookupHandler: invoiceLookupHandler });
    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service"
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM"
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.state.paymentTerms,
      "PaymentTerm"
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
  };
  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    // const attribute_cache = { ...this.cache };
    // this.state.shipVias = [];
    // let shipVias = attribute_cache.shipVias;
    // if (!isEmptyArray(shipVias))
    //   shipVias.map((ent) => {
    //     this.state.shipVias.push(ent);
    //   });
    // this.state.freightMethods = [];
    // let freightMethods = attribute_cache.freightMethods;
    // if (!isEmptyArray(freightMethods))
    //   freightMethods.map((ent) => {
    //     this.state.freightMethods.push(ent);
    //   });
    // this.state.cityList = [];
    // let cityList = attribute_cache.cities;
    // if (!isEmptyArray(cityList))
    //   cityList.map((ent) => {
    //     this.state.cityList.push(ent);
    //   });

    // this.state.stateList = [];
    // let stateList = attribute_cache.states;
    // if (!isEmptyArray(stateList))
    //   stateList.map((ent) => {
    //     this.state.stateList.push(ent);
    //   });
    // this.state.countryList = [];
    // let countryList = attribute_cache.countries;
    // if (!isEmptyArray(countryList))
    //   countryList.map((ent) => {
    //     this.state.countryList.push(ent);
    //   });

    // this.state.boxTypes = [];
    // let boxTypes = attribute_cache.boxTypes;
    // if (!isEmptyArray(boxTypes))
    //   boxTypes.map((ent) => {
    //     this.state.boxTypes.push(ent);
    //   });

    // this.state.cancelReasons = [];
    // let cancelReasons = attribute_cache.invoiceCancelReasons;
    // if (!isEmptyArray(cancelReasons))
    //   cancelReasons.map((ent) => {
    //     this.state.cancelReasons.push(ent);
    //   });

    // this.state.unApproveReasons = [];
    // let unApproveReasons = attribute_cache.invoiceUnApprovalReasons;
    // if (!isEmptyArray(unApproveReasons))
    //   unApproveReasons.map((ent) => {
    //     this.state.unApproveReasons.push(ent);
    //   });

    // this.state.salesPersonList = [];
    // let salesPersonList = attribute_cache.salesPersons;
    // if (!isEmptyArray(salesPersonList))
    //   salesPersonList.map((ent) => {
    //     this.state.salesPersonList.push(ent);
    //   });
    // this.state.extraChargeReasons = [];
    // let extraChargeReasons = attribute_cache.extraChargeReasons;
    // if (!isEmptyArray(extraChargeReasons))
    //   extraChargeReasons.map((type) => {
    //     this.state.extraChargeReasons.push(type);
    //   });

    // this.state.nonMerchandiseReasons = [];
    // let nonMerchandiseReasons = attribute_cache.invoiceNonMerchandiseReasons;
    // if (!isEmptyArray(nonMerchandiseReasons))
    //   nonMerchandiseReasons.map((type) => {
    //     this.state.nonMerchandiseReasons.push(type);
    //   });
    // let services = attribute_cache.serviceInfos;
    // if (services != null || services != undefined) {
    //   services.map((attr) => {
    //     this.state.services.push(attr);
    //   });
    // }
    // let uoms = attribute_cache.uoms;
    // if (uoms != null || uoms != undefined) {
    //   uoms.map((attr) => {
    //     this.state.uoms.push(attr);
    //   });
    // }

    // let paymentTerms = attribute_cache.paymentTerms;
    // if (paymentTerms != null || paymentTerms != undefined) {
    //   paymentTerms.map((paymentTerm) => {
    //     this.state.paymentTerms.push(paymentTerm);
    //   });
    // }
    const attribute_cache = { ...this.cache };
    let shipVia_temp = ModuleUtils.isActiveAttribute(attribute_cache.shipVias);
    let freightMethod_temp = ModuleUtils.isActiveAttribute(attribute_cache.freightMethods);
    let cityLists_tem = ModuleUtils.isActiveAttribute(attribute_cache.cities);
    let stateLists_temp = ModuleUtils.isActiveAttribute(attribute_cache.states);
    let boxType_temp = ModuleUtils.isActiveAttribute(attribute_cache.boxTypes);
    let cancelReason_temp = ModuleUtils.isActiveAttribute(attribute_cache.invoiceCancelReasons);
    let unApproveReason_temp = ModuleUtils.isActiveAttribute(attribute_cache.invoiceUnApprovalReasons);
    let salesPersonLists_temp = ModuleUtils.isActiveAttribute(attribute_cache.salesPersons);
    let extraChargeReasons_temp = ModuleUtils.isActiveAttribute(attribute_cache.extraChargeReasons);
    let nonMerchandiseReasons_temp = ModuleUtils.isActiveAttribute(attribute_cache.invoiceNonMerchandiseReasons);
    let services = ModuleUtils.isActiveAttribute(attribute_cache.serviceInfos);
    let uoms = ModuleUtils.isActiveAttribute(attribute_cache.uoms);
    let paymentTerm_temp = ModuleUtils.isActiveAttribute(attribute_cache.paymentTerms);
    let currencies_temp = ModuleUtils.isActiveAttribute(attribute_cache.currencies);
    let invoicePrintoutTypes = ModuleUtils.isActiveAttribute(attribute_cache.invoicePrintoutTypes);
    let patternTypes = ModuleUtils.isActiveAttribute(attribute_cache.patternTypes);
    let invoiceTypeTemp = ModuleUtils.isActiveAttribute(attribute_cache.invoiceType);
    let countryLists_temp = ModuleUtils.isActiveAttribute(attribute_cache.countries);
    this.setState({
      shipVias: shipVia_temp,
      freightMethods: freightMethod_temp,
      countryList: countryLists_temp,
      stateList: stateLists_temp,
      cityList: cityLists_tem,


      boxTypes: boxType_temp,
      cancelReasons: cancelReason_temp,
      unApproveReasons: unApproveReason_temp,

      salesPersonList: salesPersonLists_temp,
      extraChargeReasons: extraChargeReasons_temp,
      nonMerchandiseReasons: nonMerchandiseReasons_temp,
      services: services,
      uoms: uoms,
      paymentTerms: paymentTerm_temp,
      currencies: currencies_temp,
      invoicePrintoutTypes: invoicePrintoutTypes,
      patternTypes: patternTypes,
      invoiceTypes: invoiceTypeTemp,

    }, () => { this.initPaymentTypes() })


    // this.initPaymentTypes();
  };

  initPaymentTypes = () => {
    this.state.paymentTypes = [];

    let check = new MasterAttributeBean();
    check.code = "Check";
    check.description = "Check";
    this.state.paymentTypes.push(check);

    let cash = new MasterAttributeBean();
    cash.code = "Cash";
    cash.description = "Cash";
    this.state.paymentTypes.push(cash);
    let debitCard = new MasterAttributeBean();
    debitCard.code = "DebitCard";
    debitCard.description = "DebitCard";
    this.state.paymentTypes.push(debitCard);
    let creditCard = new MasterAttributeBean();
    creditCard.code = "CreditCard";
    creditCard.description = "DebitCard";
    this.state.paymentTypes.push(creditCard);
    let wireTransfer = new MasterAttributeBean();
    wireTransfer.code = "WireTransfer";
    wireTransfer.description = "WireTransfer";
    this.state.paymentTypes.push(wireTransfer);
    let ach = new MasterAttributeBean();
    ach.code = "ACH";
    ach.description = "ACH";
    this.state.paymentTypes.push(ach);
  };

  loadInvoicesResponse = (response) => {
    let invoiceList = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.invoicePageList)) {
      invoiceList = response.data.invoicePageList.invoices;
      this.state.pageList.totalCount = response.data.invoicePageList.totalCount;
      this.state.pageList.currentPage =
        response.data.invoicePageList.currentPage;
    } else {
      invoiceList = new Array();
      this.showErrorMessage(response);
    }
    let loading = this.state.isLoading;
    loading = false;

    this.setState({
      isLoading: loading,
      invoiceList: invoiceList,
      isLockRequired: true,
    });
  };
  loadInvoicesError = (error) => {
    ShowError("Error : ", error);
  };
  loadInvoices = () => {
    let requestInput = new RestInvoiceListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.invoiceCriteria;
    this.setState({
      isLoading: true,
    });
    if (SecurityAccessManager.InvoiceMaintenanceView_IsAccessible()) {
      InvoiceService.getInvoicePageList(
        requestInput,
        this.loadInvoicesResponse,
        this.loadInvoicesError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  //#region Paging Related

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    //totalPages = totalPages.toFixed(1);
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadInvoices();
  };
  filterInvoice = () => {
    this.loadPage(1);
  };

  resetFilteredInvoice = (criteria) => {
    criteria = new InvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;

    this.state.invoiceCriteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  //#endregion

  readCustomerCodeForCC = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerCodeResponse,
      this.readCustomerError,
    );
  };
  readCustomerCodeResponse = (response) => {

    let customerData = response.data.customer;
    if (customerData != null) {
      let customerCode = this.state.customerCode;
      customerCode = customerData.code;
      let customerCreditCards = [];

      if (isEmptyArray(this.state.customerCreditCards)) {

        customerCreditCards = customerData.customerCreditCards;

        const maskedCustomerCards = customerCreditCards.map((card) => ({
          ...card,
          cardNumber: `************ ${card.cardNumber.slice(-4)}`,
        }));

        this.setState({
          customerCreditCards: customerCreditCards,

        });


        let customerCreditCardLookUpHandler = new CreditCardLookupHandler(
          maskedCustomerCards,
          "CreditCard",
        );
        this.setState({
          customerCreditCardLookUpHandler: customerCreditCardLookUpHandler,
        });
      }
      this.setState({
        customerCode: customerCode,
      });
    }
  };
  readCustomerError = (error) => { };

  //#region Edit Invoice
  editInvoiceResponse = (response) => {
    let errMsg = "";
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (response.data != null) {
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.invoiceResponse != null) {
        if (response.data.invoiceResponse.errors != null) {
          response.data.invoiceResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (errMsg != "Invoice [" + this.state.moduleKeyCode + "] Not read!") {
        this.showErrorMessage(response.data.invoiceResponse);
      }
      if (response.data.success == true) {
        let customerServicesList = new Array();
        if (
          !isEmpty(response.data.dependenciesResponse) &&
          !isEmpty(response.data.dependenciesResponse.dependenciesBean) &&
          !isEmpty(
            response.data.dependenciesResponse.dependenciesBean.customer
          ) &&
          !isEmptyArray(
            response.data.dependenciesResponse.dependenciesBean.customer
              .customerServices
          )
        ) {
          customerServicesList.push(
            ...response.data.dependenciesResponse.dependenciesBean.customer
              .customerServices
          );
        }
        this.setState({
          customerServicesList: customerServicesList,
        });
        if (response.data.invoiceResponse != null) {
          const invoice = response.data.invoiceResponse.invoice;
          let isDisableFields = false;
          let pageTitle = this.state.moduleCaption + " - EDIT";
          if (invoice !== null) {
            let moduleKeyCode = invoice.code;
            if (invoice.isFetched) isDisableFields = true;
            let dependenciesBean = null;
            if (response.data.dependenciesResponse != null) {
              dependenciesBean =
                response.data.dependenciesResponse.dependenciesBean;
            }
            let shipTos = [];
            if (
              !isEmpty(dependenciesBean) &&
              !isEmpty(dependenciesBean.customer) &&
              !isEmptyArray(dependenciesBean.customer.shipTos)
            ) {
              shipTos = dependenciesBean.customer.shipTos;
            }
            let billTos = [];
            if (
              !isEmpty(dependenciesBean) &&
              !isEmpty(dependenciesBean.customer) &&
              !isEmptyArray(dependenciesBean.customer.billTos)
            ) {
              billTos = dependenciesBean.customer.billTos;
            }

            // if(isEmpty(invoice.companyCurrencyCode) && isEmpty(invoice.invoiceCurrencyCode)){
            //     this.state.invoiceData.companyCurrencyCode = DEFAULT_CURRENCY_CODE;
            //     this.state.invoiceData.invoiceCurrencyCode = DEFAULT_CURRENCY_CODE;
            // }
            if (isEmpty(invoice.companyCurrencyCode) && isEmpty(invoice.invoiceCurrencyCode)) {
              invoice.companyCurrencyCode = DEFAULT_CURRENCY_CODE;
              invoice.invoiceCurrencyCode = DEFAULT_CURRENCY_CODE;
            }

            this.state.invoiceData = invoice;
            if (
              !isEmpty(invoice) &&
              !isEmpty(invoice.customerCode) &&
              isEmptyArray(this.state.customerCreditCards)
            ) {

              this.readCustomerCodeForCC(invoice.customerCode);
            }

            this.setState({
              invoiceData: invoice,
              pageTitle: pageTitle,
              isDisableFields: isDisableFields,
              isShowNodes: true,
              invoiceListUpdateNeeded: true,
              moduleKeyCode: moduleKeyCode,
              dependenciesBean: dependenciesBean,
              shipTos: shipTos,
              billTos: billTos,
              // disabled: true,
              isFocus: true,
            });
            this.isLocked = true;
            this.getNodeList();

            this.openEntryForm();
          } else {
            let errMsg = "New Invoice not Permitable";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }

      }
    }
  };

  addNewEntry = () => {

    let invoiceData = new InvoiceBean();

    let isShowSaveButton = true;

    let pageTitle = this.state.moduleCaption + " - " + NEW_ENTRY;
    invoiceData.companyCode = this.companyCode;
    invoiceData.invoiceStatus = LogicConstants.INVOICE_UNAPPROVE_STATUS;

    // if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
    //   invoiceData.pickTicketNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.salesOrderNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.purchaseOrderNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.purchaseOrderReceiptNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.logisticOrderNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.logisticOrderReceiptNumber = NOT_APPLICABLE_ENTRY;
    //   invoiceData.isManualEntry = true;
    // }
    //let currentDate = new Date();
    let currentDate = toFormattedDate_v1(new Date());
    //currentDate = currentDate.toLocaleDateString("sv-SE");

    invoiceData.invoiceDate = currentDate;
    invoiceData.paymentDueDate = currentDate;
    invoiceData.companyCurrencyCode = DEFAULT_CURRENCY_CODE;
    invoiceData.invoiceCurrencyCode = DEFAULT_CURRENCY_CODE;
    invoiceData.adjustedExchangeRate = 1;
    invoiceData.actualExchangeRate = 1;
    invoiceData.isManualEntry = true;
    if (!isEmptyString(this.state.moduleKeyCode)) {
      invoiceData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else invoiceData.code = NEW_ENTRY;
    this.setState({
      invoiceData: invoiceData,
      pageTitle: pageTitle,
      isShowCopyInvoiceButton: true,
      isShowSaveButton: isShowSaveButton,
      disabled: false,
    });
    this.state.invoiceData = invoiceData;
    this.openEntryForm();
  };
  editInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  editInvoice = (invoiceNumber) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = invoiceNumber;

    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === invoiceNumber ? false : true;
    }
    // let isLockRequired = NEW_ENTRY === invoiceNumber ? false : true;

    readrestInput.isLockRequired = isLockRequired;
    this.state.isDisableFields = true;
    this.setState({
      invoiceListUpdateNeeded: false,
    });
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      InvoiceService.initInvoiceModule(
        readrestInput,
        this.editInvoiceResponse,
        this.editInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_invoiceData = this.state.invoiceData;
    temp_invoiceData[e.target.name] = e.target.value;
    let temp_mailInfoData = this.state.mailInfoData;
    temp_mailInfoData[e.target.name] = e.target.value;
    // if (e.target.name == "shipToCode") {
    //   this.onShipToCodeChange(e.target.value);
    // }
    this.setState({
      invoiceData: temp_invoiceData,
      mailInfoData: temp_mailInfoData,
    });
  };
  onHeaderAmountsChange = (e) => {
    let invoiceData = this.state.invoiceData;
    invoiceData[e.target.name] = e.target.value;
    this.state.invoiceData = invoiceData;
    this.setState({ invoiceData: invoiceData });
    this.calculateTotals();
    // let grandTotalAmount = 0;
    // let subTotalAmount = 0;
    // let extraChargesAmount = 0;
    // let nonMerchandiseTotalAmount = 0;
    // let lineTotalTaxAmount = 0;
    // let shipmentChargesAmount = 0;
    // let tariffAmount = 0;
    // let serviceAmount = 0;
    // let invoiceLineData = invoiceData.lines;
    // invoiceLineData.map((line) => {
    //   lineTotalTaxAmount = lineTotalTaxAmount + line.taxAmount;
    //   subTotalAmount = subTotalAmount + line.lineTotalAmount;
    // });
    // if (invoiceData.extraChargesAmount != 0) {
    //   extraChargesAmount = invoiceData.extraChargesAmount;
    // }
    // if (invoiceData.nonMerchandiseTotalAmount != 0) {
    //   nonMerchandiseTotalAmount = invoiceData.nonMerchandiseTotalAmount;
    // }
    // if (invoiceData.shipmentChargesAmount != 0) {
    //   shipmentChargesAmount = invoiceData.shipmentChargesAmount;
    // }
    // if (invoiceData.tariffAmount != 0) {
    //   tariffAmount = invoiceData.tariffAmount;
    // }
    // //calculate discountAmount and set subTotalAmount
    // let discountAmount = 0;
    // if (invoiceData.discountAmount != 0) {
    //   discountAmount = invoiceData.discountAmount;
    // }
    // if (invoiceData.totalServiceAmount != 0) {
    //   serviceAmount = invoiceData.totalServiceAmount;
    // }
    // grandTotalAmount =
    //   subTotalAmount -
    //   parseFloat(discountAmount) +
    //   parseFloat(extraChargesAmount) +
    //   parseFloat(nonMerchandiseTotalAmount) +
    //   lineTotalTaxAmount +
    //   parseFloat(shipmentChargesAmount) +
    //   parseFloat(tariffAmount) +
    //   parseFloat(serviceAmount);
    // invoiceData.grandTotalAmount = grandTotalAmount;
    // invoiceData.subTotalAmount = subTotalAmount;
    // invoiceData.discountAmount = discountAmount;
    // invoiceData.totalServiceAmount = serviceAmount;
    // invoiceData.standardGrandTotalAmount = invoiceData.grandTotalAmount;
    // this.setState({ invoiceData: invoiceData });
  };
  onARChange = (e) => {
    if (e.target.name == "cashAmount") {
      let temp_arData = this.state.arData;
      temp_arData.cashAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
  };
  onARPaymentTypeChange = (e) => {
    let temp_arData = this.state.arData;
    let temp_cardDetail = this.state.cardDetail;
    temp_cardDetail.companyCode = this.companyCode;
    temp_arData[e.target.name] = e.target.value;
    let temp_wireTransferDetail = this.state.wireTransferDetail;
    temp_wireTransferDetail.companyCode = this.companyCode;

    let invoiceData = this.state.invoiceData;
    let arData = this.state.arData;
    let grantTotalAmount = invoiceData.grandTotalAmount;
    let postedPaidAmount = invoiceData.netPaidAmount;
    let unPostedPaidAmount =
      invoiceData.provisionalChargeBackAmount +
      invoiceData.provisionalOtherAppliedAmount +
      invoiceData.provisionalCreditMemoAmount;

    let openInvoiceAmount =
      grantTotalAmount - (postedPaidAmount + unPostedPaidAmount);
    let isCardPayment = false;
    let isCheckPayment = false;
    let isCashPayment = false;
    let isWirePayment = false;
    let isAchPayment = false;
    if (temp_arData.paymentTypeCode == "Check") {
      isCheckPayment = true;
      isCardPayment = false;
      isCashPayment = false;
      isWirePayment = false;
      isAchPayment = false;
      arData.cashAmount = 0;
      arData.cardAmount = 0;
    } else if (temp_arData.paymentTypeCode == "Cash") {
      isCashPayment = true;
      isCheckPayment = false;
      isCardPayment = false;
      isWirePayment = false;
      isAchPayment = false;
      arData.cashAmount = parseFloat(openInvoiceAmount).toFixed(2);
      arData.cardAmount = 0;
      arData.checkAmount = 0;
    } else if (temp_arData.paymentTypeCode == "DebitCard") {
      isCardPayment = true;
      isCheckPayment = false;
      isCashPayment = false;
      isWirePayment = false;
      isAchPayment = false;
      arData.cardAmount = parseFloat(openInvoiceAmount).toFixed(2);
      arData.cashAmount = 0;
      arData.checkAmount = 0;
      temp_cardDetail.cardAmount = parseFloat(openInvoiceAmount).toFixed(2);
      temp_cardDetail.isDebitCard = true;
    } else if (temp_arData.paymentTypeCode == "CreditCard") {
      isCardPayment = true;
      isCheckPayment = false;
      isCashPayment = false;
      isWirePayment = false;
      isAchPayment = false;
      arData.cardAmount = parseFloat(openInvoiceAmount).toFixed(2);
      arData.cashAmount = 0;
      arData.checkAmount = 0;
      temp_cardDetail.cardAmount = parseFloat(openInvoiceAmount).toFixed(2);
      if (!isEmptyArray(this.state.customerCreditCards)) {
        this.setState({ isShowCustomerCreditCardLookup: true })
      } else {
        this.setState({ isShowCustomerCreditCardLookup: false })
      }
    } else if (temp_arData.paymentTypeCode == "WireTransfer") {
      isWirePayment = true;
      isCheckPayment = false;
      isCardPayment = false;
      isCashPayment = false;
      isAchPayment = false;
      arData.wireTransferAmount = parseFloat(openInvoiceAmount).toFixed(2);
      arData.cashAmount = 0;
      arData.checkAmount = 0;
      arData.cardAmount = 0;
      temp_wireTransferDetail.wireTransferAmount =
        parseFloat(openInvoiceAmount).toFixed(2);
    } else if (temp_arData.paymentTypeCode == "ACH") {
      isAchPayment = true;
      isCheckPayment = false;
      isCardPayment = false;
      isCashPayment = false;
      isWirePayment = false;
      arData.autoClearingHouseAmount = parseFloat(openInvoiceAmount).toFixed(2);
      arData.cashAmount = 0;
      arData.checkAmount = 0;
      arData.cardAmount = 0;
      temp_wireTransferDetail.wireTransferAmount =
        parseFloat(openInvoiceAmount).toFixed(2);
    }
    if (
      !isCardPayment &&
      !isCheckPayment &&
      !isCashPayment &&
      !isWirePayment &&
      !isAchPayment
    )
      isCheckPayment = true;

    this.setState({
      arData: temp_arData,
      cardDetail: temp_cardDetail,
      isCardPayment: isCardPayment,
      isCheckPayment: isCheckPayment,
      isCashPayment: isCashPayment,
      isWirePayment: isWirePayment,
      isAchPayment: isAchPayment,
    });
  };
  onCardDetailsChange = (e) => {
    let temp_cardDetail = this.state.cardDetail;
    temp_cardDetail[e.target.name] = e.target.value;
    let temp_arData = this.state.arData;
    if (e.target.name == "cardAmount") {
      temp_arData.cardAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    if (e.target.name == "cardNumber") {
      temp_arData.cardNumber = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({ cardDetail: temp_cardDetail });
  };

  onCustomerCreditCardDetailsChange = (e) => {
    // const selectedCard = this.state.customerCreditCards.find(
    //   (card) => `************ ${card.cardNumber.slice(-4)}` === e.target.value,
    // );
    const selectedCard = this.state.customerCreditCards.find(
      (card) => card.cardID === e.target.value,
    );

    // console.log("selectedCard onChange", selectedCard);

    if (selectedCard) {
      this.setState({
        cardDetail: {
          ...this.state.cardDetail,
          cardNumber: `************ ${selectedCard.cardNumber.slice(-4)}`,
          cardType: selectedCard.cardType,
          expiryMonth: selectedCard.expiryMonth,
          expiryYear: selectedCard.expiryYear,
        },
      });
    } else {
      this.setState({
        cardDetail: {
          ...this.state.cardDetail,
          cardNumber: e.target.value,

        },
      })
    }
  };


  onCheckDetailsChange = (e) => {
    let temp_checkDetail = this.state.checkDetail;
    temp_checkDetail[e.target.name] = e.target.value;
    if (e.target.name == "checkAmount") {
      let temp_arData = this.state.arData;
      temp_arData.checkAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({ checkDetail: temp_checkDetail });
  };

  onWireTransferDetailsChange = (e) => {
    let temp_wireTransferDetail = this.state.wireTransferDetail;
    temp_wireTransferDetail[e.target.name] = e.target.value;
    if (e.target.name == "wireTransferAmount") {
      let temp_arData = this.state.arData;
      temp_arData.wireTransferAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({ wireTransferDetail: temp_wireTransferDetail });
  };

  onShipToCodeChange = (shipToCode) => {
    let shipToBean = null;
    this.state.shipTos.map((ln) => {
      if (ln.code === shipToCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_invoiceData = this.state.invoiceData;
      temp_invoiceData.shipToName = shipToBean.description;
      temp_invoiceData.shipViaCode = shipToBean.shipViaCode;
      if (!isEmpty(shipToBean.address)) {
        let address = new AddressBean();
        address.address1 = shipToBean.address.address1;
        address.address1 = shipToBean.address.address1;
        address.address2 = shipToBean.address.address2;
        address.address3 = shipToBean.address.address3;
        address.city = shipToBean.address.city;
        address.country = shipToBean.address.country;
        address.state = shipToBean.address.state;
        address.zip = shipToBean.address.zip;
        address.phone1 = shipToBean.address.phone1;
        address.phone2 = shipToBean.address.phone2;
        address.mobilePhone = shipToBean.address.mobilePhone;
        // temp_invoiceData.shipToAddress = address;
        temp_invoiceData.address = address;
        this.setState({ addressData: address });
      }

      this.setState({ invoiceData: temp_invoiceData });
    }
  };

  addressOnChange = (e) => {
    let invoiceData = this.state.invoiceData;
    let tempAddress = this.state.addressData;
    if (!isEmpty(invoiceData)) {
      tempAddress = invoiceData.address;
      tempAddress[e.target.name] = e.target.value;
    }
    invoiceData.address = tempAddress;
    this.setState({ invoiceData: invoiceData, addressData: tempAddress });
  };
  onLineChange = (e) => {
    let temp_invoiceLineData = this.state.invoiceLineData;
    temp_invoiceLineData[e.target.name] = e.target.value;
    // if (e.target.name == "price") {
    //   temp_invoiceLineData["lineDiscountAmount"] =
    //     (temp_invoiceLineData.discountPercentage / 100) *
    //     e.target.value *
    //     temp_invoiceLineData.shippedQuantity;
    //   temp_invoiceLineData["lineNetAmount"] =
    //     e.target.value * temp_invoiceLineData.shippedQuantity -
    //     temp_invoiceLineData.lineDiscountAmount;
    //   temp_invoiceLineData.tariffAmount =
    //     temp_invoiceLineData.lineNetAmount *
    //     (temp_invoiceLineData.tariffPercentage / 100);
    // }
    // if (e.target.name == "tariffPercentage") {
    //   temp_invoiceLineData["tariffAmount"] =
    //     (e.target.value / 100) * temp_invoiceLineData.price;
    // }
    this.setState({ invoiceLineData: temp_invoiceLineData });
  };
  /* open Invoice entry form*/
  openEntryForm = () => {
    this.clearError();
    let invoiceData = this.state.invoiceData;
    invoiceData.companyCode = this.companyCode;
    invoiceData.invoiceCurrencyCode = DEFAULT_CURRENCY_CODE;
    this.closeAllNodeViews();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: true,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowCancelButton: true,
      isShowModuleSearchContainer: true,
      invoiceLineData: new InvoiceLineBean(),
      isResetCustomerDynamicAutoComplete: false,
      isShowNodes: true,
      isResetView: false,
      isFocus: true,
      invoiceData: invoiceData,
      isShowAutoCompleteInvoiceUomList: false,
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      isDisableAddLine: false,
      isTarrifDisable: true,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        isTarrifDisable: true,
        isDisableFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.state.moduleCaption + " - VIEW";
        this.setState({
          disabled: true,
          isDisableNodeFields: true,
          isDisabledFields: true,
          isTarrifDisable: true,
          pageTitle: pageTitle,
          isDisableFields: true,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
        isTarrifDisable: true,
        isDisableFields: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    this.initModuleButtons();
    this.getNodeList();
    // this.calculateServiceAmount();
  };
  initModuleButtons = () => {

    let invoiceData = this.state.invoiceData;

    if (invoiceData.invoiceStatus == LogicConstants.INVOICE_UNAPPROVE_STATUS) {
      this.setState({
        isShowCancelButton: false,
        isDisableFields: false,
        isShowSaveButton: true,
        isShowApproveButton: true,
        isShowUnApproveButton: false,
        isShowPayButton: false,
        isShowCancelButton: true,
        isShowCommInvButton: true,
        isShowPrintNaftaButton: true,
        // isShowMailInvoiceButton: true,
        isTarrifDisable: true,
        isDisableAddLine: false,
        isDisabledFields: false,
      });
    } else if (
      invoiceData.invoiceStatus == LogicConstants.INVOICE_APPROVE_STATUS
    ) {
      this.setState({
        isDisableFields: true,
        isShowSaveButton: true,
        isShowApproveButton: false,
        isShowUnApproveButton: true,
        isShowPayButton: true,
        isShowCancelButton: true,
        isShowModifyButton: true,
        isShowCommInvButton: true,
        isShowPrintNaftaButton: true,
        isShowModifyCommentButton: true,
        // isShowMailInvoiceButton: true,
        isTarrifDisable: false,
        isDisableAddLine: true,
        // isDisabledFields: false,
      });
    } else if (
      invoiceData.invoiceStatus == LogicConstants.INVOICE_PARTIALLY_PAID_STATUS
    ) {
      this.setState({
        isShowSaveButton: true,
        isShowBackButton: true,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowPayButton: true,
        isShowCancelButton: false,
        isShowGenerateSalesCommButton: true,
        isShowModifyButton: true,
        isShowCommInvButton: true,
        isShowPrintNaftaButton: true,
        isShowModifyCommentButton: true,
        // isShowMailInvoiceButton: true,
        isTarrifDisable: false,
        isDisableAddLine: true,
        isDisableFields: true,
        isDisabledFields: false,
      });
    } else if (
      invoiceData.invoiceStatus == LogicConstants.INVOICE_PAID_STATUS
    ) {
      this.setState({
        isShowBackButton: true,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowPayButton: false,
        isShowCancelButton: false,
        isShowModifyButton: true,
        isShowCommInvButton: true,
        isShowPrintNaftaButton: true,
        isShowModifyCommentButton: true,
        // isShowMailInvoiceButton: true,
        isShowGenerateSalesCommButton: true,
        isTarrifDisable: false,
        isDisableAddLine: true,
        isDisabledFields: false,
        isDisableFields: true,
      });
    } else if (
      invoiceData.invoiceStatus == LogicConstants.INVOICE_CANCEL_STATUS
    ) {
      this.setState({
        isShowSaveButton: false,
        isShowBackButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowPayButton: false,
        isShowCancelButton: false,
        isTarrifDisable: true,
        isDisableAddLine: true,
        isDisabledFields: true,
        isDisableFields: true,
      });
    }

    if (this.isModifyPosible == true) {
      this.setState({
        isShowSaveButton: true,
      });
    }
    if (
      invoiceData.code == NEW_ENTRY ||
      this.state.moduleKeyCode == NEW_ENTRY
    ) {
      this.setState({
        // isShowSaveButton: false,
        isShowCancelButton: false,
        // isDisableFields: true,
        // isDisabledFields: true,
      });
    }
    if (this.state.isViewMode) {
      this.setState({
        disabled: true,
        isTarrifDisable: true,
        isDisableAddLine: true,
        isDisabledFields: true,
        isDisableFields: true,
      });
    }
  };

  /* close Invoice entry form*/

  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.state.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      sShowCancelButton: false,
      isShowPayButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,

      errorList: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isShowGenerateSalesCommButton: false,
      isShowModifyButton: false,
      isShowCommInvButton: false,
      isShowPrintNaftaButton: false,
      isShowModifyCommentButton: false,
      isShowMailInvoiceButton: false,
      isMaintenanceMode: false,
      isResetView: false,
      disabled: false,
      showAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipToList: false,
      shipToPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: [],
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: [],
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: [],

      showAutoCompleteSalesPersonList: false,
      salesPersonPageListForAutoCompleteList: [],
      invoiceData: new InvoiceBean(),
      isDisableAddLine: true,
      isDisabledFields: false,
      showAutoCompletePaymentTermList: false,
      paymentTermPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisableFields: false,
      customerCreditCards:[],
      isShowPopupAlert: false,
    });
  };
  //#endregion

  //#region Module

  startProgressBar = () => {
    this.setState({ isLoading: true });
  };

  stopProgressBar = () => {
    this.setState({ isLoading: false });
  };
  moduleExit = () => {
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unLockInvoice(this.state.invoiceData.code);
    } else {
      this.isLocked = false;
    }
    this.props.onModuleExit();
  };

  clearError = () => {
    this.clearErrors();
  };

  back = () => {
    if (this.state.invoiceListUpdateNeeded) {
      this.loadPage(1);
    }
    this.closeEntryForm();
  };

  save = () => {
    this.saveInvoice();
  };
  approveInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleApproveResponse(response.data);

    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.invoice)
      ) {
        let invoiceBean = response.data.mainOperationResponse.invoice;
        if (invoiceBean != null) {
          this.setState({
            invoiceData: invoiceBean,
          });
          if (this.isLocked) {
            this.code = invoiceBean.code;
            this.unLockInvoice(invoiceBean.code);
          }
          /**** For Future Use */
          // else {
          //   this.editInvoice(invoiceBean.code);
          // }
        }
      }
    }
  };
  approveInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  approveInvoice = () => {
    this.setState({
      isLoading: true,
      loadingText: "Approving Invoice",
    });
    let invoiceData = this.state.invoiceData;
    let input = new RestInvoiceRequest();
    input.invoiceBean = invoiceData;
    input.isLockRequired = false; //ToDo need to Change
    if (invoiceData.isFetched) {
      if (SecurityAccessManager.InvoiceMaintenanceEdit_IsAccessible()) {
        InvoiceService.updateAndApproveInvoice(
          input,
          this.approveInvoiceResponse,
          this.approveInvoiceError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };


  hideAlertCallBackLvl6 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl6: isDisplayed });
  };

  closeAlertModalCallBackLvl6 = (isShowPopup) => {
    this.setState({
      isShowCopyInvoicePopup: isShowPopup,
      copyInvoiceNumber: "",
    });
  };
  copyInvoice = () => {
    this.setState({
      isShowCopyInvoicePopup: true,
      copyInvoiceNumber: "",
    });
  };

  modifyInvoice = () => {
    this.setState({
      isShowModifyPopup: true,
    });
  };
  printNafta = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Report",
    });
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let invoiceData = this.state.invoiceData;
    let request = new CertificateOfOriginInvoicePrintRequest();
    request.companyCode = this.companyCode;
    request.invoiceNumber = invoiceData.code;
    request.isDirectPrint = true;
    request.reportBean = reportBean;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.generateCertificateOfOriginInvoicePrintReport(
        request,
        this.printNaftaResponse,
        this.printNaftaError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  printNaftaResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    // if (response.data.reportResult != null) {
    //   let reportFilePath = response.data.reportResult.reportFileID;
    //   window.open(this.report_url + reportFilePath);
    // }
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  printNaftaError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  commInv = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Report",
    });
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let invoiceData = this.state.invoiceData;
    let request = new CommercialInvoicePrintRequest();
    request.companyCode = this.companyCode;
    request.invoiceNumber = invoiceData.code;
    request.isDirectPrint = true;
    request.reportBean = reportBean;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.generateCommercialInvoicePrintReport(
        request,
        this.commInvResponse,
        this.commInvError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  commInvResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    // let reportFilePath = response.data.reportResult.reportFileID;
    // window.open(this.report_url + reportFilePath);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  commInvError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  generateSalesComm = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Sales Commission",
    });
    let invoiceData = this.state.invoiceData;
    if (
      SecurityAccessManager.InvoiceMaintenanceSalesPersonUpdate_IsAccessible()
    ) {
      InvoiceService.updateSalesPersonToInvoice(
        invoiceData,
        this.generateSalesCommResponse,
        this.generateSalesCommError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateSalesCommResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (response.data != null && response.data.invoice != null) {
        let invoiceBean = response.data.invoice;
        this.setState({
          invoiceData: invoiceBean,
        });
        if (this.isLocked) {
          this.code = invoiceBean.code;
          this.unLockInvoice(invoiceBean.code);
        }
      }
    }
  };
  generateSalesCommError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  modifyComment = () => {
    this.setState({
      isShowModifyCommentPopup: true,
    });
  };
  mailInvoice = () => {
    let invoiceData = this.state.invoiceData;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = invoiceData.code;
    this.setState({
      isLoading: true,
      loadingText: "Fetching Mail",
    });
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      InvoiceService.fetchInvoiceMailCustomerDefaultInfoBean(
        request,
        this.mailInvoiceResponse,
        this.mailInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  mailInvoiceResponse = (response) => {
    let mailInfo = response.data.mailDefaultInfo;
    this.setState({
      mailInfoData: mailInfo,
      isShowMailInvoicePopup: true,
      isLoading: false,
      loadingText: "",
    });
  };
  mailInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  payInvoice = () => {
    // if (!isEmpty(this.state.arData)) {
    // let arData = this.state.arData;
    // let invoiceData = this.state.invoiceData;

    // let  ar_data = new AccountReceivableBean();
    const invoice_data = { ...this.state.invoiceData };
    let ar_data = this.initDefaultARValues(invoice_data);

    if (isEmptyString(ar_data.paymentTypeCode))
      ar_data.paymentTypeCode = CHECK_PAYMENT_TYPE;

    let createdDate = new Date();
    createdDate = createdDate.toLocaleDateString("sv-SE");
    const grantTotalAmount = invoice_data.grandTotalAmount;
    const postedPaidAmount = invoice_data.netPaidAmount;
    const unPostedPaidAmount =
      invoice_data.provisionalChargeBackAmount +
      invoice_data.provisionalOtherAppliedAmount +
      invoice_data.provisionalCreditMemoAmount;

    const openInvoiceAmount =
      grantTotalAmount - (postedPaidAmount + unPostedPaidAmount);
    const checkDetail = new AccountReceivableCheckDetailBean();
    checkDetail.companyCode = this.companyCode;
    checkDetail.checkAmount = parseFloat(openInvoiceAmount).toFixed(2);
    checkDetail.checkDate = createdDate;
    checkDetail.currencyCode = ar_data.companyCurrencyCode;
    ar_data.checkAmount = parseFloat(openInvoiceAmount).toFixed(2);

    const cardDetail = new AccountReceivableCardDetailBean();
    cardDetail.companyCode = this.companyCode;
    cardDetail.currencyCode = ar_data.companyCurrencyCode;

    const wireTransferDetail = new AccountReceivableWireTransferDetailBean();
    wireTransferDetail.companyCode = this.companyCode;

    this.setState({
      arData: ar_data,
      isCheckPayment: true,
      isCardPayment: false,
      isCashPayment: false,
      isWirePayment: false,
      isAchPayment: false,
      checkDetail: checkDetail,
      cardDetail: cardDetail,
      wireTransferDetail: wireTransferDetail,
      isShowPaymentPopup: true,
    });
  };

  payInvoice_old = () => {
    if (!isEmpty(this.state.arData)) {
      let arData = this.state.arData;
      let invoiceData = this.state.invoiceData;
      if (isEmptyString(this.state.arData.paymentTypeCode))
        arData.paymentTypeCode = "Check";

      let isCheckPayment = true;
      arData = this.initDefaultARValues(this.state.invoiceData);
      let createdDate = new Date();
      createdDate = createdDate.toLocaleDateString("sv-SE");
      let grantTotalAmount = invoiceData.grandTotalAmount;
      let postedPaidAmount = invoiceData.netPaidAmount;
      let unPostedPaidAmount =
        invoiceData.provisionalChargeBackAmount +
        invoiceData.provisionalOtherAppliedAmount +
        invoiceData.provisionalCreditMemoAmount;

      let openInvoiceAmount =
        grantTotalAmount - (postedPaidAmount + unPostedPaidAmount);

      let checkDetail = new AccountReceivableCheckDetailBean();
      checkDetail.companyCode = this.companyCode;
      checkDetail.checkAmount = parseFloat(openInvoiceAmount).toFixed(2);
      checkDetail.checkDate = createdDate;
      checkDetail.currencyCode = arData.companyCurrencyCode;
      arData.checkAmount = parseFloat(openInvoiceAmount).toFixed(2);

      let cardDetail = new AccountReceivableCardDetailBean();
      cardDetail.companyCode = this.companyCode;
      // //cardDetail.cardAmount = parseFloat(openInvoiceAmount).toFixed(2);
      let wireTransferDetail = new AccountReceivableWireTransferDetailBean();
      // wireTransferDetail.currencyCode = invoiceData.invoiceCurrencyCode;
      wireTransferDetail.companyCode = this.companyCode;
      // wireTransferDetail.wireTransferAmount =
      //   parseFloat(openInvoiceAmount).toFixed(2);
      // wireTransferDetail.wireTransferDate = createdDate;
      // arData.wireTransferAmount = parseFloat(openInvoiceAmount).toFixed(2);

      this.setState({
        arData: arData,
        isCheckPayment: isCheckPayment,
        checkDetail: checkDetail,
        cardDetail: cardDetail,
        wireTransferDetail: wireTransferDetail,
      });
    }
    if (!isEmpty(this.state.isShowPaymentPopup)) {
      //this.paymentDialogRef.current.show();
      let arData = this.state.arData;
      if (isEmptyString(arData.paymentTypeCode))
        arData.paymentTypeCode = "Check";
      this.setState({ isShowPaymentPopup: true });
    }
  };
  onPayClick = (e) => {
    if (e.detail == 1) {
      let isValid = false;
      isValid = this.isValidatetoPay();
       let arData = this.state.arData;
      let totalCostAmount = 0;
      totalCostAmount =
        (parseFloat(arData.cardAmount) || 0) +
        (parseFloat(arData.checkAmount) || 0) +
        (parseFloat(arData.cashAmount) || 0) +
        (parseFloat(arData.wireTransferAmount) || 0) +
        (parseFloat(arData.autoClearingHouseAmount) || 0);
      let _tempCardDetail = this.state.cardDetail;
      // console.log("arData.. onPayclick", arData);
      if (isValid) {      
        arData.companyCode = this.state.invoiceData.companyCode;
        arData.customerCode = this.state.invoiceData.customerCode;
        arData.customerName = this.state.invoiceData.customerName;
        arData.cardDetailLines = [];
        arData.checkDetailLines = [];
        arData.wireTransferDetailLines = [];
        if (arData.cardAmount != null && arData.cardAmount > 0) {
          let cardDetail = new AccountReceivableCardDetailBean();
          cardDetail.companyCode = this.companyCode;
          cardDetail.cardType = _tempCardDetail.cardType;
          cardDetail.cardAmount = _tempCardDetail.cardAmount;
          cardDetail.currencyCode = _tempCardDetail.currencyCode;
          cardDetail.expiryMonth = _tempCardDetail.expiryMonth;
          cardDetail.expiryYear = _tempCardDetail.expiryYear;
          cardDetail.isPaymentProcessRequired =
            _tempCardDetail.isPaymentProcessRequired;
          cardDetail.isDebitCard = _tempCardDetail.isDebitCard;

          // console.log("_tempCardDetail.cardNumber", _tempCardDetail.cardNumber);

          if (!isEmptyArray(this.state.customerCreditCards)) {


            const selectedCard = this.state.customerCreditCards.find(
              (card) =>
                `************ ${card.cardNumber.slice(-4)}` ===
                _tempCardDetail.cardNumber,
            );
            cardDetail.cardNumber = selectedCard.cardNumber;
            // console.log("selectedCard", selectedCard);

          }

          else {
            cardDetail.cardNumber = _tempCardDetail.cardNumber;
          }
          arData.cardDetailLines.push(cardDetail);
        }
        if (arData.checkAmount != null && arData.checkAmount > 0) {
          let checkDetail = this.state.checkDetail;
          arData.checkDetailLines.push(checkDetail);
        }
        if (
          arData.wireTransferAmount != null &&
          arData.wireTransferAmount > 0
        ) {
          let wireTransferDetail = this.state.wireTransferDetail;
          arData.wireTransferDetailLines.push(wireTransferDetail);
        }
        this.setState({ arData: arData });
        // console.log("arData.. onPayclick", arData);

        let isSupressSalesOrderCostPrice = ConfigManager.isSupressSalesOrderCostPriceValidation();
        // console.log("isSupressSalesOrderCostPrice", isSupressSalesOrderCostPrice);
        // console.log("totalCostAmount", totalCostAmount);

        if (isSupressSalesOrderCostPrice && totalCostAmount === 0) {
          // console.log("zero called");
          this.handleSalesInvoiceWithZeroPaymentDetails(
            this.state.invoiceData           
          );
        } else {
          // console.log("save and pay called");
          this.saveandPayInvoice(this.state.invoiceData, arData);
        }
        
      }
    }
  };
  closePaymentDialog = () => {
    if (!isEmpty(this.state.isShowPaymentPopup)) {
      this.setState({
        isShowPaymentPopup: false,
        isCardPayment: false,
        isCheckPayment: false,
        isCashPayment: false,
        isWirePayment: false,
        isAchPayment: false,
        isShowPopupAlert:false
      });
    }
  };
  saveandPayInvoiceResponse = (response) => {
    // console.log("saveandPayInvoiceResponse", response);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handlePayInvoiceResponse(response.data);
    this.handlePopupResponse(response.data);
    if (isSuccess) {
      this.setState({
        isLoading: true,
        loadingText: "Reading..",
      });
      // if (!this.isLocked) {
      //   this.editInvoice(this.state.invoiceData.code);
      // } else {
      // this.code = this.state.invoiceData.code;
      // this.unLockInvoice(this.code);
      // }
      // this.unLockInvoice(this.state.invoiceData.code, false);
      this.setTimeToRead();
    }
    this.closePaymentDialog();
  };
  setTimeToRead = () => {
    setTimeout(() => {
      if (this.isLocked) {
        this.code = this.state.invoiceData.code;
        this.unLockInvoice(this.code);
      }
    }, 500);
  };
  saveandPayInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
    payInvoiceForZeroCostResponse = (response) => {
    // console.log("payInvoiceForZeroCostResponse", response);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handlePayInvoiceResponse(response.data);
    this.handlePopupResponse(response.data);
    if (isSuccess) {
      this.setState({
        isLoading: true,
        loadingText: "Reading..",
      });
      
      this.setTimeToRead();
    }
    this.closePaymentDialog();
  };
  handleSalesInvoiceWithZeroPaymentDetails = (invoicedata)=>{
   this.setState({
      isLoading: true,
      loadingText: "Sales Invoice With Zero Payment",
    });
     let inputRequest = new RestInvoiceRequest();
     inputRequest.invoiceBean = invoicedata;
     inputRequest.isLockRequired = false;
    //  console.log("inputRequest for payInvoiceForZeroCost", inputRequest);
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
    InvoiceService.payInvoiceForZeroCost(
      inputRequest,
      this.payInvoiceForZeroCostResponse,
      this.errorCallBack
    );
    }else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
  }

  saveandPayInvoice = (invoicedata, ardata) => {
    this.setState({
      isLoading: true,
      loadingText: "Save and Pay Invoice",
    });
    let invoiceData = invoicedata;
    let arData = this.preprocessSaveAR(invoicedata, ardata);

    // console.log("arData.. before save and pay", arData);
    if (invoiceData.isFetched) {
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        AccountReceivableService.createAndApproveAccountReceivableForInvoicePayment(
          arData,
          this.saveandPayInvoiceResponse,
          this.saveandPayInvoiceError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  isValidatetoPay = () => {
    let isValid = true;
    let err_list = [];
    let grandTotalAmount = 0;
    grandTotalAmount = this.state.invoiceData.grandTotalAmount;
    let netPaidAmount = 0;
    netPaidAmount = this.state.invoiceData.netPaidAmount;
    let openAmount = 0;
    openAmount = grandTotalAmount - netPaidAmount;
    let totalARAmount = 0;

    let arData = this.state.arData;
    // console.log("arData.. validation", arData);
    if (
      arData.cardAmount != null &&
      arData.cardAmount > 0 &&
      arData.cardAmount != undefined
    ) {
      totalARAmount = totalARAmount + parseFloat(arData.cardAmount).toFixed(2);
      if (isEmptyString(this.state.cardDetail.cardNumber)) {
        let errMsg = " CardNumber is Required ";
        err_list.push(errMsg);
      }
    }
    if (
      arData.checkAmount != null &&
      arData.checkAmount > 0 &&
      arData.checkAmount != undefined
    ) {
      totalARAmount = totalARAmount + parseFloat(arData.checkAmount).toFixed(2);
      if (isEmptyString(this.state.checkDetail.checkNumber)) {
        let errMsg = " checkNumber is Required ";
        err_list.push(errMsg);
      }
    }
    if (
      arData.cashAmount != null &&
      arData.cashAmount > 0 &&
      arData.cashAmount != undefined
    ) {
      totalARAmount = totalARAmount + parseFloat(arData.cashAmount).toFixed(2);
    }
    if (
      arData.wireTransferAmount &&
      arData.wireTransferAmount > 0 &&
      arData.wireTransferAmount != undefined
    ) {
      totalARAmount =
        totalARAmount + parseFloat(arData.wireTransferAmount).toFixed(2);
      if (
        isEmptyString(this.state.wireTransferDetail.wireTransferReferenceNumber)
      ) {
        let errMsg = " WireTransfer Ref is Required ";
        err_list.push(errMsg);
      }
    }
    if (totalARAmount == 0) {   
      // let errMsg = "Applied Amount Required";
      // err_list.push(errMsg);
    } else if (totalARAmount > 0 && totalARAmount > openAmount) {
      let errMsg =
        " Invalid Applied Amount ,Applied Amount Exceeds " +
        this.state.moduleCaption +
        " Amount";
      err_list.push(errMsg);
    }
    this.setState({ error_list: err_list });
    if (err_list.length > 0) {
      //ShowError(errorMessage);

      isValid = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowPopupAlert: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }
    return isValid;
    // if (err_list.length > 0) isValid = false;
    // return isValid;
  };

  initDefaultARValues(invoiceData) {
    let arBean = new AccountReceivableBean();
    let currentDate = new Date();

    arBean.companyCode = this.companyCode;
    arBean.code = NEW_ENTRY;
    arBean.accountReceivableStatus = LogicConstants.INVOICE_OPEN_STATUS;
    arBean.createdDate = currentDate.toLocaleDateString("sv-SE");
    arBean.accountReceivableDate = currentDate.toLocaleDateString("sv-SE");
    arBean.customerCode = invoiceData.customerCode;
    arBean.customerName = invoiceData.customerName;
    arBean.billToCode = invoiceData.billToCode;
    arBean.customerCurrencyCode = invoiceData.companyCurrencyCode;
    arBean.companyCurrencyCode = invoiceData.companyCurrencyCode;
    //let arLine = this.setARLineValues(invoiceData);
    //arBean.lines.push(arLine);

    return arBean;
  }

  preprocessSaveAR = (invoicedata, ardata) => {
    let temp_ARData = null;
    if (ardata != null) {
      temp_ARData = ardata;

      temp_ARData.paymentLines = [];
      let currentDate = new Date();
      let arAmount = 0;
      if (
        temp_ARData.checkAmount != null &&
        temp_ARData.checkAmount > 0 &&
        temp_ARData.checkAmount != undefined
      ) {
        let paymentLine = new AccountReceivablePaymentDetailBean();
        paymentLine.accountReceivableNumber = ardata.code;
        paymentLine.companyCode = invoicedata.companyCode;
        paymentLine.currencyCode = invoicedata.invoiceCurrencyCode;
        paymentLine.invoiceNumber = invoicedata.code;
        paymentLine.paymentType = 1;
        paymentLine.paymentAmount = temp_ARData.checkAmount;
        paymentLine.paymentDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.paymentPostDate = currentDate.toLocaleDateString("sv-SE");
        if (
          temp_ARData.checkDetailLines != null &&
          temp_ARData.checkDetailLines.length > 0
        ) {
          let checkDetail = temp_ARData.checkDetailLines[0];
          if (checkDetail != null)
            paymentLine.documentNumber = checkDetail.cardNumber;
        }
        arAmount = arAmount + parseFloat(temp_ARData.checkAmount);
        temp_ARData.paymentLines.push(paymentLine);
      }
      if (
        temp_ARData.cardAmount != null &&
        temp_ARData.cardAmount > 0 &&
        temp_ARData.cardAmount != undefined
      ) {
        let paymentLine = new AccountReceivablePaymentDetailBean();
        paymentLine.accountReceivableNumber = ardata.code;
        paymentLine.companyCode = invoicedata.companyCode;
        paymentLine.currencyCode = invoicedata.invoiceCurrencyCode;
        paymentLine.invoiceNumber = invoicedata.code;
        paymentLine.paymentType = 3;
        paymentLine.paymentAmount = temp_ARData.cardAmount;
        paymentLine.paymentDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.paymentPostDate = currentDate.toLocaleDateString("sv-SE");
        if (
          temp_ARData.cardDetailLines != null &&
          temp_ARData.cardDetailLines.length > 0
        ) {
          let cardDetail = temp_ARData.cardDetailLines[0];
          if (cardDetail != null) {
            paymentLine.documentNumber = cardDetail.cardNumber;
            if (
              cardDetail.isDebitCard != undefined &&
              cardDetail.isDebitCard == true
            ) {
              paymentLine.paymentType = 4;
            }
          }
        }
        arAmount = arAmount + parseFloat(temp_ARData.cardAmount);
        temp_ARData.paymentLines.push(paymentLine);
      }
      if (
        temp_ARData.cashAmount != null &&
        temp_ARData.cashAmount > 0 &&
        temp_ARData.cashAmount != undefined
      ) {
        let paymentLine = new AccountReceivablePaymentDetailBean();
        paymentLine.accountReceivableNumber = ardata.code;
        paymentLine.companyCode = invoicedata.companyCode;
        paymentLine.currencyCode = invoicedata.invoiceCurrencyCode;
        paymentLine.paymentType = 5;
        paymentLine.invoiceNumber = invoicedata.code;
        paymentLine.paymentAmount = temp_ARData.cardAmount;
        paymentLine.paymentDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.paymentPostDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.documentNumber = "CASH";
        arAmount = arAmount + parseFloat(temp_ARData.cashAmount);
        temp_ARData.paymentLines.push(paymentLine);
      }
      if (
        temp_ARData.wireTransferAmount != null &&
        temp_ARData.wireTransferAmount > 0 &&
        temp_ARData.wireTransferAmount != undefined
      ) {
        let paymentLine = new AccountReceivablePaymentDetailBean();
        paymentLine.accountReceivableNumber = ardata.code;
        paymentLine.companyCode = invoicedata.companyCode;
        paymentLine.currencyCode = invoicedata.invoiceCurrencyCode;
        paymentLine.paymentType = 6;
        paymentLine.invoiceNumber = invoicedata.code;
        paymentLine.paymentAmount = temp_ARData.wireTransferAmount;
        paymentLine.paymentDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.paymentPostDate = currentDate.toLocaleDateString("sv-SE");
        paymentLine.documentNumber = "WIRETRANSFER";
        arAmount = arAmount + parseFloat(temp_ARData.wireTransferAmount);
        temp_ARData.paymentLines.push(paymentLine);
      }

      let newARLine = new AccountReceivableLineBean();

      newARLine.companyCode = this.companyCode;
      newARLine.accountReceivableNumber = NEW_ENTRY;
      newARLine.invoiceNumber = invoicedata.code;
      newARLine.customerCode = invoicedata.customerCode;
      newARLine.invoiceDate = invoicedata.invoiceDate;
      newARLine.customerPurchaseOrderNumber =
        invoicedata.customerPurchaseOrderNumber;
      newARLine.openInvoiceAmount = invoicedata.grandTotalAmount;
      newARLine.currencyCode = invoicedata.companyCurrencyCode;
      newARLine.appliedAmount = arAmount;
      newARLine.totalAppliedAmount = arAmount;

      temp_ARData.lines.push(newARLine);
    }
    return temp_ARData;
  };
  _executeAfterPaymentDialogClose = (e) => { };

  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unApproveReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unApproveReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unApproveReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApproveInvoice = () => {
    this.openReasonCapture(2);
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApproveInvoice();
    this.closeReasonModelCallBack();
  };

  saveUnApproveInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (!isEmpty(response.data) && !isEmpty(response.data.invoice)) {
        let invData = response.data.invoice;
        this.setState({
          invoiceData: invData,
        });
        if (this.isLocked) {
          this.code = invData.code;
          this.unLockInvoice(invData.code);
        }
      }
    }
  };
  saveUnApproveInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Errors : " + error);
  };
  saveUnApproveInvoice = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving Invoice",
    });
    let ptData = this.state.invoiceData;
    let input = new RestInvoiceRequest();
    input.invoiceBean = ptData;
    input.reason = this.state.reasonData;
    input.companyCode = this.companyCode;
    input.code = ptData.code;
    if (SecurityAccessManager.InvoiceMaintenanceUnApprove_IsAccessible()) {
      InvoiceService.unApproveInvoice(
        input,
        this.saveUnApproveInvoiceResponse,
        this.saveUnApproveInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  cancelInvoice = () => {
    this.openReasonCapture(1);
  };

  onCancelReasonContinue = () => {
    this.saveCancelInvoice();
    this.closeReasonModelCallBack();
  };

  saveCancelInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);

    if (isSuccess) {
      if (!isEmpty(response.data) && !isEmpty(response.data.invoice)) {
        let invData = response.data.invoice;
        this.setState({
          invoiceData: invData,
        });
        if (this.isLocked) {
          this.code = invData.code;
          this.unLockInvoice(invData.code);
        }
      }
    }
  };
  saveCancelInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveCancelInvoice = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling Invoice",
    });
    let ptData = this.state.invoiceData;
    let input = new RestInvoiceRequest();
    input.invoiceBean = ptData;
    input.reason = this.state.reasonData;
    if (SecurityAccessManager.InvoiceMaintenanceCancel_IsAccessible()) {
      InvoiceService.cancelInvoice(
        input,
        this.saveCancelInvoiceResponse,
        this.saveCancelInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  isValidReason = () => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(this.state.reasonData)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(this.state.reasonData.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }

    //  ShowError(errorMsg);
    this.setState({ error_list: err_list });
    if (err_list.length > 0) isValid = false;

    return isValid;
  };

  generateInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  generateInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  generateInvoice = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Invoice",
    });
    let invoice = this.state.invoiceData;
    if (SecurityAccessManager.InvoiceMaintenanceCancel_IsAccessible()) {
      InvoiceService.updateInvoiceAndCreateInvoice(
        invoice,
        this.generateInvoiceResponse,
        this.generateInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  saveInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.invoice)) {
      const invoiceBean = response.data.invoice;

      if (isSuccess) {
        if (invoiceBean != null) {
          let pageTitle = this.state.moduleCaption + " - EDIT";
          //  this.state.invoiceData = invoiceBean;
          this.setState({
            invoiceData: invoiceBean,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });
          // if (this.isLocked) {
          //   this.code = invoiceBean.code;
          //   this.unLockInvoice(invoiceBean.code);
          // }
          if (this.isLocked) {
            this.code = invoiceBean.code;
            this.unLockInvoice(invoiceBean.code);
          } else {
            /********8 For Future Use */
            this.editInvoice(invoiceBean.code);
          }

          /********8 For Future Use */
          // else{
          //   this.editInvoice(invoiceBean.code);
          // }

          // this.unLockInvoice(invoiceBean.code, false);
          // this.editInvoice(invoiceBean.code);
        }
      }
    }
  };

  saveInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  errorCallBack = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  }
  validateSalesInvoice = (invoiceData) => {
    let isValidSalesInvoiceData = false;
    let err_list = [];
    let errorMessage = "";
    if (invoiceData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(invoiceData.billToCode)) {
        let errMsg = "Invoice BillTo is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(invoiceData.customerCode)) {
        let errMsg = "Customer Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(invoiceData.customerName)) {
        let errMsg = "Customer Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(invoiceData.shipToCode) && !this.state.is3PL) {
        let errMsg = "Invoice ShipTo Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (this.state.is3PL) {
        if (
          isEmptyArray(invoiceData.lines) &&
          isEmptyArray(invoiceData.serviceLines)
        ) {
          let errMsg = "Invoice / service Lines Required";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      } else {
        if (isEmptyArray(invoiceData.lines)) {
          let errMsg = "Invoice Lines Required";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      }

      if (isEmptyString(invoiceData.paymentTermCode)) {
        let errMsg = "PaymentTerm is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidSalesInvoiceData = false;

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidSalesInvoiceData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidSalesInvoiceData;
  };
  saveInvoice = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let invoiceData = { ...this.state.invoiceData };
    let isValidData = false;
    isValidData = this.validateSalesInvoice(invoiceData);
    if (isValidData) {
      if (invoiceData.isFetched) {
        if (
          invoiceData.invoiceStatus == LogicConstants.INVOICE_UNAPPROVE_STATUS
        ) {
          if (SecurityAccessManager.InvoiceMaintenanceEdit_IsAccessible()) {
            InvoiceService.updateInvoice(
              invoiceData,
              this.saveInvoiceResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else if (
          invoiceData.invoiceStatus == LogicConstants.INVOICE_APPROVE_STATUS ||
          invoiceData.invoiceStatus ==
          LogicConstants.INVOICE_PARTIALLY_PAID_STATUS ||
          invoiceData.invoiceStatus == LogicConstants.INVOICE_PAID_STATUS
        ) {
          if (SecurityAccessManager.InvoiceMaintenanceEdit_IsAccessible()) {
            InvoiceService.updateInvoiceAfterApproval(
              invoiceData,
              this.saveInvoiceResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      }
    }
  };

  generatePDFResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    // if (response.data != null && response.data.reportResult != null) {
    //   let reportFilePath = response.data.reportResult.reportFileID;
    //   if (reportFilePath != null) {
    //     window.open(this.report_url + reportFilePath);
    //   }
    // }
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generatePDFError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    let invData = this.state.invoiceData;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let requestInput = new RestPrintInputRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = invData.code;
    requestInput.report = reportBean;
    if (SecurityAccessManager.InvoiceMaintenancePDFReport_IsAccessible()) {
      ReportService.generateInvoicePrintReport(
        requestInput,
        this.generatePDFResponse,
        this.generatePDFError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  clearErrors = () => {
    let errList = [];

    this.setState({ errorList: errList });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handlePayInvoiceResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });

      this.setState({ errorList: errList });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg =
        "Payment Process Completed SuccessFully ! Kindly Wait For Some Time To Update In Invoice";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + "" + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });

      this.setState({ errorList: errList });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handlePopupResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowPopupAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleErrorResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });

      this.setState({ errorList: errList });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (
      !isEmpty(response.additionalOperationResponse) ||
      response.additionalOperationResponse != null
    ) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    return success;
  };

  handleInvoiceResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.invoiceResponse)) {
      if (!isEmptyArray(response.invoiceResponse.errors)) {
        response.invoiceResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.invoiceResponse.infos)) {
        response.invoiceResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmpty(response.invoicePrintReportResponse)) {
      if (!isEmptyArray(response.invoicePrintReportResponse.errors)) {
        response.invoicePrintReportResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.invoicePrintReportResponse.infos)) {
        response.invoicePrintReportResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  //#endregion
  //#region Node Details
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", emptyObject);
    let invData = this.state.invoiceData;
    let changesHistoryNode = new NodeData(
      "changesHistoryView",
      "ChangesHistory",
      emptyObject
    );
    let shippingInformationNode = new NodeData(
      "shippingInformationView",
      "ShippingInfo",
      emptyObject
    );
    let PaymentDetailsNode = new NodeData(
      "paymentDetailsView",
      "PaymentDetails",
      emptyObject
    );
    let PaymentHistoryNode = new NodeData(
      "paymentHistoryView",
      "PaymentHistory",
      emptyObject
    );
    let CommissionNode = new NodeData(
      "commissionView",
      "Commission",
      emptyObject
    );
    let ServiceDetailsNode = new NodeData(
      "serviceDetailsView",
      "Service Details",
      emptyObject
    );
    nodeList["headerView"] = headerNode;
    if (invData.isFetched) {
      nodeList["shippingInformationView"] = shippingInformationNode;
      nodeList["paymentDetailsView"] = PaymentDetailsNode;
      nodeList["paymentHistoryView"] = PaymentHistoryNode;
      nodeList["commissionView"] = CommissionNode;
      nodeList["changesHistoryView"] = changesHistoryNode;
      if (this.state.is3PL) {
        nodeList["serviceDetailsView"] = ServiceDetailsNode;
      }
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setInvoiceHeaderView();
    } else if (selectedNode == "paymentDetailsView") {
      this.setPaymentDetailsView();
    } else if (selectedNode == "shippingInformationView") {
      this.setShippingInformationView();
    } else if (selectedNode == "changesHistoryView") {
      this.setChangesHistoryView();
    } else if (selectedNode == "paymentHistoryView") {
      this.setPaymentHistoryView();
    } else if (selectedNode == "commissionView") {
      this.setCommissionView();
    } else if (selectedNode == "serviceDetailsView") {
      this.setServiceView();
    }
  };

  setInvoiceHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isShowBackButton: true,
      isEntryFormOpen: true,
    });
  };

  setPaymentDetailsView = () => {
    this.closeAllNodeViews();
    this.getandSetPaymentDetails();
    this.setState({
      isPaymentDetailsFormOpened: true,
      isShowBackButton: true,
    });
  };
  setPaymentHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isPaymentHistoryFormOpened: true,
      isShowBackButton: true,
    });
  };
  setCommissionView = () => {
    this.closeAllNodeViews();
    this.setState({
      isCommissionFormOpened: true,
      isShowBackButton: true,
    });
  };
  setShippingInformationView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShippingInformationFormOpened: true,
      isShowBackButton: true,
    });
  };
  setChangesHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isChangesHistoryFormOpened: true,
      isShowBackButton: true,
    });
  };
  setServiceView = () => {
    this.closeAllNodeViews();
    this.setState({
      isServiceFormOpened: true,
      isShowBackButton: true,
    });
  };

  closeAllNodeViews = () => {
    this.setState({
      isEntryFormOpen: false,
      isListFormOpen: false,
      isShippingInformationFormOpened: false,
      isPaymentDetailsFormOpened: false,
      isChangesHistoryFormOpened: false,
      isPaymentHistoryFormOpened: false,
      isCommissionFormOpened: false,
      isServiceFormOpened: false,
    });
  };

  getandSetPaymentDetailsResponse = (response) => {
    //  console.log("response..",response);
    this.setState({ isLoading: false });
    let isSuccess = this.handleErrorResponse(response.data);
    let invoiceData = this.state.invoiceData;
    if (
      !isEmpty(response.data.accountReceivablePaymentDetailPageList) &&
      !isEmptyArray(
        response.data.accountReceivablePaymentDetailPageList
          .accountReceivablePaymentDetails
      ) &&
      isSuccess
    ) {
      let accountReceivablePaymentDetails = [];
      accountReceivablePaymentDetails =
        response.data.accountReceivablePaymentDetailPageList
          .accountReceivablePaymentDetails;
      let arList = [];
      if (
        invoiceData.invoiceStatus === LogicConstants.INVOICE_PAID_STATUS ||
        invoiceData.invoiceStatus ===
        LogicConstants.INVOICE_PARTIALLY_PAID_STATUS
      ) {
        for (let list of accountReceivablePaymentDetails) {
          if (list.cancelled != true) {
            arList.push(list);
          }
        }
        this.setState({
          accountReceivablePaymentDetails: arList,
        });
      }
    }
  };
  getandSetPaymentDetailsError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  getandSetPaymentDetails = () => {
    this.setState({ isLoading: true });
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = this.state.invoiceData.code;
   
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
        input,
        this.getandSetPaymentDetailsResponse,
        this.getandSetPaymentDetailsError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  //#endregion
  // loadRollLines = () => {
  //   const skuBatchInventories = [...this.state.skuBatchInventories];
  //   const invoiceLineData = { ...this.state.invoiceLineData };
  //   let roll_lines = new Array();
  //   roll_lines = [...invoiceLineData.rollLines];
  //   let existingRollLine = {};
  //   if (!isEmptyArray(skuBatchInventories)) {
  //     skuBatchInventories.map((inv) => {
  //       if (!inv.isPickedFlag && inv.onHandQuantity != 0) {
  //         if (
  //           !isEmpty(invoiceLineData) &&
  //           !isEmptyArray(invoiceLineData.rollLines)
  //         ) {
  //           invoiceLineData.rollLines.map((line) => {
  //             if (
  //               line.rollSkuNumber == inv.rollSkuNumber &&
  //               line.locationCode == inv.locationCode
  //             ) {

  //               // line.availableQuantity = inv.onHandQuantity;
  //               // line.binLocation = inv.aisleInfoText;
  //               // line.isApplied = line.shippedQuantity > 0;
  //               // if (isEmpty(line.shippedQuantity)) line.shippedQuantity = 0;
  //               // roll_lines.push(line);
  //               existingRollLine = line;
  //             } else {

  //               // const rollLine = new InvoiceRollLineBean();
  //               // rollLine.invoiceRollLineNumber =
  //               //   invoiceLineData.rollLines.length + 1;
  //               // rollLine.rollSkuNumber = inv.rollSkuNumber;
  //               // rollLine.rollNumber = inv.rollNumber;
  //               // rollLine.purchasOrderNumber = inv.purchaseOrderNumber;
  //               // rollLine.purchaseOrderReceiptNumber = inv.referenceEntityNumber;
  //               // rollLine.vendorBatchNumber = inv.vendorBatchNumber;
  //               // rollLine.boxNumber = inv.boxNumber;
  //               // rollLine.availableQuantity = inv.onHandQuantity;
  //               // rollLine.locationCode = inv.locationCode;
  //               // rollLine.invoiceUomCode = invoiceLineData.uomCode;
  //               // rollLine.inventoryUomCode = invoiceLineData.inventoryUomCode;
  //               // rollLine.uomConversionRate = invoiceLineData.uomConversionRate;
  //               // rollLine.isApplied = false;
  //               // roll_lines.push(rollLine);
  //             }
  //           });
  //           if (isEmpty(existingRollLine)) {
  //             const rollLine = new InvoiceRollLineBean();
  //             rollLine.invoiceRollLineNumber =
  //               invoiceLineData.rollLines.length + 1;
  //             rollLine.rollSkuNumber = inv.rollSkuNumber;
  //             rollLine.rollNumber = inv.rollNumber;
  //             rollLine.purchasOrderNumber = inv.purchaseOrderNumber;
  //             rollLine.purchaseOrderReceiptNumber = inv.referenceEntityNumber;
  //             rollLine.vendorBatchNumber = inv.vendorBatchNumber;
  //             rollLine.boxNumber = inv.boxNumber;
  //             rollLine.availableQuantity = inv.onHandQuantity;
  //             rollLine.locationCode = inv.locationCode;
  //             rollLine.invoiceUomCode = invoiceLineData.uomCode;
  //             rollLine.inventoryUomCode = invoiceLineData.inventoryUomCode;
  //             rollLine.uomConversionRate = invoiceLineData.uomConversionRate;
  //             rollLine.isApplied = false;
  //             roll_lines.push(rollLine);
  //           } else {
  //             existingRollLine.availableQuantity = inv.onHandQuantity;
  //             existingRollLine.binLocation = inv.aisleInfoText;
  //             existingRollLine.isApplied = existingRollLine.shippedQuantity > 0;
  //             if (isEmpty(existingRollLine.shippedQuantity))
  //               existingRollLine.shippedQuantity = 0;
  //             roll_lines.push(existingRollLine);
  //           }
  //         }
  //       }
  //     });
  //   }
  //   invoiceLineData.rollLines = roll_lines;
  //   this.setState({ invoiceLineData: invoiceLineData });
  //   this.openLineDetailsDialog();
  // };
  //#region Line Details
  // loadRollLines = () => {
  //   const skuBatchInventories = [...this.state.skuBatchInventories];
  //   const invoiceLineData = { ...this.state.invoiceLineData };

  //   const roll_lines = new Array();
  //   if (!isEmptyArray(skuBatchInventories)) {
  //     skuBatchInventories.map((inv) => {
  //       if (!inv.isPickedFlag && inv.onHandQuantity > 0) {
  //         // let existingRollLine = new InvoiceRollLineBean();
  //         if (
  //           !isEmpty(invoiceLineData) &&
  //           !isEmptyArray(invoiceLineData.rollLines)
  //         ) {
  //           invoiceLineData.rollLines.map((line) => {
  //             if (line.rollSkuNumber == inv.rollSkuNumber) {
  //               // existingRollLine = { ...line };
  //               line.availableQuantity = inv.onHandQuantity;
  //               // existingRollLine.locationCode = inv.locationCode;
  //               line.binLocation = inv.aisleInfoText;
  //               // existingRollLine.isApplied = true;
  //               line.isApplied = line.shippedQuantity > 0;
  //               if (isEmpty(line.shippedQuantity)) line.shippedQuantity = 0;
  //               // roll_lines.push(line);
  //             } else {
  //               // let invoiceRollLineNumber = 0;
  //               // // const rollLine = new InvoiceRollLineBean();
  //               // line.companyCode = invoiceLineData.companyCode;
  //               // line.invoiceNumber = invoiceLineData.invoiceNumber;
  //               // line.customerCode = invoiceLineData.customerCode;
  //               // line.customerName = invoiceLineData.customerName;
  //               // if (!isEmptyArray(invoiceLineData.rollLines))
  //               //   line.invoiceRollLineNumber =
  //               //     invoiceLineData.rollLines.length + 1;
  //               // else line.invoiceRollLineNumber = invoiceRollLineNumber++;
  //               // line.invoiceLineNumber = invoiceLineData.lineNumber;
  //               // line.sourcePickTicketNumber =
  //               //   invoiceLineData.sourcePickTicketNumber;
  //               // line.sourcePickTicketLineNumber =
  //               //   invoiceLineData.sourcePickTicketLineNumber;
  //               // line.fabricStyleCode = invoiceLineData.fabricStyleCode;
  //               // line.fabricStyleName = invoiceLineData.fabricStyleName;
  //               // line.colorCode = invoiceLineData.colorCode;
  //               // line.widthCode = invoiceLineData.widthCode;
  //               // line.skuNumber = invoiceLineData.skuNumber;
  //               // line.rollSkuNumber = inv.rollSkuNumber;
  //               // line.rollNumber = inv.rollNumber;
  //               // line.purchasOrderNumber = inv.purchaseOrderNumber;
  //               // line.purchaseOrderReceiptNumber = inv.referenceEntityNumber;
  //               // line.vendorBatchNumber = inv.vendorBatchNumber;
  //               // line.boxNumber = inv.boxNumber;
  //               // line.availableQuantity = inv.onHandQuantity;
  //               // line.locationCode = inv.locationCode;
  //               // line.invoiceUomCode = invoiceLineData.inventoryUomCode;
  //               // line.inventoryUomCode = invoiceLineData.inventoryUomCode;
  //               // line.uomConversionRate = invoiceLineData.uomConversionRate;
  //               // line.inventoryReceivedQuatity = inv.receivedQuantity;
  //               // line.isCloseOutInventory = inv.closeOutInventory;
  //               // line.binLocation = inv.aisleInfoText;
  //               // line.isApplied = false;
  //               // roll_lines.push(rollLine);
  //             }
  //           });
  //           // if (isEmpty(existingRollLine)) {
  //           //   let invoiceRollLineNumber = 0;
  //           //   const rollLine = new InvoiceRollLineBean();
  //           //   rollLine.companyCode = invoiceLineData.companyCode;
  //           //   rollLine.invoiceNumber = invoiceLineData.invoiceNumber;
  //           //   rollLine.customerCode = invoiceLineData.customerCode;
  //           //   rollLine.customerName = invoiceLineData.customerName;
  //           //   if (!isEmptyArray(invoiceLineData.rollLines))
  //           //     rollLine.invoiceRollLineNumber =
  //           //       invoiceLineData.rollLines.length + 1;
  //           //   else rollLine.invoiceRollLineNumber = invoiceRollLineNumber++;
  //           //   rollLine.invoiceLineNumber = invoiceLineData.lineNumber;
  //           //   rollLine.sourcePickTicketNumber =
  //           //     invoiceLineData.sourcePickTicketNumber;
  //           //   rollLine.sourcePickTicketLineNumber =
  //           //     invoiceLineData.sourcePickTicketLineNumber;
  //           //   rollLine.fabricStyleCode = invoiceLineData.fabricStyleCode;
  //           //   rollLine.fabricStyleName = invoiceLineData.fabricStyleName;
  //           //   rollLine.colorCode = invoiceLineData.colorCode;
  //           //   rollLine.widthCode = invoiceLineData.widthCode;
  //           //   rollLine.skuNumber = invoiceLineData.skuNumber;
  //           //   rollLine.rollSkuNumber = inv.rollSkuNumber;
  //           //   rollLine.rollNumber = inv.rollNumber;
  //           //   rollLine.purchasOrderNumber = inv.purchaseOrderNumber;
  //           //   rollLine.purchaseOrderReceiptNumber = inv.referenceEntityNumber;
  //           //   rollLine.vendorBatchNumber = inv.vendorBatchNumber;
  //           //   rollLine.boxNumber = inv.boxNumber;
  //           //   rollLine.availableQuantity = inv.onHandQuantity;
  //           //   rollLine.locationCode = inv.locationCode;
  //           //   rollLine.invoiceUomCode = invoiceLineData.inventoryUomCode;
  //           //   rollLine.inventoryUomCode = invoiceLineData.inventoryUomCode;
  //           //   rollLine.uomConversionRate = invoiceLineData.uomConversionRate;
  //           //   rollLine.inventoryReceivedQuatity = inv.receivedQuantity;
  //           //   rollLine.isCloseOutInventory = inv.closeOutInventory;
  //           //   rollLine.binLocation = inv.aisleInfoText;
  //           //   rollLine.isApplied = false;
  //           //   roll_lines.push(rollLine);
  //           // } else {

  //           // }
  //         }
  //       }
  //     });
  //   }
  //   // invoiceLineData.rollLines = roll_lines;
  //   this.setState({ invoiceLineData: invoiceLineData });
  //   this.openLineDetailsDialog();
  // };
  loadRollLines = () => {
    let skuBatchInventories = this.state.skuBatchInventories;
    let invoiceLine = this.state.invoiceLineData;
    let rollLines = [];
    if (!isEmptyArray(invoiceLine.rollLines)) rollLines = invoiceLine.rollLines;
    let invoiceRollLineNumber = 1;
    skuBatchInventories.map((inventoryRoll) => {
      if (!inventoryRoll.isPickedFlag && inventoryRoll.onHandQuantity != 0) {
        let existingRollLine = null;
        if (!isEmptyArray(invoiceLine.rollLines)) {
          invoiceLine.rollLines.map((line) => {
            if (line.rollSkuNumber == inventoryRoll.rollSkuNumber)
              existingRollLine = line;
          });
        }
        if (existingRollLine == null) {
          let rollLine = new InvoiceRollLineBean();

          if (!isEmptyArray(rollLines))
            rollLine.companyCode = invoiceLine.companyCode;
          rollLine.invoiceNumber = invoiceLine.invoiceNumber;

          rollLine.customerCode = invoiceLine.customerCode;
          rollLine.customerName = invoiceLine.customerName;

          invoiceRollLineNumber = rollLines.length + 1;
          rollLine.invoiceRollLineNumber = invoiceRollLineNumber++;
          rollLine.invoiceLineNumber = invoiceLine.lineNumber;
          rollLine.sourcePickTicketNumber = invoiceLine.sourcePickTicketNumber;
          rollLine.sourcePickTicketLineNumber =
            invoiceLine.sourcePickTicketLineNumber;
          rollLine.fabricStyleCode = invoiceLine.fabricStyleCode;
          rollLine.fabricStyleName = invoiceLine.fabricStyleName;
          rollLine.colorCode = invoiceLine.colorCode;
          rollLine.widthCode = invoiceLine.widthCode;
          rollLine.skuNumber = invoiceLine.skuNumber;

          rollLine.rollSkuNumber = inventoryRoll.rollSkuNumber;
          rollLine.rollNumber = inventoryRoll.rollNumber;
          rollLine.purchasOrderNumber = inventoryRoll.purchaseOrderNumber;
          rollLine.purchaseOrderReceiptNumber =
            inventoryRoll.referenceEntityNumber;
          rollLine.vendorBatchNumber = inventoryRoll.vendorBatchNumber;
          rollLine.vendorCode = "";
          rollLine.boxNumber = inventoryRoll.boxNumber;
          rollLine.availableQuantity = inventoryRoll.onHandQuantity;
          rollLine.locationCode = inventoryRoll.locationCode;
          rollLine.invoiceUomCode = invoiceLine.inventoryUomCode;
          rollLine.inventoryUomCode = invoiceLine.inventoryUomCode;
          rollLine.uomConversionRate = invoiceLine.uomConversionRate;
          rollLine.inventoryReceivedQuatity = inventoryRoll.receivedQuantity;
          rollLine.isCloseOutInventory = inventoryRoll.closeOutInventory;
          rollLine.binLocation = inventoryRoll.aisleInfoText;
          rollLine.shippedQuantity = 0;
          rollLine.isApplied = false;

          rollLines.push(rollLine);
        } else {
          // if (existingRollLine.pickedQuantity > 0 || existingRollLine.isFetched)
          // invoiceLine.rollLines.map((ln) => {
          //   if (ln.shippedQuantity > 0) {
          //     ln.isApplied = true;
          //   }
          //   if (
          //     ln.shippedQuantity == null ||
          //     ln.shippedQuantity == undefined
          //   ) {
          //     ln.shippedQuantity = 0;
          //   }
          // });
          // existingRollLine.availableQuantity = inventoryRoll.onHandQuantity;
          // existingRollLine.locationCode = inventoryRoll.locationCode;
          if (isEmpty(existingRollLine.shippedQuantity))
            existingRollLine.shippedQuantity = 0;
          existingRollLine.binLocation = inventoryRoll.aisleInfoText;
          existingRollLine.isApplied = existingRollLine.shippedQuantity > 0;
        }
      }
    });
    if (!isEmptyArray(rollLines)) invoiceLine.rollLines = rollLines;
    this.setState({ invoiceLineData: invoiceLine });
    this.openLineDetailsDialog();
  };
  calculateTotals() {
    let invoiceData = this.state.invoiceData;
    let grandTotalAmount = 0;
    let subTotalAmount = 0;
    // let grandTotalAmount = this.state.invoiceData.grandTotalAmount;
    // let subTotalAmount = this.state.invoiceData.subTotalAmount;
    let extraChargesAmount = 0;
    let nonMerchandiseTotalAmount = 0;
    let lineTotalTaxAmount = 0;
    let shipmentChargesAmount = 0;
    let tariffAmount = 0;
    let serviceAmount = 0;
    // let invoiceLineData = invoiceData.lines;
    // invoiceLineData.map((line) => {
    //   lineTotalTaxAmount = lineTotalTaxAmount + line.taxAmount;
    //   subTotalAmount = subTotalAmount + line.lineTotalAmount;
    // });
    // if (invoiceData.extraChargesAmount != 0) {
    //   extraChargesAmount = invoiceData.extraChargesAmount;
    // }
    // if (invoiceData.nonMerchandiseTotalAmount != 0) {
    //   nonMerchandiseTotalAmount = invoiceData.nonMerchandiseTotalAmount;
    // }
    // if (invoiceData.shipmentChargesAmount != 0) {
    //   shipmentChargesAmount = invoiceData.shipmentChargesAmount;
    // }

    // //calculate discountAmount and set subTotalAmount
    // let discountAmount = 0;
    // if (invoiceData.discountAmount != 0) {
    //   discountAmount = invoiceData.discountAmount;
    // }
    // if (invoiceData.totalServiceAmount != 0) {
    //   serviceAmount = invoiceData.totalServiceAmount;
    // }
    // grandTotalAmount =
    //   subTotalAmount -
    //   parseFloat(discountAmount) +
    //   parseFloat(extraChargesAmount) +
    //   parseFloat(nonMerchandiseTotalAmount) +
    //   lineTotalTaxAmount +
    //   parseFloat(shipmentChargesAmount) +
    //   parseFloat(tariffAmount) +
    //   parseFloat(serviceAmount);
    // invoiceData.grandTotalAmount = grandTotalAmount;
    // invoiceData.subTotalAmount = subTotalAmount;
    // invoiceData.discountAmount = discountAmount;
    // invoiceData.totalServiceAmount = serviceAmount;
    // invoiceData.standardGrandTotalAmount = invoiceData.grandTotalAmount;
    // this.setState({ invoiceData: invoiceData });

    if (!isEmpty(this.state.invoiceData)) {
      // let totMerchandiseCreditAmount = 0;
      // let totNonMerchandiseCreditAmount = 0;
      // let totTaxAmount = 0;
      let lineTotalAmount = 0;
      if (!isEmptyArray(this.state.invoiceData.lines)) {
        this.state.invoiceData.lines.map((line) => {
          lineTotalAmount = parseFloat(line.lineNetAmount) + lineTotalAmount;
          // lineTotalAmount =
          //   parseFloat(line.lineNetAmount) -
          //   parseFloat(line.lineDiscountAmount);
          lineTotalTaxAmount += parseFloat(line.taxAmount).toFixed(2);
          tariffAmount += parseFloat(line.tariffAmount).toFixed(2);
          // totMerchandiseCreditAmount =
          //   totMerchandiseCreditAmount + parseFloat(line.lineTotalAmount);
          // if (
          //   line.isTaxRequiredFlag &&
          //   line.lineStatus !== LogicConstants.CREDIT_MEMO_LINE_CANCEL_STATUS
          // )
          //   line.taxAmount = (line.lineTotalAmount * line.taxPercentage) / 100;
          // totTaxAmount = totTaxAmount + parseFloat(line.taxAmount);
        });
      }
      if (invoiceData.extraChargesAmount != 0) {
        extraChargesAmount = parseFloat(invoiceData.extraChargesAmount);
      }
      if (invoiceData.nonMerchandiseTotalAmount != 0) {
        nonMerchandiseTotalAmount = parseFloat(
          invoiceData.nonMerchandiseTotalAmount
        );
      }
      if (invoiceData.shipmentChargesAmount != 0) {
        shipmentChargesAmount = parseFloat(invoiceData.shipmentChargesAmount);
      }
      // if (invoiceData.tariffAmount != 0) {
      //   tariffAmount = parseFloat(invoiceData.tariffAmount);
      // }
      let discountAmount = 0;
      if (invoiceData.discountAmount != 0) {
        discountAmount = parseFloat(invoiceData.discountAmount);
      }
      if (invoiceData.totalServiceAmount != 0) {
        serviceAmount = parseFloat(invoiceData.totalServiceAmount);
      }
      // if (!isEmptyArray(this.state.invoiceData.nonMerchandiseLines)) {
      //   this.state.invoiceData.nonMerchandiseLines.map((line) => {
      //     totNonMerchandiseCreditAmount =
      //       totNonMerchandiseCreditAmount + parseFloat(line.lineTotalAmount);
      //   });
      // }
      // this.state.invoiceData.merchandiseCreditAmount = parseFloat(
      //   totMerchandiseCreditAmount
      // );
      // this.state.invoiceData.nonMerchandiseCreditAmount = parseFloat(
      //   totNonMerchandiseCreditAmount
      // );
      subTotalAmount =
        parseFloat(lineTotalAmount) + parseFloat(lineTotalTaxAmount);
      grandTotalAmount =
        parseFloat(subTotalAmount) -
        parseFloat(discountAmount) +
        parseFloat(extraChargesAmount) +
        parseFloat(shipmentChargesAmount) +
        parseFloat(nonMerchandiseTotalAmount) +
        parseFloat(serviceAmount) +
        parseFloat(tariffAmount);
      // if (this.state.invoiceData.isTaxRequiredFlag)
      //   totalCreditAmount =
      //     parseFloat(totalCreditAmount) + parseFloat(totTaxAmount);
      this.state.invoiceData.subTotalAmount =
        parseFloat(subTotalAmount).toFixed(2);
      this.state.invoiceData.grandTotalAmount =
        parseFloat(grandTotalAmount).toFixed(2);
      this.state.invoiceData.standardSubTotalAmount =
        parseFloat(subTotalAmount).toFixed(2);
      this.state.invoiceData.standardGrandTotalAmount =
        parseFloat(grandTotalAmount).toFixed(2);
      this.state.invoiceData.tariffAmount = parseFloat(tariffAmount).toFixed(2);
      this.state.invoiceData.extraChargesAmount =
        parseFloat(extraChargesAmount).toFixed(2);
      this.state.invoiceData.nonMerchandiseTotalAmount = parseFloat(
        nonMerchandiseTotalAmount
      ).toFixed(2);
      this.state.invoiceData.discountAmount =
        parseFloat(discountAmount).toFixed(2);
      this.state.invoiceData.totalServiceAmount =
        parseFloat(serviceAmount).toFixed(2);
      this.state.invoiceData.shipmentChargesAmount = parseFloat(
        shipmentChargesAmount
      ).toFixed(2);
    }
  }
  getMaxLineNumberInvoiceLines = () => {
    let maxLineNumber = 0;
    let invoiceData = this.state.invoiceData;
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.lines)) {
      invoiceData.lines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  clearInvoiceLine = (e) => {
    if (e.detail == 1) {
      let invoiceData = this.state.invoiceData;
      let invoiceLine = new InvoiceLineBean();
      invoiceLine.companyCode = this.companyCode;
      invoiceLine.lineNumber = NEW_ENTRY;
      invoiceLine.invoiceNumber = invoiceData.code;
      invoiceLine.customerCode = invoiceData.customerCode;
      invoiceLine.customerName = invoiceData.customerName;
      this.setState({
        invoiceLineData: invoiceLine,
        isShowPtLineLookup: false,
        isPtDisable: false,
      });
    }
  };
  updateLine = (e) => {
    if (e.detail == 1) {
      let lineData = this.state.invoiceLineData;
      let invoiceData = this.state.invoiceData;
      // invoiceData.tariffAmount = lineData.tariffAmount;
      // let tariffAmount = 0;
      // tariffAmount = invoiceData.tariffAmount + lineData.tariffAmount;
      // invoiceData.tariffAmount = tariffAmount;
      var lineNumber = this.getMaxLineNumberInvoiceLines();
      let lines = invoiceData.lines;
      if (lines == null) {
        lines = [];
      }

      lineData.lineStatus = LogicConstants.INVOICE_LINE_OPEN_STATUS;
      let isLineFound = false;
      lines.map((ln, i) => {
        if (ln.lineNumber == lineData.lineNumber) {
          lineData.lineNumber = ln.lineNumber;
          lineData.isFetched = ln.isFetched;
          lines[i] = lineData;
          isLineFound = true;
          // invoiceData.tariffAmount = lineData.tariffAmount;
        }
      });
      if (!isLineFound) {
        lineData.lineNumber = ++lineNumber;
        lines.push(lineData);
        // let tariffAmount = 0;
        // tariffAmount = invoiceData.tariffAmount + lineData.tariffAmount;
        // invoiceData.tariffAmount = tariffAmount;
      }
      invoiceData.lines = lines;
      this.setState({
        invoiceData: invoiceData,
        invoiceLineData: new InvoiceLineBean(),
        isPtDisable: true,
      });
      this.calculateTotals();
      this.closeLineDetailsDialog();
    }
  };
  openLineDetailsDialog = () => {
    this.setState({ isShowLinePopup: true, isShowPtLineLookup: false });
  };
  deleteInvoiceLine = (rowData) => {
    let invoiceData = this.state.invoiceData;
    let lines = invoiceData.lines;
    var index = lines.indexOf(rowData);
    if (rowData.isFetched != true) {
      if (index > -1) {
        lines.splice(index, 1);
      }
    }

    invoiceData.lines = lines;
    this.setState({ invoiceData: invoiceData });
    this.calculateTotals();
  };
  addNewInvoiceLine = () => {
    let invoiceData = this.state.invoiceData;
    let invoiceLine = new InvoiceLineBean();
    invoiceLine.companyCode = this.companyCode;
    invoiceLine.lineNumber = NEW_ENTRY;
    invoiceLine.invoiceNumber = invoiceData.code;
    invoiceLine.customerCode = invoiceData.customerCode;
    invoiceLine.customerName = invoiceData.customerName;
    this.setState({ invoiceLineData: invoiceLine, isPtDisable: false });
    this.openLineDetailsDialog();
  };

  closeLineDetailsDialog = () => {
    this.setState({
      isShowLinePopup: false,
      invoiceLineData: new InvoiceLineBean(),
    });
  };

  executeAfterLineDetailDialogClose = (e) => { };

  onRollSelectedChange = (e, rowData) => {
    rowData.isApplied = e.target.value;
    if (rowData.isApplied == true) {
      rowData.shippedQuantity = rowData.availableQuantity;
      rowData.isRollPartialInventoryFlag = true;
    } else {
      rowData.shippedQuantity = 0;
      rowData.isRollPartialInventoryFlag = false;
    }
    const invoiceLineData = { ...this.state.invoiceLineData };
    invoiceLineData.rollLines.map((line) => {
      if (line.invoiceRollLineNumber == rowData.invoiceRollLineNumber) {
        line = rowData;
      }
    });
    this.calculateLineTotal(invoiceLineData);
    this.setState({ invoiceLineData: invoiceLineData });
  };

  // onRollSelectedChange = (evt, rollLine) => {
  //   let isSelected = false;
  //   let invoiceLine = this.state.invoiceLineData;

  //   isSelected = evt.target.value;
  //   rollLine.isSelected = evt.target.value;
  //   if (isSelected) {
  //     if (!rollLine.isCloseOutInventory) {
  //       let availableQty = rollLine.availableQuantity;

  //       rollLine.shippedQuantity = availableQty;

  //       let currAvailQty =
  //         rollLine.availableQuantity - rollLine.shippedQuantity;
  //       if (currAvailQty > 0) rollLine.isRollPartialInventoryFlag = true;
  //     } else {
  //     }
  //   } else {
  //     if (!rollLine.isCloseOutInventory) {
  //       if (rollLine.shippedQuantity > 0) {
  //         rollLine.shippedQuantity = 0;
  //         rollLine.isRollPartialInventoryFlag = false;
  //       }
  //     }
  //   }
  //   invoiceLine.rollLines.map((line) => {
  //     if (line.invoiceRollLineNumber == rollLine.invoiceRollLineNumber) {
  //       line = rollLine;
  //     }
  //   });
  //   this.calculateLineTotal(invoiceLine);
  //   this.setState({ invoiceLineData: invoiceLine });
  // };
  //#region Box Details
  onBoxLineChange = (e) => {
    let temp_invoiceBoxLineData = this.state.invoiceBoxLineData;
    temp_invoiceBoxLineData[e.target.name] = e.target.value;
    if (e.target.name == "boxType") {
      this.onBoxTypeChanges(temp_invoiceBoxLineData);
    }
    this.setState({ invoiceBoxLineData: temp_invoiceBoxLineData });
  };
  onBoxTypeChanges = (boxLineData) => {
    let boxTypes = this.state.boxTypes;

    let selectedBoxType = null;
    if (!isEmptyArray(boxTypes)) {
      boxTypes.map((boxType) => {
        if (boxType.code == boxLineData.boxType) {
          selectedBoxType = boxType;
        }
      });
    }
    if (selectedBoxType != null) {
      boxLineData.heightInInces = selectedBoxType.heightInInces;
      boxLineData.widthInInces = selectedBoxType.widthInInces;
      boxLineData.lengthInInces = selectedBoxType.lengthInInces;
    }
  };
  addNewBoxLine = () => {
    let invData = this.state.invoiceData;
    let invBoxLineData = new InvoiceShipmentBoxDetailBean();
    invBoxLineData.companyCode = this.companyCode;
    invBoxLineData.isFetched = false;
    invBoxLineData.pickTicketNumber = invData.code;
    this.setState({ invoiceBoxLineData: invBoxLineData });
    this.openBoxDetailsDialog();
  };
  lnkBoxLineDetailsClick = (rowData) => {
    let invBoxLine = new InvoiceShipmentBoxDetailBean();
    invBoxLine = { ...rowData };
    this.state.invoiceBoxLineData = invBoxLine;
    this.setState({ invoiceBoxLineData: invBoxLine });

    this.openBoxDetailsDialog();
  };

  addorupdateBoxLine = (e) => {
    if (e.detail == 1) {
      let invData = this.state.invoiceData;
      let invLineData = this.state.invoiceBoxLineData;

      if (isEmptyArray(invData.boxDetails)) invData.boxDetails = [];

      const index = invData.boxDetails.findIndex(
        (ln) => ln.boxLineNumber === invLineData.boxLineNumber
      );
      if (index != -1) {
        invData.boxDetails.splice(index, 1);
        invData.boxDetails.push(invLineData);
        this.setState({ invoiceData: invData });
        this.closeBoxDetailsDialog();
      } else {
        if (!isEmptyString(invLineData.boxNumber)) {
          var lineNumber = this.getBoxMaxLineNumber();
          invLineData.boxLineNumber = ++lineNumber;
          invData.boxDetails.push(invLineData);
          this.closeBoxDetailsDialog();
          this.setState({ invoiceData: invData });
        } else {
          let errList = [];
          let errMsg = "boxNumber Required";
          errList.push(errMsg);
          this.setState({
            alertType: "danger",
            alertMessage: errList,
            isShowPopupAlert: true,
          });
        }
      }
      this.setState({ invoiceData: invData });
      this.clearBoxLineValues(e);
    }
  };
  clearBoxLineValues = (e) => {
    if (e.detail == 1) {
      let boxLineData = new InvoiceShipmentBoxDetailBean();
      this.setState({ invoiceBoxLineData: boxLineData });
    }
  };

  getBoxMaxLineNumber() {
    let maxLineNumber = 0;
    let boxDetails = this.state.invoiceData.boxDetails;
    if (!isEmptyArray(boxDetails) && boxDetails.length > 0)
      boxDetails.map((line) => {
        if (line.boxLineNumber > maxLineNumber) {
          maxLineNumber = line.boxLineNumber;
        }
      });
    return maxLineNumber;
  }
  openBoxDetailsDialog = () => {
    this.setState({ isShowBoxPopup: true });
  };

  closeBoxDetailsDialog = () => {
    this.setState({ isShowBoxPopup: false });
  };

  executeAfterBoxDetailDialogClose = (e) => { };
  //#endregion
  calculateLineTotal = (invoiceLineData) => {
    let totalShippedQty = 0;

    if (!isEmpty(invoiceLineData) && !isEmptyArray(invoiceLineData.rollLines)) {
      invoiceLineData.rollLines.map((line) => {
        let shippedQuantity = 0;
        if (!isEmptyString(line.shippedQuantity))
          shippedQuantity = line.shippedQuantity;
        totalShippedQty += parseFloat(shippedQuantity);
      });

      invoiceLineData.shippedQuantity = parseFloat(totalShippedQty);
      invoiceLineData.lineNetAmount =
        parseFloat(totalShippedQty) * parseFloat(invoiceLineData.price);
      this.tariffPercentage = 0;
      this.tariffAmount = 0;
      invoiceLineData.tariffAmount =
        (parseFloat(invoiceLineData.lineNetAmount) *
          parseFloat(invoiceLineData.tariffPercentage)) /
        100;
    }
  };

  onRollLineShippedQtyChange = (evt, row) => {
    let invLine = this.state.invoiceLineData;

    if (
      !isEmpty(invLine) &&
      !isEmpty(row) &&
      !isEmptyArray(invLine.rollLines) &&
      // row.isSelected
      row.isApplied
    ) {
      invLine.rollLines.map((line) => {
        if (line.invoiceRollLineNumber == row.invoiceRollLineNumber) {
          line[evt.target.name] = evt.target.value;
        }
      });
      this.calculateLineTotal(invLine);
      this.state.invoiceLineData = invLine;
    }
    //this.setState({ invoiceLineData: invLine });
  };

  onRollLineShippedQtyBlur = (evt, row) => {
    // if (!isEmpty(row) && row.isSelected) {
    if (!isEmpty(row) && row.isApplied) {
      let invLine = this.state.invoiceLineData;
      this.setState({ invoiceLineData: invLine });
    }
  };

  RateDetailsColumnDefinitions = () => {
    let columnList = [];
    let moduleCaption = this.props.moduleCaption;
    let roll = new InvoiceRollLineBean();

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Service",
        "serviceMethodCode",
        0,
        true,
        this.lnkServiceMethodClick,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ServiceName",
        "serviceMethodName"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Carrier", "carrierCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Rate", "totalShipmentRate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Details", "rateDetails")
    );

    return columnList;
  };

  lnkLineDetailsClickReponse = (response) => {
    if (!isEmpty(response.data.skuBatchInventories)) {
      this.state.skuBatchInventories = response.data.skuBatchInventories;
      this.loadRollLines();
    }
  };

  lnkLineDetailsClickError = (error) => {
    ShowError("Error : " + error);
  };

  lnkLineDetailsClick = (rowData) => {
    if (this.state.is3PL === true) {
      this.lnkLineDetailsClick_3PL(rowData);
    } else {
      this.lnkLineDetailsClick_(rowData);
    }
  };

  lnkLineDetailsClick_ = (rowData) => {
    let invoiceLine = new InvoiceLineBean();
    invoiceLine = { ...rowData };
    this.state.invoiceLineData = invoiceLine;
    let input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;

    input.fabricStyleCode = invoiceLine.fabricStyleCode;
    input.colorCode = invoiceLine.colorCode;
    input.skuNumber = invoiceLine.skuNumber;
    this.setState({ isPtDisable: true, isShowPtLineLookup: false });
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      InventoryService.getAvailableSKUBatchInventories(
        input,
        this.lnkLineDetailsClickReponse,
        this.lnkLineDetailsClickError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  lnkLineDetailsClick_3PL = (rowData) => {
    this.state.invoiceLineData = { ...rowData };
    // this.setState({ invoiceLineData: rowData });

    this.openLineDetailsDialog();
  };

  //#endregion

  unLockInvoice = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      InvoiceService.unLockInvoice(
        request,
        this.unlockInvoiceResponse,
        this.unlockInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  unlockInvoiceResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editInvoice(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockInvoiceError = (error) => {
    ShowError("Error : ", error);
  };

  onCriteriaChange = (e) => {
    let criteria = this.state.invoiceCriteria;
    criteria.companyCode = this.companyCode;
    //if(e.target.name=="specialSearchText"){
    criteria[e.target.name] = e.target.value;
    // criteria["invoiceNumberStartsWith"] = e.target.value;
    //	}
    this.setState({ invoiceCriteria: criteria });
  };

  isModifyPosible = () => {
    let isModify = false;
    let invoiceData = this.state.invoiceData;
    if (invoiceData != null) {
      if (
        invoiceData.invoiceStatus == LogicConstants.INVOICE_APPROVE_STATUS ||
        invoiceData.invoiceStatus ==
        LogicConstants.INVOICE_PARTIALLY_PAID_STATUS ||
        invoiceData.invoiceStatus == LogicConstants.INVOICE_PAID_STATUS
      ) {
        isModify = true;
      }
    }
    return isModify;
  };

  getSalesCommissionMaxLineNumber() {
    let maxLineNumber = 0;
    let invoiceCommissions = this.state.invoiceData.invoiceCommissions;
    if (!isEmptyArray(invoiceCommissions) && invoiceCommissions.length > 0)
      invoiceCommissions.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getSalesCommissionBySalesPerson = (salesPerson) => {
    let salesCommission = null;
    if (this.state.invoiceData === null) return salesCommission;
    else if (this.state.invoiceData.invoiceCommissions === null)
      return salesCommission;
    else {
      this.state.invoiceData.invoiceCommissions.map((line) => {
        if (line.salesPersonCode === salesPerson) {
          salesCommission = line;
          return salesCommission;
        }
      });
    }
    return salesCommission;
  };
  onCommissionChange = (e) => {
    let temp_salesCommissionData = this.state.salesCommissionData;
    temp_salesCommissionData[e.target.name] = e.target.value;
    if (e.target.name == "salesPersonCode") {
      if (!isEmptyArray(this.state.salesPersonList)) {
        this.state.salesPersonList.map((line) => {
          if (line.code === e.target.value) {
            temp_salesCommissionData.salesPersonName = line.description;
          }
        });
      }
    }
    this.setState({ salesCommissionData: temp_salesCommissionData });
  };
  validateCommission = (commission) => {
    let isValidCommission = false;
    let err_list = [];
    let errorMessage = "";
    if (commission == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(commission.salesPersonCode)) {
        let errMsg = "salesPerson is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(commission.salesPersonName)) {
        let errMsg = "SalesPersonName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }

      if (commission.commissionPercentage == 0) {
        let errMsg = "CommissionPercentage is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else if (commission.commissionPercentage <= 0) {
        let errMsg = "CommissionPercentage is inValid";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      ShowError(errorMessage);
      isValidCommission = false;
      this.setState({ errorList: err_list });
    } else {
      isValidCommission = true;
    }
    return isValidCommission;
  };

  onAddorUpdateCommissionClick = () => {
    let commissionData = this.state.salesCommissionData;
    let invoiceData = this.state.invoiceData;
    let commissionLine = invoiceData.invoiceCommissions;
    commissionData.companyCode = this.companyCode;
    commissionData.invoiceNumber = invoiceData.code;
    var lineNumber = this.getSalesCommissionMaxLineNumber();
    let lineData = null;
    let list = [];
    let isValidCommission = false;
    isValidCommission = this.validateCommission(commissionData);
    if (isValidCommission) {
      let isLineFound = false;
      if (commissionLine != null) {
        commissionLine.map((line, i) => {
          if (
            line.lineNumber == commissionData.lineNumber ||
            line.salesPersonCode == commissionData.salesPersonCode
          ) {
            line.commissionPercentage = commissionData.commissionPercentage;
            list.push(line);
            isLineFound = true;
            commissionLine[i] = line;
          }
        });
      } else {
        commissionLine = [];
      }
      if (!isLineFound) {
        commissionData.lineNumber = ++lineNumber;
        commissionLine.push(commissionData);
      }

      invoiceData.invoiceCommissions = commissionLine;

      this.setState({
        invoiceData: invoiceData,
        salesCommissionData: commissionData,
      });
      this.onClearCommissionClick();
    }
  };
  onClearCommissionClick = () => {
    let salesCommissionData = new InvoiceCommissionBean();
    this.setState({ salesCommissionData: salesCommissionData });
  };

  /* ----------ExtraCharge -------------*/

  //ExtraCharge Amount Popup

  extraChargeAmountClick = (val) => {
    let invoiceData = this.state.invoiceData;
    let exLine = new InvoiceExtraChargesBean();
    exLine.companyCode = this.companyCode;
    exLine.invoiceNumber = invoiceData.code;
    exLine.currencyCode = DEFAULT_CURRENCY_CODE;
    exLine.lineNumber = NEW_ENTRY;
    this.setState({
      invoiceExtraChargeData: exLine,
      isShowExtraChargePopup: true,
    });
  };
  addSaveExtraChargeAmount = () => {
    let invoiceExtraChargeData = this.state.invoiceExtraChargeData;
    let invoiceData = this.state.invoiceData;
    let extraChargeAmount = 0;
    if (invoiceData.extraCharges != null) {
      invoiceData.extraCharges.map((ex) => {
        // if (ex.isDeleted != true) {
        extraChargeAmount =
          parseFloat(extraChargeAmount) + parseFloat(ex.extraChargesAmount);
        // }
      });
    }

    invoiceData.extraChargesAmount = extraChargeAmount;

    this.setState({ isShowExtraChargePopup: false, invoiceData: invoiceData });
    // this.calculateTotals();
  };

  onExtraChange = (e) => {
    let temp_ExtraChargeData = this.state.invoiceExtraChargeData;
    temp_ExtraChargeData[e.target.name] = e.target.value;
    this.setState({ invoiceExtraChargeData: temp_ExtraChargeData });
  };

  onExtraReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteExtraChargeList = true;

    let temp_ExtraChargeData = this.state.invoiceExtraChargeData;
    let showAutoCompleteList = this.state.showAutoCompleteExtraChargeList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteExtraChargeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteExtraChargeList;

      temp_ExtraChargeData.extraChargeReasonCode = "";
      temp_ExtraChargeData.extraChargeReasonName = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteExtraChargeList: showAutoCompleteList,
        invoiceExtraChargeData: temp_ExtraChargeData,
        extraChargePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readExtraChargeCodeBySearchString(code);
    }
    if (e.target.name == "extraChargeReasonCode") {
      temp_ExtraChargeData["extraChargeReasonCode"] = e.target.value;
      let element_List = this.state.extraChargeReasons;
      element_List.map((element) => {
        if (element.extraChargeReasonCode == e.target.value) {
          temp_ExtraChargeData["extraChargeReasonCode"] = element.code;
          temp_ExtraChargeData["extraChargeReasonName"] = element.description;
          temp_ExtraChargeData["extraChargesAmount"] =
            element.extraChargesAmount;
          this.state.showAutoCompleteExtraChargeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteExtraChargeList;
          this.setState({
            showAutoCompleteExtraChargeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ invoiceExtraChargeData: temp_ExtraChargeData });
  };
  readExtraChargeCodeBySearchString(searchString) {
    let extraChargeList = this.state.extraChargeReasons;
    let simpleAutoCompleteList = new Array();
    if (extraChargeList.length > 0 && extraChargeList != null) {
      extraChargeList.map((list) => {
        let simpleItemBean = {
          code: list.code,
          description: list.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (ln) => ln.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      extraChargePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  extraChargeEnterKeyEventHandler = (e) => {
    let temp_invoiceExtraChargeData = this.state.invoiceExtraChargeData;
    let extraChargeReasonCode = e.target.value;

    temp_invoiceExtraChargeData["extraChargeReasonCode"] = e.target.value;
    let charge_List = this.state.extraChargeReasons;
    let extraBean = null;
    charge_List.map((ln) => {
      if (ln.code == e.target.value) {
        extraBean = ln;
      }
    });
    if (!isEmpty(extraBean)) {
      temp_invoiceExtraChargeData.extraChargeReasonCode = extraBean.code;
      temp_invoiceExtraChargeData.extraChargeReasonName = extraBean.description;
      temp_invoiceExtraChargeData.extraChargesAmount =
        extraBean.extraChargesAmount;
      this.setState({
        invoiceExtraChargeData: temp_invoiceExtraChargeData,
        extraChargePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteExtraChargeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteExtraChargeList: showAutoCompleteList,
    });
  };

  onExtraChargeLineClick = (rowData) => {
    // let invoiceExtraChargeData = new InvoiceExtraChargesBean();
    let invoiceExtraChargeData = this.state.invoiceExtraChargeData;
    // invoiceExtraChargeData.lineNumber = rowData.lineNumber;
    // invoiceExtraChargeData.extraChargeReasonCode =
    //   rowData.extraChargeReasonCode;
    // invoiceExtraChargeData.extraChargesAmount = rowData.extraChargesAmount;
    // invoiceExtraChargeData.extraChargeReasonName =
    //   rowData.extraChargeReasonName;
    let invoiceRowData = { ...rowData };
    //this.props.invoiceExtraChargeData = invoiceExtraChargeData;
    this.setState({ invoiceExtraChargeData: invoiceRowData });
  };

  getExtraChargeMaxLineNumber() {
    let maxLineNumber = 0;
    let exLines = this.state.invoiceData.extraCharges;
    if (exLines != null) {
      if (exLines.length > 0)
        exLines.map((line) => {
          if (line.lineNumber > maxLineNumber) {
            maxLineNumber = line.lineNumber;
          }
        });
    }
    return maxLineNumber;
  }
  validateExtraCharge = (exLine) => {
    let isValidLine = false;
    let err_list = [];
    let errorMessage = "";
    if (exLine == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(exLine.extraChargeReasonCode)) {
        let errMsg = "Reason Code Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (exLine.extraChargesAmount <= 0) {
        let errMsg = "Invalid Amount";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidLine = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValidLine = true;
      this.setState({ isShowPopupAlert: false });
    }

    return isValidLine;
  };
  addUpdateExtraChargeLine = () => {
    let exLine = this.state.invoiceExtraChargeData;
    let invoiceData = this.state.invoiceData;
    let extraLine = invoiceData.extraCharges;
    var lineNumber = this.getExtraChargeMaxLineNumber();
    let lineData = null;
    let isValid = false;
    isValid = this.validateExtraCharge(exLine);
    if (isValid) {
      let isLineFound = false;
      if (extraLine != null) {
        extraLine.map((line, i) => {
          if (
            line.lineNumber == exLine.lineNumber ||
            line.extraChargeReasonCode == exLine.extraChargeReasonCode
          ) {
            exLine.lineNumber = line.lineNumber;
            // extraLine[i] = exLine;
            line.extraChargesAmount = exLine.extraChargesAmount;
            extraLine[i] = line;
            isLineFound = true;
          }
        });
      } else {
        extraLine = [];
      }
      if (!isLineFound) {
        exLine.lineNumber = ++lineNumber;
        extraLine.push(exLine);
      }

      invoiceData.extraCharges = extraLine;
      this.setState({
        invoiceData: invoiceData,
      });
      this.clearExtraChargesValues();
    }
  };
  clearExtraChargesValues = () => {
    let invoiceData = this.state.invoiceData;
    let newLineBean = new InvoiceExtraChargesBean();
    newLineBean.companyCode = this.companyCode;
    newLineBean.invoiceNumber = invoiceData.code;
    newLineBean.currencyCode = DEFAULT_CURRENCY_CODE;
    this.setState({
      invoiceExtraChargeData: newLineBean,
    });
  };
  reArrangeExtraLineDisplayLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.displayLineNumber = maxLineNumber;
    });
  };
  deleteExtraCharge = (rowData) => {
    let tempInvoiceData = this.state.invoiceData;
    var temp_extra = tempInvoiceData.extraCharges;

    let line = rowData;

    if (rowData.isFetched == false) {
      var index = temp_extra.indexOf(line);
      if (index > -1) {
        temp_extra.splice(index, 1);
      }
    } else {
      let errMsg = "Already Existing Extra Charge";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }

    this.reArrangeExtraLineDisplayLineNumbers(temp_extra);
    this.setState({ invoiceData: tempInvoiceData });
  };

  /* ------------ Non Merchandise Popup ------------*/

  nonMerchandiseAmountClick = (val) => {
    let invoiceData = this.state.invoiceData;
    let mcLine = new InvoiceNonMerchandiseLineBean();
    mcLine.companyCode = this.companyCode;
    mcLine.invoiceNumber = invoiceData.code;
    mcLine.currencyCode = DEFAULT_CURRENCY_CODE;
    mcLine.lineNumber = NEW_ENTRY;
    mcLine.customerCode = invoiceData.customerCode;
    mcLine.customerName = invoiceData.customerName;

    this.setState({
      merchandiseData: mcLine,
      isShowNonMerchandisePopup: true,
    });
  };
  addSaveNonMerchandiseAmount = () => {
    let merchandiseData = this.state.merchandiseData;
    let invoiceData = this.state.invoiceData;
    let nonMerchandiseTotalAmount = 0;
    if (invoiceData.nonMerchandiseLines != null) {
      invoiceData.nonMerchandiseLines.map((ex) => {
        nonMerchandiseTotalAmount =
          parseFloat(nonMerchandiseTotalAmount) +
          parseFloat(ex.lineTotalAmount);
      });
    }

    invoiceData.nonMerchandiseTotalAmount = nonMerchandiseTotalAmount;
    this.setState({ isShowNonMerchandisePopup: false });
  };
  onNonMerchandiseChange = (e) => {
    let invoiceData = this.state.invoiceData;
    let lineData = this.state.merchandiseData;
    lineData[e.target.name] = e.target.value;

    this.setState({
      invoiceData: invoiceData,
      merchandiseData: lineData,
    });
  };

  onNonMerchandiseReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteNonMercList = true;

    let temp_MerchandiseData = this.state.merchandiseData;
    let showAutoCompleteList = this.state.showAutoCompleteNonMercList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteNonMercList = false;
      let showAutoCompleteList = this.state.showAutoCompleteNonMercList;

      temp_MerchandiseData.reasonCode = "";
      temp_MerchandiseData.reasonName = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteNonMercList: showAutoCompleteList,
        merchandiseData: temp_MerchandiseData,
        nonMercPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readNonMercCodeBySearchString(code);
    }
    if (e.target.name == "reasonCode") {
      temp_MerchandiseData["reasonCode"] = e.target.value;
      let element_List = this.state.nonMerchandiseReasons;
      element_List.map((element) => {
        if (element.reasonCode == e.target.value) {
          temp_MerchandiseData["reasonCode"] = element.code;
          temp_MerchandiseData["reasonName"] = element.description;
          this.state.showAutoCompleteNonMercList = false;
          let showAutoCompleteList = this.state.showAutoCompleteNonMercList;
          this.setState({ showAutoCompleteNonMercList: showAutoCompleteList });
        }
      });
    }
    this.setState({ merchandiseData: temp_MerchandiseData });
  };
  readNonMercCodeBySearchString(searchString) {
    let nonMercList = this.state.nonMerchandiseReasons;
    let simpleAutoCompleteList = new Array();
    if (nonMercList.length > 0 && nonMercList != null) {
      nonMercList.map((list) => {
        let simpleItemBean = {
          code: list.code,
          description: list.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (ln) => ln.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ nonMercPageListForAutoCompleteList: filteredSuggestions });
  }
  nonMercEnterKeyEventHandler = (e) => {
    let temp_MerchandiseData = this.state.merchandiseData;
    let reasonCode = e.target.value;
    temp_MerchandiseData["reasonCode"] = e.target.value;
    let merc_List = this.state.nonMerchandiseReasons;
    let mercBean = null;
    merc_List.map((ln) => {
      if (ln.code == e.target.value) {
        mercBean = ln;
      }
    });
    if (!isEmpty(mercBean)) {
      temp_MerchandiseData.reasonCode = mercBean.code;
      temp_MerchandiseData.reasonName = mercBean.description;
      this.setState({
        merchandiseData: temp_MerchandiseData,
        nonMercPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteNonMercList = (showAutoCompleteList) => {
    this.setState({ displayAutoCompleteNonMercList: showAutoCompleteList });
  };

  onMerchandiseLineClick = (val, rowData) => {
    let merchandiseData = this.state.merchandiseData;
    let merchRowData = { ...rowData };
    this.setState({ merchandiseData: merchRowData });
  };

  getMerchandiseMaxLineNumber() {
    let maxLineNumber = 0;
    let mcLines = this.state.invoiceData.nonMerchandiseLines;
    if (mcLines != null) {
      if (mcLines.length > 0)
        mcLines.map((line) => {
          if (line.lineNumber > maxLineNumber) {
            maxLineNumber = line.lineNumber;
          }
        });
    }
    return maxLineNumber;
  }
  validateNonMerchandise = (mcLine) => {
    let isValidLine = false;
    let err_list = [];
    let errorMessage = "";
    if (mcLine == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(mcLine.reasonCode)) {
        let errMsg = "Reason Code Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (mcLine.lineTotalAmount <= 0) {
        let errMsg = "Invalid Amount";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidLine = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValidLine = true;
      this.setState({ isShowPopupAlert: false });
    }

    return isValidLine;
  };

  addUpdateMerchandiseLine = () => {
    let mcData = this.state.merchandiseData;
    let invoiceData = this.state.invoiceData;
    let mcList = invoiceData.nonMerchandiseLines;
    let isValid = false;
    isValid = this.validateNonMerchandise(mcData);
    if (isValid) {
      let isLineFound = false;
      if (mcList != null) {
        mcList.map((line, i) => {
          if (
            line.lineNumber == mcData.lineNumber ||
            line.reasonCode == mcData.reasonCode
          ) {
            mcData.lineNumber = line.lineNumber;
            line.lineTotalAmount = mcData.lineTotalAmount;
            mcList[i] = line;
            isLineFound = true;
          }
        });
      } else {
        mcList = [];
      }
      var lineNumber = this.getMerchandiseMaxLineNumber();
      if (!isLineFound) {
        mcData.lineNumber = ++lineNumber;
        mcList.push(mcData);
      }
      invoiceData.nonMerchandiseLines = mcList;
      this.setState({
        invoiceData: invoiceData,
      });
      this.clearMerchandiseValues();
    }
  };
  clearMerchandiseValues = () => {
    let invoiceData = this.state.invoiceData;
    let newLineBean = new InvoiceNonMerchandiseLineBean();
    newLineBean.companyCode = this.companyCode;
    newLineBean.invoiceNumber = invoiceData.code;
    newLineBean.currencyCode = DEFAULT_CURRENCY_CODE;
    newLineBean.customerCode = invoiceData.customerCode;
    newLineBean.customerName = invoiceData.customerName;
    this.setState({
      merchandiseData: newLineBean,
    });
  };
  reArrangeNonMercLineDisplayLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.displayLineNumber = maxLineNumber;
    });
  };
  deleteNonMerchandiseLine = (rowData) => {
    let tempInvoiceData = this.state.invoiceData;
    var temp_merc = tempInvoiceData.nonMerchandiseLines;
    let line = rowData;
    if (rowData.isFetched == false) {
      var index = temp_merc.indexOf(line);
      if (index > -1) {
        temp_merc.splice(index, 1);
      }
    } else {
      let errMsg = "Already Existing Non Merchandise Amount";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
    this.reArrangeNonMercLineDisplayLineNumbers(temp_merc);
    this.setState({ invoiceData: tempInvoiceData });
  };
  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
    });
  };
  reArrangeBoxLineDisplayLineNumbers = (boxLineList) => {
    let maxLineNumber = 0;
    boxLineList.map((line) => {
      ++maxLineNumber;
      line.displayLineNumber = maxLineNumber;
    });
  };

  deleteBoxLine = (rowData) => {
    let tempInvoiceData = this.state.invoiceData;
    var temp_boxLine = tempInvoiceData.boxDetails;
    let line = rowData;
    var index = temp_boxLine.indexOf(line);
    if (index > -1) {
      temp_boxLine.splice(index, 1);
    }
    this.reArrangeBoxLineDisplayLineNumbers(temp_boxLine);
    this.setState({ invoiceData: tempInvoiceData });
  };

  /*----------------------Sales Person AutoComplete --------------------*/
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_commission = this.state.salesCommissionData;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      temp_commission.salesPersonCode = "";
      temp_commission.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesPersonList: showAutoCompleteList,
        salesCommissionData: temp_commission,
        salesPersonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_commission[e.target.name] = e.target.value;
    this.setState({ salesCommissionData: temp_commission });
    this.readSalesPerson(salesPersonCode);
  };

  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersonList.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_commission = this.state.salesCommissionData;
      temp_commission.salesPersonCode = salesPersonBean.code;
      temp_commission.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        salesCommissionData: temp_commission,
        showAutoCompleteSalesPersonList: showAutoCompleteList,
      });
    }
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersonList;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  reArrangeSalesCommissionLineNumbers = (LineList) => {
    let maxLineNumber = 0;
    LineList.map((line) => {
      ++maxLineNumber;
      line.ineNumber = maxLineNumber;
    });
  };
  deleteCommissionClickCallback = (rowData) => {
    let invoiceData = this.state.invoiceData;
    let lineData = invoiceData.invoiceCommissions;
    if (rowData.isFetched == false) {
      var index = lineData.indexOf(rowData);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
      invoiceData.invoiceCommissions.map((ln) => {
        if (ln.lineNumber === rowData.lineNumber) {
          ln.isDeleted = true;
        }
      });
    }
    this.reArrangeSalesCommissionLineNumbers(lineData);
    this.setState({ invoiceData: invoiceData });
  };
  handleCommissionLineNumberClick = (rowData) => {
    let commission = { ...rowData };
    this.setState({ salesCommissionData: commission });
  };
  viewPOModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPOModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPOReceiptModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPOReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  getHeaderView() {
    return (
      <InvoiceEntryForm
        {...this.state}
        ref={this.entryFormRef}
        viewPOModule={this.viewPOModule}
        viewPOReceiptModule={this.viewPOReceiptModule}
        invoiceData={this.state.invoiceData}
        invoiceLineData={this.state.invoiceLineData}
        moduleCaption={this.state.moduleCaption}
        onChange={this.onChange}
        onLineChange={this.onLineChange}
        isModifyPosible={this.isModifyPosible}
        lnkLineDetailsClick={this.lnkLineDetailsClick}
        isReadOnlyOrDisabled={this.state.isReadOnlyOrDisabled}
        onHeaderAmountsChange={this.onHeaderAmountsChange}
        clearExtraChargesValues={this.clearExtraChargesValues}
        addUpdateExtraChargeLine={this.addUpdateExtraChargeLine}
        onExtraChargeLineClick={this.onExtraChargeLineClick}
        onExtraChange={this.onExtraChange}
        addSaveExtraChargeAmount={this.addSaveExtraChargeAmount}
        extraChargeAmountClick={this.extraChargeAmountClick}
        deleteExtraCharge={this.deleteExtraCharge}
        closeAlertAmountModalCallBack={this.closeAlertAmountModalCallBack}
        extraChargeEnterKeyEventHandler={this.extraChargeEnterKeyEventHandler}
        displayAutoCompleteExtraChargeList={
          this.displayAutoCompleteExtraChargeList
        }
        hidePopupAlertCallBack={this.hidePopupAlertCallBack}
        onExtraReasonChange={this.onExtraReasonChange}
        nonMerchandiseAmountClick={this.nonMerchandiseAmountClick}
        addSaveNonMerchandiseAmount={this.addSaveNonMerchandiseAmount}
        onNonMerchandiseChange={this.onNonMerchandiseChange}
        onMerchandiseLineClick={this.onMerchandiseLineClick}
        addUpdateMerchandiseLine={this.addUpdateMerchandiseLine}
        clearMerchandiseValues={this.clearMerchandiseValues}
        deleteNonMerchandiseLine={this.deleteNonMerchandiseLine}
        nonMercEnterKeyEventHandler={this.nonMercEnterKeyEventHandler}
        displayAutoCompleteNonMercList={this.displayAutoCompleteNonMercList}
        onNonMerchandiseReasonChange={this.onNonMerchandiseReasonChange}
        openCustomerOnOrderInq={this.openCustomerOnOrderInq}
        openCustomerTransactionsInq={this.openCustomerTransactionsInq}
        openCustomerStatisticsInq={this.openCustomerStatisticsInq}
        openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
        openCustomerMostRecentFabricsInq={this.openCustomerMostRecentFabricsInq}
        openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
        openCustomerInfoInq={this.openCustomerInfoInq}
        addNewInvoiceLine={this.addNewInvoiceLine}
        deleteInvoiceLine={this.deleteInvoiceLine}
        onPaymentTermChange={this.onPaymentTermChange}
        paymentTermEnterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
        displayAutoCompletePaymentTermList={
          this.displayAutoCompletePaymentTermList
        }

        onCustomerCodeChange={this.onCustomerCodeChange}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
      />
    );
  }
  getListView() {
    return (
      <InvoiceListForm
        {...this.state}
        invoiceList={this.state.invoiceList}
        pageList={this.state.pageList}
        invoiceCriteria={this.state.invoiceCriteria}
        filterInvoice={this.filterInvoice}
        loadFirst={this.loadFirst}
        loadNext={this.loadNext}
        loadPrevious={this.loadPrevious}
        loadLast={this.loadLast}
        editInvoice={this.editInvoice}
        resetFilteredInvoice={this.resetFilteredInvoice}
        isLoading={this.state.isLoading}
        advanceSearch={this.advanceSearch}
        getCriteriaString={this.getCriteriaString}
        isAdvanceSearch={this.state.isAdvanceSearch}
        moduleCaption={this.state.moduleCaption}
        onCriteriaChange={this.onCriteriaChange}
        handleSortingChange={this.handleSortingChange}
      />
    );
  }
  getShippingInformationView() {
    return (
      <ShippingInformationEntryForm
        {...this.state}
        ref={this.shippingInformationFormRef}
        invoiceData={this.state.invoiceData}
        moduleCaption={this.state.moduleCaption}
        onChange={this.onChange}
        isModifyPosible={this.isModifyPosible}
        addressOnChange={this.addressOnChange}
        addNewBoxLine={this.addNewBoxLine}
        lnkBoxLineDetailsClick={this.lnkBoxLineDetailsClick}
        freightMethods={this.state.freightMethods}
        shipVias={this.state.shipVias}
        cityList={this.state.cityList}
        stateList={this.state.stateList}
        countryList={this.state.countryList}
        shipTos={this.state.shipTos}
        isDisabledFields={this.state.isDisabledFields}
        deleteBoxLine={this.deleteBoxLine}
        onCityChange={this.onCityChange}
        cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
        onCountryChange={this.onCountryChange}
        countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
        onStateChange={this.onStateChange}
        stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        addressData={this.state.addressData}
        onShipViaChange={this.onShipViaChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        onFreightMethodChange={this.onFreightMethodChange}
        freightMethodEnterKeyEventHandler={
          this.freightMethodEnterKeyEventHandler
        }
        displayAutoCompleteFreightMethodList={
          this.displayAutoCompleteFreightMethodList
        }
        onShipToChange={this.onShipToChange}
        shipToEnterKeyEventHandler={this.shipToEnterKeyEventHandler}
        displayAutoCompleteShipToList={this.displayAutoCompleteShipToList}
        onHeaderAmountsChange={this.onHeaderAmountsChange}
      />
    );
  }
  getPaymentDetailsView() {
    return (
      <PaymentDetailsForm
        onChange={this.onChange}
        invoiceData={this.state.invoiceData}
        accountReceivablePaymentDetails={
          this.state.accountReceivablePaymentDetails
        }
      />
    );
  }
  getPaymentHistoryView() {
    return (
      <PaymentHistoryForm
        {...this.state}
        onChange={this.onChange}
        invoiceData={this.state.invoiceData}
        accountReceivablePaymentDetails={
          this.state.accountReceivablePaymentDetails
        }
      />
    );
  }
  getCommissionView() {
    return (
      <SalesCommissionForm
        {...this.state}
        onChange={this.onChange}
        invoiceData={this.state.invoiceData}
        onCommissionChange={this.onCommissionChange}
        onAddorUpdateCommissionClick={this.onAddorUpdateCommissionClick}
        onClearCommissionClick={this.onClearCommissionClick}
        disablePurchaseOrderFormFields={this.state.isDisableFields}
        isModifyPosible={this.isModifyPosible}
        salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
        displayAutoCompleteSalesPersonList={
          this.displayAutoCompleteSalesPersonList
        }
        salesPersonCodeOnChange={this.salesPersonCodeOnChange}
        buttonClickCallback={this.buttonClickCallback}
        handleCommissionLineNumberClick={this.handleCommissionLineNumberClick}
        deleteCommissionClickCallback={this.deleteCommissionClickCallback}
      />
    );
  }
  getChangesHistoryView() {
    return <ChangesHistoryForm invoiceData={this.state.invoiceData} />;
  }
  serviceLineOnchange = (e) => {
    let invoiceServiceLineData = this.state.invoiceServiceLineData;
    invoiceServiceLineData[e.target.name] = e.target.value;
    if (e.target.name == "quantity") {
      invoiceServiceLineData.amount =
        invoiceServiceLineData.unitPrice * e.target.value;
    }
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };
  getLineNumber = () => {
    let maxLineNumber = 0;
    let invoiceServiceLineList = this.state.invoiceData.serviceLines;
    if (!isEmptyArray(invoiceServiceLineList)) {
      invoiceServiceLineList.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.serviceCode)) {
        let errMsg = "ServiceCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.amount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UomCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.unitPrice)) {
        let errMsg = "Price is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.quantity)) {
        let errMsg = "Qty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  clearLines = () => {
    let invoiceServiceLineData = new InvoiceServiceLineBean();
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };
  reArrangeLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  calculateServiceAmount = () => {
    // need to check service amount it get replicate after add or update
    let serviceAmount = 0;
    let invoiceData = this.state.invoiceData;
    if (!isEmptyArray(invoiceData.serviceLines)) {
      invoiceData.serviceLines.map((ln) => {
        serviceAmount += parseFloat(ln.amount);
      });
    }
    invoiceData.totalServiceAmount = serviceAmount;
    this.setState({
      invoiceData: invoiceData,
    });
  };

  addLines = () => {
    let invoiceData = this.state.invoiceData;
    let invoiceServiceLineList = [];
    if (!isEmptyArray(this.state.invoiceData.serviceLines)) {
      invoiceServiceLineList = this.state.invoiceData.serviceLines;
    }
    let invoiceServiceLineData = this.state.invoiceServiceLineData;
    invoiceServiceLineData.companyCode = this.companyCode;
    invoiceServiceLineData.invoiceNumber = invoiceData.code;
    invoiceServiceLineData.customerCode = invoiceData.customerCode;
    invoiceServiceLineData.customerName = invoiceData.customerName;
    invoiceServiceLineData.lineStatus =
      LogicConstants.INVOICE_SERVICE_LINE_OPEN_STATUS;
    // invoiceServiceLineData.companyCode = "3PL";
    let isValid = false;
    isValid = this.validate(invoiceServiceLineData);
    if (isValid) {
      var lineNumber = this.getLineNumber();
      let isLineFound = false;
      if (!isEmptyArray(invoiceServiceLineList)) {
        invoiceServiceLineList.map((ln, i) => {
          if (ln.lineNumber == invoiceServiceLineData.lineNumber) {
            invoiceServiceLineData.isFetched = ln.isFetched;
            invoiceServiceLineList[i] = invoiceServiceLineData;
            isLineFound = true;
          }
        });
      }
      if (!isLineFound) {
        invoiceServiceLineData.lineNumber = ++lineNumber;
        invoiceServiceLineList.push(invoiceServiceLineData);
      }
      invoiceData.serviceLines = invoiceServiceLineList;
      this.setState({
        invoiceServiceLineList: invoiceServiceLineList,
        invoiceData: invoiceData,
      });
      this.calculateServiceAmount();
      this.clearLines();
    }
  };
  deleteService = (rowData) => {
    let invoiceServiceLineList = [];
    let invoiceData = this.state.invoiceData;
    if (!isEmptyArray(this.state.invoiceData.serviceLines)) {
      invoiceServiceLineList = this.state.invoiceData.serviceLines;
    }
    var index = invoiceServiceLineList.indexOf(rowData);
    if (index > -1) {
      invoiceServiceLineList.splice(index, 1);
      this.reArrangeLines(invoiceServiceLineList);
      invoiceData.serviceLines = invoiceServiceLineList;
      this.state.invoiceData.serviceLines = invoiceServiceLineList;
      this.setState({
        invoiceServiceLineList: invoiceServiceLineList,
        invoiceData: invoiceData,
      });
    }
    this.calculateServiceAmount();
  };
  editService = (data, rowData) => {
    let invoiceServiceLineData = new InvoiceServiceLineBean();
    let invoiceData = this.state.invoiceData;
    invoiceServiceLineData = { ...rowData };
    invoiceServiceLineData.companyCode = invoiceData.companyCode;
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };
  getServiceView() {
    return (
      <ServiceDetailsForm
        {...this.state}
        invoiceData={this.state.invoiceData}
        serviceLineOnchange={this.serviceLineOnchange}
        invoiceUomOnChange={this.invoiceUomOnChange}
        invoiceUomEnterKeyEvent={this.invoiceUomEnterKeyEvent}
        displayInvoiceUomAutoCompleteList={
          this.displayInvoiceUomAutoCompleteList
        }
        serviceOnChange={this.serviceOnChange}
        serviceEnterKeyEvent={this.serviceEnterKeyEvent}
        displayServiceAutoCompleteList={this.displayServiceAutoCompleteList}
        editService={this.editService}
        clearLines={this.clearLines}
        addLines={this.addLines}
        deleteService={this.deleteService}
        onHeaderAmountsChange={this.onHeaderAmountsChange}
      />
    );
  }
  getModuleListView = () => {
    let invoiceData = this.state.invoiceData;
    // this.unLockInvoice(invoiceData.code, false);
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockInvoice(invoiceData.code);
    } else {
      this.isLocked = false;
    }
    this.closeEntryForm();
    this.loadInvoices();
    this.hideAlertCallBack(false);
  };
  resetView = () => {
    let invoice_Data = this.state.invoiceData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockInvoice(invoice_Data.code);
    } else {
      this.isLocked = false;
    }
    let invoiceData = new InvoiceBean();
    this.setState({
      invoiceData: invoiceData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      showAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipToList: false,
      shipToPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: [],
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: [],
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: [],
      showAutoCompleteSalesPersonList: false,
      salesPersonPageListForAutoCompleteList: [],
      isShowMailInvoiceButton: false,
      isShowModifyCommentButton: false,
      isShowGenerateSalesCommButton: false,
      isShowCommInvButton: false,
      isShowModifyButton: false,
      isShowPrintNaftaButton: false,
      isShowPayButton: false,
      showAutoCompletePaymentTermList: false,
      paymentTermPageListForAutoCompleteList: new Array(),
      isDisabledFields: false,
      isDisableAddLine: false,
    });
    this.state.invoiceData = new InvoiceBean();
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    // this.openEntryForm();
    this.addNewEntry();
    this.hideAlertCallBack(false);
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  moduleExit = () => {
    let invoiceData = this.state.invoiceData;
    if (this.isLocked) {
      this.isLocked = false;
      this.unLockInvoice(invoiceData.code);
    } else {
      // this.isLocked = false;
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unLockInvoice(invoiceData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
    // this.props.onModuleExit();
    this.hideAlertCallBack(false);
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editInvoice(this.state.moduleKeyCode);
    }
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowBoxPopup: isShowPopup,
      isShowPaymentPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowModifyPopup: isShowPopup,
      isCardPayment: false,
      isCheckPayment: true,
      isCashPayment: false,
      isWirePayment: false,
      isAchPayment: false,
      isShowCustomerCreditCardLookup: false,
      isShowPopupAlert:false,
    });
  };
  closeAlertPopupModalCallBack = (isShowPopup) => {
    this.setState({
      isShowBoxPopup: isShowPopup,
      isShowPopupAlert: isShowPopup,
      isShowLinePopup: isShowPopup,
      isShowMailInvoicePopup: isShowPopup,
      isShowModifyCommentPopup: isShowPopup,
    });
    this.clearPopupDatas();
  };
  clearPopupDatas = () => {
    this.setState({
      mailInfoData: new MailInfoBean(),
      invoiceBoxLineData: new InvoiceShipmentBoxDetailBean(),
    });
  };
  isClose = () => {
    this.setState({
      isClose: true,
    });
  };
  onKeyDownLineDetail = (e) => {
    if (e.keyCode == 27) {
      this.closeAlertModalCallBack(false);
    }
  };
  onFabricKeyDown = (e) => {
    if (e.keyCode == 27) {
      this.closeAlertFabricModalCallBack(false);
      this.setState({
        isClose: false,
      });
    }
  };
  closeAlertFabricModalCallBack = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,
      isShowCustomerFabricSalesPopup: isShowPopup,
      isShowFabricCurrentInvPopup: isShowPopup,
      isShowFabricInventoryPosPopup: isShowPopup,
      isShowFabricPurchaseHistoryPopup: isShowPopup,
      disableLineDetailPopUp: false,
    });
  };
  disableFabricPurchasePopUp = () => {
    this.setState({
      disableFabricPurchasePopUp: true,
    });
  };
  releaseFabricPurchasePopUp = () => {
    this.setState({
      disableFabricPurchasePopUp: false,
    });
  };
  modifyCommentsContinue = (e) => {
    if (e.detail == 1) {
      let invoiceData = this.state.invoiceData;
      this.setState({
        isLoading: true,
        loadingText: "Modifying Comment",
      });
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        InvoiceService.updateInvoiceCommentsAfterApproval(
          invoiceData,
          this.updateInvoiceCommentPageResponse,
          this.updateInvoiceCommentPageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  updateInvoiceCommentPageResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handlePopupResponse(response.data);
    if (isSuccess) {
      if (response.data != null) {
        let invoiceData = response.data.invoice;
        if (invoiceData != null) {
          this.setState({
            invoiceData: invoiceData,
          });
          if (this.isLocked) {
            this.code = invoiceData.code;
            this.unLockInvoice(invoiceData.code);
          }

          setTimeout(() => {
            this.closeAlertPopupModalCallBack(false);
          }, 200);
        }
      }
    }
  };
  updateInvoiceCommentPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :", error);
  };
  mailInvoiceContinue = (e) => {
    if (e.detail == 1) {
      let request = new RestInvoiceMailInfoBeanRequest();
      let reportData = new RestReportBean();
      let mailInfoData = this.state.mailInfoData;
      reportData.reportType = 1;
      let invoiceData = this.state.invoiceData;
      request.companyCode = this.companyCode;
      request.code = invoiceData.code;
      request.inputReportBean = reportData;
      request.infoBean = mailInfoData;
      if (
        SecurityAccessManager.InvoiceMaintenanceSendMailReport_IsAccessible()
      ) {
        InvoiceService.sendSalesInvoiceCustomerMail(
          request,
          this.mailInvoiceContinueResponse,
          this.mailInvoiceContinueError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  mailInvoiceContinueResponse = (response) => {
    let isSuccess = this.handlePopupResponse(response.data);
    if (isSuccess) {
      if (response.data != null) {
        if (response.data.success) {
          setTimeout(() => {
            this.closeAlertPopupModalCallBack(false);
          }, 200);
        }
      }
    }
  };
  mailInvoiceContinueError = (error) => {
    ShowError("Error :", error);
  };
  //Fabric Info
  lnkFabricStyleModule = (e) => {
    if (e.detail == 1) {
      let invoiceLineData = this.state.invoiceLineData;
      let fabricStyleCode = invoiceLineData.fabricStyleCode;
      if (!isEmptyString(fabricStyleCode)) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={fabricStyleCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerOnOrderInq: isOpen,
      isShowCustomerTransactionsInq: isOpen,
      isShowCustomerStatisticsInq: isOpen,
      isShowCustomerSalesHistoryInq: isOpen,
      isShowCustomerMostRecentFabricsInq: isOpen,
      isShowCustomerCurrentAgingInq: isOpen,
      isShowCustomerInfoInq: isOpen,
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
      isShowCustomerSalesHistoryInq: isOpen,
      isShowItemInventoryPositionInq: isOpen,
      isShowItemCurrentInventoryInq: isOpen,
      isShowFabricPurchaseHistoryInq: isOpen,
      isShowAtsInq: isOpen,
      isShowPOModule: isOpen,
      isShowPOReceiptModule: isOpen,
    });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
    // this.closeModalInquiryCallBack(false);
  };

  closeAlertAmountModalCallBack = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,
      isShowExtraChargePopup: isShowPopup,
      isShowNonMerchandisePopup: isShowPopup,
    });
  };

  openCustomerOnOrderInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerOnOrderInq: true,
        moduleForPopup: (
          <PopupCustomerOnOrderInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerTransactionsInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerTransactionsInq: true,
        moduleForPopup: (
          <PopupCustomerTransactionsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  openCustomerInfoInq_old = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerInfoInq: true,
        moduleForPopup: (
          <PopUpCustomerInfoInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerInfoInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      // this.setState({
      //   isShowCustomerInfoInq: true,
      //   moduleForPopup: (
      //     <PopUpCustomerInfoInq
      //       customerCode={code}
      //       onModuleExit={this.onPopupModalExit}
      //     />
      //   ),
      // });
      this.setState({
        isShowCustomerInfoInq: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  openCustomerStatisticsInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerStatisticsInq: true,
        moduleForPopup: (
          <PopupCustomerStatisticsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerSalesHistoryInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerSalesHistoryInq: true,
        moduleForPopup: (
          <PopupCustomerSalesHistoryInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerMostRecentFabricsInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerMostRecentFabricsInq: true,
        moduleForPopup: (
          <PopupCustomerMostRecentFabricsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerCurrentAgingInq = (code) => {
    if (code !== NEW_ENTRY && !isEmptyString(code)) {
      this.setState({
        isShowCustomerCurrentAgingInq: true,
        moduleForPopup: (
          <PopupCustomerCurrentAgingInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  /* ------------------Box AutoComplete --------------*/

  displayAutoCompleteBoxTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteBoxTypeList: showAutoCompleteList });
  };
  onBoxTypeChange = (e) => {
    let boxType = e.target.value;
    this.state.showAutoCompleteBoxTypeList = true;
    let temp_invoiceData = this.state.invoiceBoxLineData;
    let showAutoCompleteList = this.state.showAutoCompleteBoxTypeList;
    if (isEmpty(boxType)) {
      this.state.showAutoCompleteBoxTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBoxTypeList;

      temp_invoiceData.boxType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        invoiceData: temp_invoiceData,
        boxTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && boxType !== "") {
      this.readboxTypeBySearchString(boxType);
    }
    temp_invoiceData[e.target.name] = e.target.value;
    this.setState({
      invoiceBoxLineData: temp_invoiceData,
    });
    this.onBoxTypeChanges(boxType);
  };
  readboxTypeBySearchString(searchString) {
    let boxTypeData = this.state.boxTypes;
    let simpleAutoCompleteList = new Array();
    if (boxTypeData.length > 0 && boxTypeData != null) {
      boxTypeData.map((boxTypes) => {
        let simpleItemBean = {
          code: boxTypes.code,
          description: boxTypes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteBoxTypeLists) =>
        simpleAutoCompleteBoxTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ boxTypePageListForAutoCompleteList: filteredSuggestions });
  }
  boxTypeEnterKeyEventHandler = (e) => {
    let boxType = e.target.value;
    this.onBoxLineChange(e);
    this.setState({
      boxTypePageListForAutoCompleteList: new Array(),
    });
  };
  /* ---------------------------ShippingNode AutoComplete *---------------------*/
  onShipViaChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let invoiceData = this.state.invoiceData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmptyString(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let invoiceData = this.state.invoiceData;
      invoiceData.shipViaCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        invoiceData: invoiceData,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      invoiceData["shipViaCode"] = e.target.value;
      let shipViaList = this.state.shipVias;
      shipViaList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          invoiceData["shipViaCode"] = pdtType.code;
          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      invoiceData: invoiceData,
    });
  };
  readShipViaBySearchString(searchString) {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVias) => {
        let simpleItemBean = {
          code: shipVias.code,
          description: shipVias.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  shipViaEnterKeyEventHandler = (e) => {
    let invoiceData = this.state.invoiceData;
    invoiceData["shipViaCode"] = e.target.value;
    let shipViaCode_List = this.state.shipVias;
    let shipViaCodeBean = null;
    shipViaCode_List.map((ship) => {
      if (ship.code == e.target.value) {
        shipViaCodeBean = ship;
      }
    });
    if (!isEmpty(shipViaCodeBean)) {
      let invoiceData = this.state.invoiceData;
      invoiceData.shipViaCode = shipViaCodeBean.code;

      this.setState({
        invoiceData: invoiceData,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };

  onFreightMethodChange = (e) => {
    let freightMethodCode = e.target.value;
    this.state.showAutoCompleteFreightMethodList = true;

    let temp_invoiceData = this.state.invoiceData;
    let showAutoCompleteList = this.state.showAutoCompleteFreightMethodList;

    if (isEmpty(freightMethodCode)) {
      this.state.showAutoCompleteFreightMethodList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFreightMethodList;
      let temp_invoiceData = this.state.invoiceData;
      temp_invoiceData.freightMethodCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        invoiceData: temp_invoiceData,
        freightMethodPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && freightMethodCode !== "") {
      this.readFreightMethodBySearchString(freightMethodCode);
    }
    if (e.target.name == "freightMethodCode") {
      temp_invoiceData[e.target.name] = e.target.value;
      let freightMethodList = this.state.freightMethods;
      freightMethodList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_invoiceData["freightMethodCode"] = pdtType.code;
          this.state.showAutoCompleteFreightMethodList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteFreightMethodList;
          this.setState({
            showAutoCompleteFreightMethodList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      invoiceData: temp_invoiceData,
    });
  };
  readFreightMethodBySearchString(searchString) {
    let freightMethodData = this.state.freightMethods;
    let simpleAutoCompleteList = new Array();
    if (freightMethodData.length > 0 && freightMethodData != null) {
      freightMethodData.map((freightMethods) => {
        let simpleItemBean = {
          code: freightMethods.code,
          description: freightMethods.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      freightMethodPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  freightMethodEnterKeyEventHandler = (e) => {
    let invoiceData = this.state.invoiceData;
    invoiceData["freightMethodCode"] = e.target.value;
    let freightMethodCode_List = this.state.freightMethods;
    let freightMethodCodeBean = null;
    freightMethodCode_List.map((fm) => {
      if (fm.code == e.target.value) {
        freightMethodCodeBean = fm;
      }
    });
    if (!isEmpty(freightMethodCodeBean)) {
      let invoiceData = this.state.invoiceData;
      invoiceData.freightMethodCode = freightMethodCodeBean.code;

      this.setState({
        invoiceData: invoiceData,
        freightMethodPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteFreightMethodList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFreightMethodList: showAutoCompleteList });
  };

  onShipToChange = (e) => {
    let shipToCode = e.target.value;
    this.state.showAutoCompleteShipToList = true;

    let temp_invoiceData = this.state.invoiceData;
    let showAutoCompleteList = this.state.showAutoCompleteShipToList;

    if (isEmpty(shipToCode)) {
      this.state.showAutoCompleteShipToList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToList;
      let temp_invoiceData = this.state.invoiceData;
      temp_invoiceData.shipToCode = "";
      temp_invoiceData.address = new AddressBean();
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        invoiceData: temp_invoiceData,
        shipToPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipToCode !== "") {
      this.readShipToBySearchString(shipToCode);
    }
    if (e.target.name == "shipToCode") {
      temp_invoiceData[e.target.name] = e.target.value;
      this.readShipTo(shipToCode);
    }
    // if (e.target.name == "shipToCode") {
    //   temp_invoiceData[e.target.name] = e.target.value;
    //   let shipToList = this.state.shipTos;
    //   let shipToBean = null;
    //   shipToList.map((pdtType) => {
    //     if (pdtType.code == e.target.value) {
    //       shipToBean = pdtType;
    //       temp_invoiceData["shipToCode"] = pdtType.code;
    //       temp_invoiceData["shipToName"] = pdtType.description;
    //       temp_invoiceData.shipViaCode = shipToBean.shipViaCode;
    //       if (!isEmpty(shipToBean.address)) {
    //         let address = new AddressBean();
    //         address.address1 = shipToBean.address.address1;

    //         address.address1 = shipToBean.address.address1;
    //         address.address2 = shipToBean.address.address2;
    //         address.address3 = shipToBean.address.address3;
    //         address.city = shipToBean.address.city;
    //         address.country = shipToBean.address.country;
    //         address.state = shipToBean.address.state;
    //         address.zip = shipToBean.address.zip;
    //         address.phone1 = shipToBean.address.phone1;
    //         address.phone2 = shipToBean.address.phone2;
    //         address.mobilePhone = shipToBean.address.mobilePhone;
    //         temp_invoiceData.address = address;
    //       }
    //       this.state.showAutoCompleteShipToList = false;
    //       let showAutoCompleteList = this.state.showAutoCompleteShipToList;
    //       this.setState({ showAutoCompleteShipToList: showAutoCompleteList });
    //     }
    //   });
    // }

    this.setState({
      invoiceData: temp_invoiceData,
    });
  };
  readShipTo = (code) => {
    let temp_invoiceData = this.state.invoiceData;
    let shipToList = this.state.shipTos;
    let shipToBean = null;
    if (shipToList != null) {
      shipToList.map((pdtType) => {
        if (pdtType.code == code) {
          shipToBean = pdtType;
          temp_invoiceData["shipToCode"] = pdtType.code;
          temp_invoiceData["shipToName"] = pdtType.description;
          temp_invoiceData.shipViaCode = shipToBean.shipViaCode;
          if (!isEmpty(shipToBean.address)) {
            let address = new AddressBean();
            address.address1 = shipToBean.address.address1;

            address.address1 = shipToBean.address.address1;
            address.address2 = shipToBean.address.address2;
            address.address3 = shipToBean.address.address3;
            address.city = shipToBean.address.city;
            address.country = shipToBean.address.country;
            address.state = shipToBean.address.state;
            address.zip = shipToBean.address.zip;
            address.phone1 = shipToBean.address.phone1;
            address.phone2 = shipToBean.address.phone2;
            address.mobilePhone = shipToBean.address.mobilePhone;
            temp_invoiceData.address = address;
          }
          // this.state.showAutoCompleteShipToList = false;
          // let showAutoCompleteList = this.state.showAutoCompleteShipToList;
          // this.setState({ showAutoCompleteShipToList: showAutoCompleteList });
        }
      });
    }
    this.setState({ invoiceData: temp_invoiceData });
  };
  readShipToBySearchString(searchString) {
    let shipToData = this.state.shipTos;
    let simpleAutoCompleteList = new Array();
    if (shipToData.length > 0 && shipToData != null) {
      shipToData.map((shipTos) => {
        let simpleItemBean = {
          code: shipTos.code,
          description: shipTos.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipToPageListForAutoCompleteList: filteredSuggestions });
  }
  shipToEnterKeyEventHandler = (e) => {
    let temp_invoiceData = this.state.invoiceData;
    temp_invoiceData[e.target.name] = e.target.value;
    this.readShipTo(e.target.value);
    this.setState({
      invoiceData: temp_invoiceData,
      shipToPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteShipToList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToList: showAutoCompleteList });
  };

  /*--------------------------Address AutoComplete --------------------*/

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_invoiceData = this.state.invoiceData;
    if (temp_invoiceData.address == null) {
      temp_invoiceData.address = new AddressBean();
    }
    let temp_addressData = this.state.addressData;
    temp_addressData = temp_invoiceData.address;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      // let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData = temp_invoiceData.address;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cityList = this.state.cityList;
      cityList.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    temp_invoiceData.address = temp_addressData;
    this.setState({
      invoiceData: temp_invoiceData,
      addressData: temp_addressData,
    });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      let temp_invoiceData = this.state.invoiceData;
      temp_invoiceData.address = temp_addressData;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
        invoiceData: temp_invoiceData,
      });
    }
  };
  onCountryChange = (e) => {
    let countryCode = e.target.value;
    this.state.showAutoCompleteCountryList = true;
    let temp_invoiceData = this.state.invoiceData;
    if (temp_invoiceData.address == null) {
      temp_invoiceData.address = new AddressBean();
    }
    let temp_addressdata = this.state.addressData;
    temp_addressdata = temp_invoiceData.address;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(countryCode)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData = temp_invoiceData.address;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && countryCode !== "") {
      this.readcountryBySearchString(countryCode);
    }
    if (e.target.name == "country") {
      temp_addressdata["country"] = e.target.value;
      let country_List = this.state.countryList;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressdata["country"] = country.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    temp_invoiceData.address = temp_addressdata;
    this.setState({
      invoiceData: temp_invoiceData,
      addressData: temp_addressdata,
    });
  };
  readcountryBySearchString(searchString) {
    let countryData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let temp_addressdata = this.state.addressData;
    let countryCode = e.target.value;
    temp_addressdata["country"] = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressdata = this.state.addressData;
      temp_addressdata.country = countryBean.code;
      let temp_invoiceData = this.state.invoiceData;
      temp_invoiceData.address = temp_addressdata;
      this.setState({
        addressData: temp_addressdata,
        countryPageListForAutoCompleteList: new Array(),
        invoiceData: temp_invoiceData,
      });
    }
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let invoiceData = this.state.invoiceData;
    if (invoiceData.address == null) {
      invoiceData.address = new AddressBean();
    }
    let temp_addressData = this.state.addressData;
    temp_addressData = invoiceData.address;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;
      addressData = invoiceData.address;
      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.stateList;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }
    invoiceData.address = temp_addressData;
    this.setState({ invoiceData: invoiceData, addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;
    temp_addressData["state"] = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      let invoiceData = this.state.invoiceData;
      invoiceData.address = temp_addressData;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
        invoiceData: invoiceData,
      });
    }
  };

  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };

  /* ------------Invoice PaymentType AutoComplete --------------------*/

  onPaymentTypeChange = (e) => {
    let paymentTypeCode = e.target.value;
    this.state.showAutoCompletePaymentTypeList = true;
    let temp_arData = this.state.arData;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
    if (isEmpty(paymentTypeCode)) {
      this.state.showAutoCompletePaymentTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
      temp_arData.paymentTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        arData: temp_arData,
        paymentTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTypeCode !== "") {
      this.readPaymentTypeCodeBySearchString(paymentTypeCode);
    }
    this.setState({ arData: temp_arData });
    this.onARPaymentTypeChange(e);
  };
  readPaymentTypeCodeBySearchString(searchString) {
    let paymentTypeCodeData = this.state.paymentTypes;
    let simpleAutoCompleteList = new Array();
    if (paymentTypeCodeData.length > 0 && paymentTypeCodeData != null) {
      paymentTypeCodeData.map((paymentTypeCodeDatas) => {
        let simpleItemBean = {
          code: paymentTypeCodeDatas.code,
          description: paymentTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletepaymentTypeCodeDataLists) =>
        simpleAutoCompletepaymentTypeCodeDataLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      paymentTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  paymentTypeEnterKeyEventHandler = (e) => {
    let temp_arData = this.state.arData;
    let paymentTypeCode = e.target.value;
    temp_arData["paymentTypeCode"] = e.target.value;
    let paymentTypeCode_List = this.state.paymentTypes;
    let paymentTypeCodeBean = null;
    paymentTypeCode_List.map((paymentTypeCode) => {
      if (paymentTypeCode.code == e.target.value) {
        paymentTypeCodeBean = paymentTypeCode;
      }
    });
    if (!isEmpty(paymentTypeCodeBean)) {
      let temp_arData = this.state.arData;
      temp_arData.paymentTypeCode = paymentTypeCodeBean.code;
      this.setState({
        arData: temp_arData,
        paymentTypePageListForAutoCompleteList: new Array(),
      });
    }
    this.onARPaymentTypeChange(e);
  };
  displayAutoCompletePaymentTypeList = (list) => {
    this.setState({ showAutoCompletePaymentTypeList: list });
  };
  invoiceUomOnChange = (e) => {
    let uomCode = e.target.value;
    this.state.isShowAutoCompleteInvoiceUomList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    if (isEmpty(uomCode)) {
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.uomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        invoiceUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "uomCode" &&
      showAutoCompleteList === true &&
      uomCode !== ""
    ) {
      this.readInvoiceUomBySearchString(e.target.value);
      this.readInvoiceUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ serviceDetail: tempData });
  };
  invoiceUomEnterKeyEvent = (e) => {
    this.readInvoiceUom(e.target.value);
    this.state.isShowAutoCompleteInvoiceUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    this.setState({
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
    });
  };
  displayInvoiceUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteInvoiceUomList: isShowAutoCompleteList,
    });
  };
  readInvoiceUomBySearchString = (searchString) => {
    let uomData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      invoiceUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readInvoiceUom = (uomCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let uomBean = null;
    let uomData = null;
    this.state.uoms.map((ln) => {
      if (ln.code === uomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.uomCode = uomBean.code;
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      this.setState({
        serviceDetail: tempData,
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
      });
    }
  };

  serviceOnChange = (e) => {
    let serviceCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(serviceCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.serviceCode = "";
      tempData.serviceName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "serviceCode" &&
      showAutoCompleteList === true &&
      serviceCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ invoiceServiceLineData: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (serviceCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let serivceBean = null;
    let serviceData = null;
    this.state.services.map((ln) => {
      if (ln.code === serviceCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });
    if (!isEmpty(serivceBean)) {
      const customerServicesList = this.state.customerServicesList;
      let service_bean = new BaseBean();
      if (!isEmptyArray(customerServicesList)) {
        const result = customerServicesList.filter(
          (service) => service.code === serviceCode
        );
        service_bean = result[0];
      }
      tempData.serviceCode = serivceBean.code;
      tempData.serviceName = serivceBean.description;
      tempData.uomCode = serivceBean.uomCode;
      if (
        !isEmpty(service_bean) &&
        service_bean.price != null &&
        service_bean.price > 0
      )
        tempData.unitPrice = service_bean.price;
      else tempData.unitPrice = serivceBean.price;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        invoiceServiceLineData: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };

  onPickTicketLineChange = (e) => {
    let sourcePickTicketNumber = e.target.value;
    this.state.showAutoCompletePickTicketList = true;
    let invoiceLineData = this.state.invoiceLineData;
    let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
    if (isEmpty(sourcePickTicketNumber)) {
      this.state.showAutoCompletePickTicketList = false;
      let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
      let invoiceLine = this.state.invoiceLineData;
      invoiceLine.sourcePickTicketNumber = "";
      // invoiceLine.sourcePickTicketLineNumber="";
      // invoiceLine.fabricStyleCode = "";
      // invoiceLine.fabricStyleName="";
      // invoiceLine.colorCode="";
      invoiceLine.sourcePickTicketLineNumber = "";
      invoiceLineData.fabricStyleCode = "";
      invoiceLineData.fabricStyleName = "";
      invoiceLineData.colorCode = "";
      invoiceLineData.widthCode = "";
      invoiceLineData.skuNumber = 0;
      invoiceLineData.uomConversionRate = 0;
      invoiceLineData.uomCode = "";
      invoiceLineData.price = 0;
      invoiceLineData.inventoryUomCode = "";
      invoiceLineData.shippedQuantity = 0;
      invoiceLineData.onOrderQuantity = 0;
      invoiceLineData.currencyCode = "";
      invoiceLineData.onHandQuantity = 0;
      invoiceLineData.sourceSalesOrderNumber = "";
      invoiceLineData.sourceSalesOrderLineNumber = 0;
      invoiceLineData.rollLines = [];
      invoiceLineData.lineTotalAmount = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        invoiceLineData: invoiceLine,
        pickTicketPageListForAutoCompleteList: suggestion,
        isShowPtLineLookup: false,
      });
      this.clearInvoiceLine(e);
    } else if (
      e.target.name == "sourcePickTicketNumber" &&
      showAutoCompleteList === true &&
      sourcePickTicketNumber !== ""
    ) {
      this.readPickTicketBySearchString(e.target.value);
    }
    invoiceLineData[e.target.name] = e.target.value;
    this.setState({ invoiceLineData: invoiceLineData });
    //this.readPickTicket(sourcePickTicketNumber);
  };
  readPickTicketBySearchString(searchString) {
    let searchCriteria = new PickTicketSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.pickTicketStartsWith = searchString;
    searchCriteria.pickTicketContains = searchString;
    let pt_pageList = new PageListBean();
    pt_pageList.pageSize = 100;
    let pt_requestInput = new RestPickTicketListRequest();
    pt_requestInput.pageInput = pt_pageList;
    pt_requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      PickTicketService.getPickTicketPageList(
        pt_requestInput,
        this.readByPickTicketCodeResponse,
        this.readByPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByPickTicketCodeResponse = (response) => {
    let pickTicketData = response.data.pickTicketPageList.pickTickets;
    let simpleAutoCompleteList = new Array();
    if (pickTicketData.length > 0 && pickTicketData != null) {
      pickTicketData.map((pickTicket) => {
        let simpleItemBean = {
          code: pickTicket.code,
          description: pickTicket.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      pickTicketPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByPickTicketError = (error) => {
    ShowError("Error : " + error);
  };
  readPickTicketResponse = (response) => {
    let pickTicketData = response.data.pickTicket;
    if (pickTicketData != null) {
      this.setState({
        pickTicketData: pickTicketData,
      });

      let pickTicketLineLookupHandler = new PickTicketLineLookupHandler(
        this.companyCode,
        "PickTicketLine",
        pickTicketData.code
      );
      this.setState({
        pickTicketLineLookupHandler: pickTicketLineLookupHandler,
        isShowPtLineLookup: true,
      });
    }
  };
  readPickTicketError = (error) => {
    ShowError("Erro : " + error);
  };
  readPickTicket = (sourcePickTicketNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = sourcePickTicketNumber;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      PickTicketService.readPickTicket(
        readrestInput,
        this.readPickTicketResponse,
        this.readPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  pickTicketCodeEnterKeyEventHandler = (e) => {
    let sourcePickTicketNumber = e.target.value;
    this.readPickTicket(sourcePickTicketNumber);
    this.setState({
      pickTicketPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePickTicketList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePickTicketList: showAutoCompleteList });
  };
  onPtLineChange_bkup = (e) => {
    let invoiceLineData = this.state.invoiceLineData;
    invoiceLineData[e.target.name] = e.target.value;

    this.setState({ invoiceLineData: invoiceLineData });
    this.readPickTicketLines();
  };
  onPtLineChange = (e) => {
    let { name, value } = e.target;

    let invoiceLineData = { ...this.state.invoiceLineData };
    invoiceLineData[name] = value;

    this.setState({ invoiceLineData }, () => {
      if (name === "sourcePickTicketLineNumber") {

        if (value && value.trim() !== "") {
          // when value exists
          this.readPickTicketLines();
        } else {
          invoiceLineData.fabricStyleCode = "";
          invoiceLineData.fabricStyleName = "";
          invoiceLineData.colorCode = "";
          invoiceLineData.widthCode = "";
          invoiceLineData.skuNumber = 0;
          invoiceLineData.uomConversionRate = 0;
          invoiceLineData.uomCode = "";
          invoiceLineData.price = 0;
          invoiceLineData.inventoryUomCode = "";
          invoiceLineData.shippedQuantity = 0;
          invoiceLineData.onOrderQuantity = 0;
          invoiceLineData.currencyCode = "";
          invoiceLineData.onHandQuantity = 0;
          invoiceLineData.sourceSalesOrderNumber = "";
          invoiceLineData.sourceSalesOrderLineNumber = 0;
          invoiceLineData.rollLines = [];
          invoiceLineData.lineTotalAmount = 0;

          this.setState({ invoiceLineData });
        }

      }
    });
  };
  readPickTicketLines = () => {
    let pickTicketData = this.state.pickTicketData;
    let invoiceLineData = this.state.invoiceLineData;
    let invoiceData = this.state.invoiceData;
    pickTicketData.pickTicketLines.map((ln) => {
      if (
        invoiceLineData.sourcePickTicketLineNumber == ln.pickTicketLineNumber
      ) {
        invoiceLineData.fabricStyleCode = ln.fabricStyleCode;
        invoiceLineData.fabricStyleName = ln.fabricStyleName;
        invoiceLineData.colorCode = ln.colorCode;
        invoiceLineData.widthCode = ln.widthCode;
        invoiceLineData.skuNumber = ln.skuNumber;
        invoiceLineData.uomConversionRate = ln.uomConversionRate;
        invoiceLineData.uomCode = ln.orderUomCode;
        invoiceLineData.price = ln.price;
        invoiceLineData.inventoryUomCode = ln.inventoryUomCode;
        invoiceLineData.shippedQuantity = ln.toBePickedQuantity;
        invoiceLineData.onOrderQuantity = ln.orderQuantity;
        invoiceLineData.currencyCode = ln.currencyCode;
        if (ln.onHandQuantity == null) {
          ln.onHandQuantity = 0;
        }
        invoiceLineData.onHandQuantity = ln.onHandQuantity;
        invoiceLineData.sourceSalesOrderNumber = ln.salesOrderNumber;
        invoiceLineData.sourceSalesOrderLineNumber = ln.salesOrderLineNumber;
        // invoiceLineData.rollLines = ln.rollLines;
        let invoiceRollLineNumber = 0;
        let rollLines = [];
        // var lineNumber = this.getMaxLineNumberInvoiceLines();
        let lineNumber = 0;
        let lines = invoiceData.lines;
        lines.map((line) => {
          if (line.lineNumber > lineNumber) {
            lineNumber = line.lineNumber;
          }
        });
        lineNumber++;
        if (ln.rollLines != null) {
          ln.rollLines.map((roll) => {
            let rollLine = new InvoiceRollLineBean();
            rollLine.companyCode = this.companyCode;
            rollLine.invoiceNumber = invoiceLineData.invoiceNumber;

            rollLine.customerCode = invoiceData.customerCode;
            rollLine.customerName = invoiceData.customerName;
            // invoiceRollLineNumber = ln.rollLines.length + 1;
            // rollLine.invoiceRollLineNumber = invoiceRollLineNumber++;
            rollLine.invoiceRollLineNumber = roll.pickTicketRollLineNumber;
            rollLine.invoiceLineNumber = lineNumber;
            rollLine.sourcePickTicketNumber =
              invoiceLineData.sourcePickTicketNumber;
            rollLine.sourcePickTicketLineNumber =
              invoiceLineData.sourcePickTicketLineNumber;
            rollLine.fabricStyleCode = invoiceLineData.fabricStyleCode;
            rollLine.fabricStyleName = invoiceLineData.fabricStyleName;
            rollLine.colorCode = invoiceLineData.colorCode;
            rollLine.widthCode = invoiceLineData.widthCode;
            rollLine.skuNumber = invoiceLineData.skuNumber;
            rollLine.rollSkuNumber = roll.rollSkuNumber;
            rollLine.rollNumber = roll.rollNumber;
            rollLine.purchasOrderNumber = roll.purchasOrderNumber;
            rollLine.purchaseOrderReceiptNumber =
              roll.purchaseOrderReceiptNumber;
            rollLine.vendorBatchNumber = roll.vendorBatchNumber;
            rollLine.vendorCode = "";
            rollLine.boxNumber = roll.boxNumber;
            rollLine.availableQuantity = roll.availableQuantity;
            rollLine.locationCode = roll.locationCode;
            rollLine.invoiceUomCode = roll.inventoryUomCode;
            rollLine.inventoryUomCode = roll.inventoryUomCode;
            rollLine.uomConversionRate = roll.uomConversionRate;
            rollLine.shippedQuantity = invoiceLineData.shippedQuantity;
            rollLine.isCloseOutInventory = roll.closeOutInventory;
            rollLine.binLocation = roll.binLocation;

            rollLine.isApplied = false;
            rollLines.push(rollLine);
          });

          invoiceLineData.rollLines = rollLines;
        }

        invoiceLineData.lineTotalAmount =
          invoiceLineData.price * invoiceLineData.shippedQuantity;
      }
    });
    this.setState({ invoiceLineData: invoiceLineData });
  };

  onPaymentTermChange = (e) => {
    let paymentTermCode = e.target.value;
    this.state.showAutoCompletePaymentTermList = true;
    let invoiceData = this.state.invoiceData;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
    if (isEmpty(paymentTermCode)) {
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      let invoiceData = this.state.invoiceData;
      invoiceData.paymentTermCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePaymentTermList: showAutoCompleteList,
        invoiceData: invoiceData,
        paymentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTermCode !== "") {
      this.readPaymentTermCodeBySearchString(paymentTermCode);
    }
    if (e.target.name == "paymentTermCode") {
      invoiceData["paymentTermCode"] = e.target.value;
      let paymentTermsCode_List = this.state.paymentTerms;
      paymentTermsCode_List.map((paymentTermCode) => {
        if (paymentTermCode.code == e.target.value) {
          invoiceData["paymentTermCode"] = paymentTermCode.code;

          this.state.showAutoCompletePaymentTermList = false;
          let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
          this.setState({
            showAutoCompletePaymentTermList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ invoiceData: invoiceData });
  };

  readPaymentTermCodeBySearchString(searchString) {
    let paymentTermCodeData = this.state.paymentTerms;
    let simpleAutoCompleteList = new Array();
    if (paymentTermCodeData.length > 0 && paymentTermCodeData != null) {
      paymentTermCodeData.map((paymentTermCodeDatas) => {
        let simpleItemBean = {
          code: paymentTermCodeDatas.code,
          description: paymentTermCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletepaymentTypeCodeDataLists) =>
        simpleAutoCompletepaymentTypeCodeDataLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      paymentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  paymentTermEnterKeyEventHandler = (e) => {
    let invoiceData = this.state.invoiceData;
    let paymentTermCode = e.target.value;
    invoiceData["paymentTermCode"] = e.target.value;
    let paymentTermsCode_List = this.state.paymentTerms;
    let paymentTermCodeBean = null;
    paymentTermsCode_List.map((paymentTermCode) => {
      if (paymentTermCode.code == e.target.value) {
        paymentTermCodeBean = paymentTermCode;
      }
    });
    if (!isEmpty(paymentTermCodeBean)) {
      let invoiceData = this.state.invoiceData;
      invoiceData.paymentTermCode = paymentTermCodeBean.code;
      this.setState({
        invoiceData: invoiceData,
        paymentTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePaymentTermList: showAutoCompleteList });
  };
  openItemPurchaseHistoryInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== NEW_ENTRY && !isEmptyString(code)) {
        this.setState({
          isShowFabricPurchaseHistoryInq: true,
          moduleForPopup: (
            <PopupFabricPurchaseHistoryInq
              fabricCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openFabricSalesHistoryInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== NEW_ENTRY && !isEmptyString(code)) {
        this.setState({
          isShowCustomerSalesHistoryInq: true,
          moduleForPopup: (
            <PopupCustomerSalesHistoryInq
              fabricCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemInvPositionInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== NEW_ENTRY && !isEmptyString(code)) {
        this.setState({
          isShowItemInventoryPositionInq: true,
          moduleForPopup: (
            <PopupFabricInventoryPositionInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openItemCurrentInvInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== NEW_ENTRY && !isEmptyString(code)) {
        this.setState({
          isShowItemCurrentInventoryInq: true,
          moduleForPopup: (
            <PopupItemCurrentInventoryInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openAtsInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== NEW_ENTRY && !isEmptyString(code)) {
        this.setState({
          isShowAtsInq: true,
          moduleForPopup: (
            <PopupAtsInq code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let invoiceList = this.state.invoiceList;
    if (sortField && !isEmptyArray(invoiceList)) {
      const sorted = [...invoiceList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ invoiceList: sorted });
    }
  };
  handleRollLinesSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleRollLineSorting(sortField, sortOrder);
  };
  handleRollLineSorting = (sortField, sortOrder) => {
    let invoiceLineData = this.state.invoiceLineData;

    if (sortField && !isEmptyArray(invoiceLineData.rollLines)) {
      const sorted = [...invoiceLineData.rollLines].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      invoiceLineData.rollLines = sorted;
      this.setState({ invoiceLineData: invoiceLineData });
    }
  };

  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value.toUpperCase();
    this.state.showAutoCompleteCustomerList = true;
    let tempInvoiceData = this.state.invoiceData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let invoice_data = this.state.invoiceData;
      invoice_data.customerCode = "";
      invoice_data.customerName = "";

      invoice_data.paymentTermCode = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        invoiceData: invoice_data,
        customerPageListForAutoCompleteList: suggestion,

        isCustomerNotFound: false,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempInvoiceData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ invoiceData: tempInvoiceData });
    // this.readCustomer(customerCode);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  isFound = (data) => {
    var found = false;
    if (!data.isActive) {
      found = true;
    }
    return found;
  };
  // readCustomerResponse = (response) => {
  //   const customerData = response.data.customer;
  //   if (customerData != null) {
  //     this.setState({ customerData: customerData });
  //     const isFound = this.isFound(customerData);
  //     if (isFound) {
  //       this.setState({ isCustomerNotFound: true });
  //       let errMsg = "Customer is InActive";
  //       let errList = [];
  //       errList.push(errMsg);

  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     } else {
  //       this.setState({ isCustomerNotFound: false });
  //     }
  //     this.customerSelected();
  //   } else {
  //     this.setState({ isCustomerNotFound: true });
  //   }
  // };

  readCustomerResponse = (response) => {
    const customerData = response.data.customer;
    if (customerData != null) {

      this.setState({ customerData: customerData, }, () => {
        const isFound = this.isFound(customerData);
        if (isFound) {
          this.setState({ isCustomerNotFound: true });
          let errMsg = "Customer is InActive";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        } else {
          this.setState({ isCustomerNotFound: false });
        }
        this.customerSelected();
      });

    } else {
      this.setState({ isCustomerNotFound: true });
    }
  };

  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  customerSelected() {
    let invoice_Data = this.state.invoiceData;
    let customerData = this.state.customerData;
    this.state.showAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    let shipTos = [];
    if (!isEmpty(customerData)) {
      invoice_Data.customerCode = customerData.code;
      invoice_Data.customerName = customerData.description;
      invoice_Data.paymentTermCode = customerData.paymentTermsCode;
      invoice_Data.invoiceCurrencyCode = customerData.currencyCode;
      invoice_Data.companyCurrencyCode = customerData.currencyCode;
      invoice_Data.divisionCode = customerData.divisionCode;
      invoice_Data.customerDivisionCode = customerData.divisionCode;
      invoice_Data.businessDivision = customerData.businessDivision;
      invoice_Data.customerType = customerData.customerTypeCode;
      invoice_Data.customerDeliveryTypeCode =
        customerData.customerDeliveryTypeCode;
      invoice_Data.address = customerData.address;
      if (!isEmpty(invoice_Data.billToCode))
        invoice_Data.billToCode = customerData.billTos.code;
      if (!isEmpty(invoice_Data.shipToCode))
        invoice_Data.shipToCode = customerData.shipTos.code;
      if (isEmptyString(invoice_Data.billToCode))
        invoice_Data.billToCode = "B1001";
      if (isEmptyString(invoice_Data.shipToCode))
        invoice_Data.shipToCode = "S1001";
      if (isEmptyString(invoice_Data.businessDivision))
        invoice_Data.businessDivision = "$$$";
      invoice_Data.divisionCode = "N/A";

      if (invoice_Data.lines !== null && invoice_Data.lines.length > 0) {
        invoice_Data.lines.map((line) => {
          if (isEmptyString(line.customerCode)) {
            line.customerCode = customerData.code;
          }
          if (isEmptyString(line.customerName)) {
            line.customerName = customerData.description;
          }
        });
      }
      invoice_Data.taxRequiredFlag = customerData.salesTaxRequiredFlag;
      if (invoice_Data.taxRequiredFlag) {
        let taxPercentage = ConfigManager.getSalesTaxPercentage();
        invoice_Data.taxPercentage = taxPercentage;
      } else {
        invoice_Data.taxPercentage = 0;
      }
    }

    this.setState({
      invoiceData: invoice_Data,
    });
  }
  customerCleared() {
    let customerData = new CustomerBean();

    this.setState({
      customerData: customerData,
    });
  }
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  render() {
    let invoiceData = this.state.invoiceData;
    let invoiceList = this.state.invoiceList;
    let invoiceLineData = this.state.invoiceLineData;
    let invoiceBoxLineData = this.state.invoiceBoxLineData;
    let isLoading = this.state.isLoading;
    let disableInvoiceFormFields = this.state.isDisableFields;

    let isModify = false;
    isModify = this.isModifyPosible();

    let rollLines = [];
    if (!isEmpty(invoiceLineData) && !isEmptyArray(invoiceLineData.rollLines)) {
      rollLines = invoiceLineData.rollLines;
    }
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    let inventories = [];
    if (
      !isEmpty(this.state.inventoryData) &&
      !isEmptyArray(this.state.inventoryData.inventoryDataDetails)
    ) {
      inventories = this.state.inventoryData.inventoryDataDetails;
    }
    let invoiceStatus = "";
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.invoiceStatus))
      invoiceStatus = ModuleUtils.getInvoiceStatusCaption(
        invoiceData.invoiceStatus
      );
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "9em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let mailInfoData = this.state.mailInfoData;
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowMailInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertPopupModalCallBack}
          title={"Mailing Sales Invoice"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hidePopupAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.mailInvoiceContinue(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div className="PurchaseOrderPopup">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>From</FormLabel>
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="from"
                      value={mailInfoData.from}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>TOs</FormLabel>
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="tos"
                      value={mailInfoData.tos}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>CCs</FormLabel>
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="ccs"
                      value={mailInfoData.ccs}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>BCCs</FormLabel>
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="bccs"
                      value={mailInfoData.bccs}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Title</FormLabel>
                  </Col>
                  <Col sm="5">
                    <InputTextbox
                      name="title"
                      value={mailInfoData.title}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Attachments</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="message"
                      type="text"
                      onChange={this.onChange}
                      value={mailInfoData.message}
                    />
                  </Col>
                </Row>
                <Row></Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowModifyCommentPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertPopupModalCallBack}
          title={"Modify Comments"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hidePopupAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.modifyCommentsContinue(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div className="PurchaseOrderPopup">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>SalesInvoive#</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox value={invoiceData.code} disabled={true} />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Date</FormLabel>
                  </Col>

                  <Col sm="2">
                    <InputTextbox
                      value={invoiceData.invoiceDate}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Customer</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={invoiceData.customerCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={invoiceData.customerName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="comments"
                      type="text"
                      onChange={this.onChange}
                      value={invoiceData.comments}
                      isModifyView={isModify}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <ModuleToolBar
          isShowNewButton={false}
          // onNewEntry={() => this.openEntryForm()}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          // isMaintenanceMode={!this.state.isListFormOpen}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editInvoice}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.invoiceLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          isSpecialViewMode={this.state.isSpecialViewMode}
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              // set InvoiceToolBar to BaseToolBar
              extend_toolbar={
                <InvoiceModuleToolBar
                  cancelInvoice={this.cancelInvoice}
                  approveInvoice={this.approveInvoice}
                  unApproveInvoice={this.unApproveInvoice}
                  payInvoice={this.payInvoice}
                  modifyInvoice={this.modifyInvoice}
                  printNafta={this.printNafta}
                  commInv={this.commInv}
                  modifyComment={this.modifyComment}
                  // mailInvoice={this.mailInvoice}
                  generateSalesComm={this.generateSalesComm}
                  // isShowMailInvoiceButton={this.state.isShowMailInvoiceButton}
                  isShowModifyCommentButton={
                    this.state.isShowModifyCommentButton
                  }
                  isShowGenerateSalesCommButton={
                    this.state.isShowGenerateSalesCommButton
                  }
                  isShowCommInvButton={this.state.isShowCommInvButton}
                  isShowModifyButton={this.state.isShowModifyButton}
                  isShowPrintNaftaButton={this.state.isShowPrintNaftaButton}
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowApproveButton={this.state.isShowApproveButton}
                  isShowUnApproveButton={this.state.isShowUnApproveButton}
                  isShowPayButton={this.state.isShowPayButton}
                />
              }
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              //isShowBackButton={this.state.isShowBackButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isShowModuleSearchContainer={
                this.state.isShowModuleSearchContainer
              }
              onModuleKeyContainerButtonClick={this.editInvoice}
              moduleKeyCode={this.state.moduleKeyCode}
              onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            />
          )}
        {/* {isLoading ? <Loader /> : null} */}
        <BaseNotification errorList={this.state.errorList} />
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={invoiceStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {!this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isListFormOpen &&
          !this.state.isSpecialViewMode &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getListView()}
        {!this.state.isEntryFormOpen &&
          !this.state.isListFormOpen &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isShippingInformationFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getShippingInformationView()}
        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          this.state.isPaymentDetailsFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getPaymentDetailsView()}
        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isPaymentHistoryFormOpened &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getPaymentHistoryView()}
        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isPaymentDetailsFormOpened &&
          this.state.isCommissionFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getCommissionView()}
        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isCommissionFormOpened &&
          this.state.isChangesHistoryFormOpened &&
          !this.state.isServiceFormOpened &&
          this.getChangesHistoryView()}
        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isPaymentDetailsFormOpened &&
          !this.state.isPaymentHistoryFormOpened &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isServiceFormOpened &&
          this.getServiceView()}
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel0"}
            isModulePopup={false}
            isShowPopup={this.state.isShowLinePopup}
            closeOnEsc={true}
            closeAlertModalCallBack={this.closeAlertPopupModalCallBack}
            title={"LINE DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                {/* {this.state.isDisabledFields != true && !this.state.is3PL && ( */}
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.updateLine(e)}
                >
                  Add/Update
                </Button>
                {/* )} */}
                {/* {this.state.isDisabledFields != true && !this.state.is3PL && ( */}
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.clearInvoiceLine(e)}
                >
                  clear
                </Button>
                {/* )} */}
              </div>
            }
            content={
              <InvoiceLinePopupForm
                {...this.state}
                onChange={this.onChange}
                lnkFabricStyleModule={this.lnkFabricStyleModule}
                onLineChange={this.onLineChange}
                onRollLineShippedQtyChange={this.onRollLineShippedQtyChange}
                onRollLineShippedQtyBlur={this.onRollLineShippedQtyBlur}
                onRollSelectedChange={this.onRollSelectedChange}
                isModifyPosible={this.isModifyPosible}
                onPickTicketLineChange={this.onPickTicketLineChange}
                pickTicketCodeEnterKeyEventHandler={
                  this.pickTicketCodeEnterKeyEventHandler
                }
                displayAutoCompletePickTicketList={
                  this.displayAutoCompletePickTicketList
                }
                onPtLineChange={this.onPtLineChange}
                openFabricSalesHistoryInq={this.openFabricSalesHistoryInq}
                openItemPurchaseHistoryInq={this.openItemPurchaseHistoryInq}
                openItemInvPositionInq={this.openItemInvPositionInq}
                openItemCurrentInvInq={this.openItemCurrentInvInq}
                openAtsInq={this.openAtsInq}
                handleSortingChange={this.handleRollLinesSortingChange}
              />
            }
          />
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowBoxPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertPopupModalCallBack}
            title={"BOX DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addorupdateBoxLine(e)}
                  disabled={disableInvoiceFormFields}
                >
                  Update
                </Button>

                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.clearBoxLineValues(e)}
                  disabled={disableInvoiceFormFields}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <ShippingBoxPopupForm
                {...this.state}
                onChange={this.onChange}
                onBoxLineChange={this.onBoxLineChange}
                isModifyPosible={this.isModifyPosible}
                displayAutoCompleteBoxTypeList={
                  this.displayAutoCompleteBoxTypeList
                }
                boxTypeEnterKeyEventHandler={this.boxTypeEnterKeyEventHandler}
                onBoxTypeChange={this.onBoxTypeChange}
              />
            }
          />
        </div>
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPaymentPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"PAYMENT DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.onPayClick(e)}
                >
                  Pay
                </Button>
              </div>
            }
            content={
              <InvoicePaymentPopupForm
                {...this.state}
                onCardDetailsChange={this.onCardDetailsChange}
                onARChange={this.onARChange}
                onCheckDetailsChange={this.onCheckDetailsChange}
                onWireTransferDetailsChange={this.onWireTransferDetailsChange}
                onChange={this.onChange}
                onARPaymentTypeChange={this.onARPaymentTypeChange}
                onPaymentTypeChange={this.onPaymentTypeChange}
                paymentTypeEnterKeyEventHandler={
                  this.paymentTypeEnterKeyEventHandler
                }
                displayAutoCompletePaymentTypeList={
                  this.displayAutoCompletePaymentTypeList
                }
                onCustomerCreditCardDetailsChange={
                  this.onCustomerCreditCardDetailsChange
                }
              />
            }
          />

          {/* Fabric Shortcut Menu Popup :*/}
        </div>
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Invoice Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.unApproveReasonDialogRef}
          reasons={this.state.unApproveReasons}
          reasonData={this.state.reasonData}
          title="Invoice UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerTransactionsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerStatisticsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerCurrentAgingInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerInfoInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          closeOnDocumentClick={false}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemInventoryPositionInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemCurrentInventoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowAtsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerSalesHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPOModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPOReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class InvoiceListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceCriteria: new InvoiceSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
  }

  onChange = (e) => {
    this.props.onCriteriaChange(e);
  };

  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterInvoice();
    }
  };

  advanceSearch = () => {
    this.props.advanceSearch();
  };

  filterInvoice = (e) => {
    if (e.detail == 1) this.props.filterInvoice();
  };

  resetFilteredInvoice = (e) => {
    let invoiceCriteria = this.props.invoiceCriteria;
    if (e.detail == 1) this.props.resetFilteredInvoice(invoiceCriteria);
  };

  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };

  handleInvoiceCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };

  handleHyperLinkClick = (e, val) => {
    if (e.detail == 1) this.props.editInvoice(val);
  };

  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };


  invoicePageColumns = () => {

    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.handleHyperLinkClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("pickTicket#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerCode", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      // .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyles", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      // .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustPO#", "customerPurchaseOrderNumber", true,)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "invoiceStatus", true,)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption)
    );


    return columns;
  }
  getCaption = (status) => {
    return ModuleUtils.getInvoiceStatusCaption(status);
  };
  render() {
    let invoiceList = new Array();
    if (!isEmptyArray(this.props.invoiceList))
      invoiceList = this.props.invoiceList;
    let invoiceCriteria = this.props.invoiceCriteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    let isLoading = this.props.isLoading;
    let criteriaString = ""; //To-Do Need to Change

    let isAdvanceSearch = this.props.isAdvanceSearch;

    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <FormControl
                name="searchName"
                type="text"
                value={invoiceCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterInvoice(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilteredInvoice(e)}>
              Reset
            </Button>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="invoiceStatus"
                value={invoiceCriteria.invoiceStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"F"}>Paid</option>
                <option value={"P"}>Partially Paid</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={invoiceCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterInvoice(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetFilteredInvoice(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>


        {isAdvanceSearch && (
          <div className="secondary_module_header">{criteriaString}</div>
        )}
        <div className="mt-3">
          <CustomTable
            data={invoiceList}
            columns={this.invoicePageColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            searchText={invoiceCriteria.searchName} // Search input text
            enableVirtualization={true} // Example of enabling virtualization
          />
        </div>

      </div>
    );
  }
}

class InvoiceEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.itemCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();

    this.state = {
      invoiceData: this.props.invoiceData,
      customerData: new CustomerBean(),
      isInvoiceLineAddOpen: false,
      invoiceLineData: new InvoiceLineBean(),
      isItemDataLoding: false,
      itemList: [],
      isCustomerDataLoding: false,
      customerList: [],
      isLineEditMode: false,
      customerData: new CustomerBean(),
      orderTypes: this.props.orderTypes,
      paymentTerms: this.props.paymentTerms,
      warehouses: this.props.warehouses,
      selected_item_data: new FabricStyleBean(),
      open: false,
      isShowPickTicketModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      //isShowARModule: false,
      isShowCreditMemoModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],

      // isShowCustomerTransactionPopup: false,
      // isShowCustomerSalesHistoryPopup: false,
      // isShowCustomerStatisticsPopup: false,
      // isShowCustomerRecentFabricPopup: false,
      // isShowCustomerCurrentAgingPopup: false,
      // isShowInvoiceAmountPopup: false,
      // isShowInvoiceAppliedAmountPopup: false,
      // isShowInvoiceAppliedCMAmountPopup: false,
      // isShowRecentInvoicePopup: false,
      // isShowCreditMemoAppliedAmountPopup: false,

      isShowARModule: false,
      invoiceList: [],
      // agingInvoiceList: [],
      // creditMemoList: [],
      // customerCreditMemoList: [],
      // customerSalesDataList: [],
      // readARAppliedList: [],
      // recentFabricList: [],
      // customerStatisticsList: [],
      // customerAgingList: [],
      // recentInvoiceList: [],
      // readARCreditMemoList: [],
      // stAgingBucketList: [],
      // stAgingHistoryBean: [],
      // onOrderInfoDetail: [],
      // salesDetail: [],
      // returnCreditMemo: [],
      // agingHistoryBean: new BaseCustomerPaymentAgingHistoryBean(),
      // agingDataList: [],
      // statisticData: "",
      // summaryData: "",
      // isShowCustomerOnOrderPopup: false,
      // customerOnOrderList: [],
      // error_list: [],
      isShowPopup: false,
      customerLookupHandler: null,
    };
    this.paymentTermRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    // let currencyLookupHandler = new GenericAttributeLookupHandler(
    //   this.props.currencies,
    //   "Currency"
    // );
    // this.setState({ currencyLookupHandler: currencyLookupHandler });

    // let printoutTypeLookupHandler = new GenericAttributeLookupHandler(
    //   this.props.invoicePrintoutTypes,
    //   "Invoice PrintOut Type"
    // );
    // this.setState({ printoutTypeLookupHandler: printoutTypeLookupHandler });

    // let patternTypeLookupHandler = new GenericAttributeLookupHandler(
    //   this.state.patternTypes,
    //   "Commodity"
    // );
    // this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
  };

  componentDidUpdate() {
    //
  }
  readCustomerResponse = (response) => {
    let customerData = response.data.customer;
    if (customerData != null) {
      let summary = customerData.accountSummary;
      this.setState({ customerData: customerData, summaryData: summary });
    }
  };
  readCustomerError = (error) => { };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();

    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerResponse,
        this.readCustomerError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onInvoiceLineTableChange = (e, line) => {
    this.props.onInvoiceLineTableChange(e, line);
  };

  onHeaderAmountsChange = (e) => {
    this.props.onHeaderAmountsChange(e);
  };

  onChange = (e) => {
    this.props.onChange(e);
  };

  onShipmentChargesAmountKeydown = (event) => {
    if (event.keyCode == 13) {
      this.customerCodeRef.current.focus();
    }
  };
  onLineAmountsChange = (e) => {
    this.props.onLineAmountsChange(e);
  };

  getLineDetails = (invoiceLinedata) => {
    this.props.getLineDetails(invoiceLinedata);
  };

  clearItemCodeRef = () => {
    this.itemCodeRef.current.clearValue();
  };

  focusCustomerCode = () => {
    this.customerCodeRef.current.focus();
  };

  setInputFocus() {
    this.customerCodeRef.current.focus();
  }

  //#region InvoiceLineTable using BootStrapTable

  lnkLineDetailsClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.lnkLineDetailsClick(rowData);
  };

  buttonClickCallback = (e, rowData) => {
    this.cancelInvoiceLine(rowData);
  };

  editPriceClickCallback = (e, rowData) => {
    this.editLinePrice(rowData);
  };
  deleteInvoiceLine = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteInvoiceLine(rowData);
  };

  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "",
  //         <DeleteIcon />,
  //         // true,
  //         1,
  //         false,
  //         null,
  //         false,
  //         null, //image link call back
  //         "1em", //min-width
  //         "3%", //max-width
  //         false,
  //         null,
  //         false
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         true,
  //         this.deleteInvoiceLine,
  //         false,
  //         null
  //       )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Ln##",
  //       "lineNumber",
  //       0,
  //       true,
  //       this.lnkLineDetailsClick,
  //       false,
  //       null
  //     )
  //   );
  //   if (this.props.is3PL) {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails("Item#", "fabricStyleCode")
  //     );
  //   } else {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "FabricStyle#",
  //         "fabricStyleCode"
  //       )
  //     );
  //   }
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Name", "fabricStyleName")
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Color", "colorCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Price", "price")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PT#",
  //       "sourcePickTicketNumber",
  //       0,
  //       true,
  //       this.viewPickTicketModule,
  //       false,
  //       null
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PTLn#",
  //       "sourcePickTicketLineNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("UOM", "uomCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("InvQty", "shippedQuantity")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("DiscAmt", "lineDiscountAmount")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Extension", "lineNetAmount")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("ReturnQty", "returnQuantity")
  //   );
  //   return columnList;
  // };

  //#endregion
  getIsPayableInvoice = () => {
    let isPayable = false;
    if (
      this.props.invoiceData.invoiceStatus !=
      LogicConstants.INVOICE_PAID_STATUS &&
      this.props.invoiceData.invoiceStatus !=
      LogicConstants.INVOICE_CANCEL_STATUS
    )
      isPayable = true;

    return isPayable;
  };

  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };

  viewPickTicketModule = (e, code) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowPickTicketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  viewSalesModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  lnkCustomerModule = (e) => {
    if (e.detail == 1) {
      let invoicedata = this.props.invoiceData;
      let customerCode = invoicedata.customerCode;
      if (!isEmptyString(customerCode)) {
        this.setState({
          isShowCustomerModule: true,
          isShowPopup: false,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  lnkCustomerCurrentAging = (e) => {
    this.setState({
      isShowCustomerCurrentAgingPopup: true,
      //isCollapsible_open: false,
    });
    this.loadCustomerCurrentAging();
  };

  lnkCustomerRecentFabrics = (e) => {
    this.setState({
      isShowCustomerRecentFabricPopup: true,
      //isCollapsible_open: false,
    });
    this.loadCustomerRecentFabrics();
  };
  loadCustomerRecentFabrics = () => {
    let invoiceData = this.props.invoiceData;
    let criteria = new MostRecentFabricInquiryCriteriaBean();
    criteria.companyCode = invoiceData.companyCode;
    criteria.customerCode = invoiceData.customerCode;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.inquireMostRecentFabricDetailsForCustomer(
        criteria,
        this.loadCustomerRecentFabricPageResponse,
        this.loadCustomerRecentFabricPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerRecentFabricPageResponse = (response) => {
    let inquiryDataList = response.data.resultBean;
    if (inquiryDataList != null) {
      let recentFabricList = response.data.resultBean.fabricInfos;
      this.setState({
        recentFabricList: recentFabricList,
        recentFabricData: inquiryDataList,
      });
    }
  };
  loadCustomerRecentFabricPageError = (error) => {
    ShowError("error :" + error);
  };
  lnkCustomerSalesHistory = (e) => {
    this.setState({
      isShowCustomerSalesHistoryPopup: true,
    });
    this.loadCustomerSalesHistoryList();
  };
  loadCustomerSalesHistoryList = () => {
    let invoiceData = this.state.invoiceData;
    let criteria = new CustomerInvoiceInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = invoiceData.customerCode;

    let pageInput = new PageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;

    let listRequest = new CustomerSalesDataRequest();
    listRequest.criteria = criteria;
    listRequest.pageInput = pageInput;

    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.getCustomerSalesData(
        listRequest,
        this.loadCustomerSalesDetailPageResponse,
        this.loadCustomerSalesDetailPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  loadCustomerSalesDetailPageResponse = (response) => {
    let inquiryDataList = response.data.salesDataPageList;
    if (inquiryDataList != null) {
      let customerSalesDataList =
        response.data.salesDataPageList.fabricStyleSales;
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        customerSalesDataList: customerSalesDataList,
        inquiryData: inquiryDataList,
      });
    }
  };
  loadCustomerSalesDetailPageError = (error) => {
    ShowError("Error :", error);
  };
  pdfCustomerSalesHistory = () => {
    this.generateCustomerSalesReport(1);
  };
  excelCustomerSalesHistory = () => {
    this.generateCustomerSalesReport(2);
  };
  generateCustomerSalesReport = (reportType) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let invoiceData = this.state.invoiceData;
    let criteria = new CustomerInvoiceInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = invoiceData.customerCode;

    let requestInput = new CustomerAndFabricSalesDetailPrintRequest();
    requestInput.criteria = criteria;
    requestInput.input = reportBean;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.generateCustomerAndFabricSalesDetailPrintReport(
        requestInput,
        this.generateCustomerSalesReportResponse,
        this.generateCustomerSalesReportError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateCustomerSalesReportResponse = (response) => {
    // let reportFilePath = response.data.reportResult.reportFileID;
    // window.open(this.report_url + reportFilePath);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generateCustomerSalesReportError = (error) => {
    ShowError("Error : " + error);
  };
  lnkCustomerTransaction = (e) => {
    this.readCustomer(this.props.invoiceData.customerCode);
    this.setState({ isShowCustomerTransactionPopup: true });
    this.loadCustomerCurrentAging();
    this.loadCustomerInvoiceDataList();
    this.loadCustomerCreditMemoList();
  };
  loadCustomerInvoiceDataList = () => {
    let tempCriteria = new CustomerTransactionAccountSummarySearchCriteria();
    let invoiceData = this.state.invoiceData;
    tempCriteria.companyCode = invoiceData.companyCode;
    tempCriteria.customerCode = invoiceData.customerCode;
    tempCriteria.entityType = 1013;
    tempCriteria.currencyCode = DEFAULT_CURRENCY_CODE;
    let statusData = ["A", "X", "P", "F"];
    tempCriteria.entityStatusList = statusData;
    let pageInput = new PageListBean();
    pageInput.pageSize = 100;
    pageInput.currentPage = 1;

    let listRequest = new CustomerTransactionDataRequest();
    listRequest.criteria = tempCriteria;
    listRequest.pageInput = pageInput;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.getAllCustomerTransactionData(
        listRequest,
        this.loadCustomerInvoiceResponse,
        this.loadCustomerInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerInvoiceResponse = (response) => {
    let invoiceList =
      response.data.inquiryResult.inquiryResult.customerTransactions;
    if (invoiceList != null) {
      this.setState({ invoiceList: invoiceList });
    }
  };
  loadCustomerInvoiceError = (error) => {
    ShowError("Error" + error);
  };

  loadCustomerCreditMemoList = () => {
    let tempCriteria = new CustomerTransactionAccountSummarySearchCriteria();
    let invoiceData = this.state.invoiceData;
    tempCriteria.companyCode = invoiceData.companyCode;
    tempCriteria.customerCode = invoiceData.customerCode;
    tempCriteria.entityType = 1006;
    tempCriteria.currencyCode = DEFAULT_CURRENCY_CODE;

    let statusData = ["P", "F", "X", "A", "U", "O"];
    tempCriteria.entityStatusList = statusData;
    let pageInput = new PageListBean();
    pageInput.pageSize = 100;
    pageInput.currentPage = 1;

    let listRequest = new CustomerTransactionDataRequest();
    listRequest.criteria = tempCriteria;
    listRequest.pageInput = pageInput;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.getAllCustomerTransactionData(
        listRequest,
        this.loadCustomerCreditMemoResponse,
        this.loadCustomerCreditMemoError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerCreditMemoResponse = (response) => {
    let creditMemoList =
      response.data.inquiryResult.inquiryResult.customerTransactions;
    if (creditMemoList != null) {
      this.setState({ customerCreditMemoList: creditMemoList });
    }
  };
  loadCustomerCreditMemoError = (error) => {
    ShowError("Error" + error);
  };
  loadCustomerCurrentAging = () => {
    let invoiceData = this.state.invoiceData;
    let criteriaBean = new CustomerPaymentAgingHistoryCriteriaBean();
    criteriaBean.companyCode = this.companyCode;
    criteriaBean.customerCode = invoiceData.customerCode;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.inquireCustomerPaymentCurrentAgingHistory(
        criteriaBean,
        this.loadCustomerAgingResponse,
        this.loadCustomerAgingError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerAgingResponse = (response) => {
    let resultList = response.data.result;
    let agingBucketList = [];
    const bucketGroup = response.data.result.agingBucketGroupBean;
    const agingHistory = response.data.result.agingHistoryBean;
    if (bucketGroup != null) {
      if (!isEmptyArray(bucketGroup.buckets)) {
        agingBucketList = response.data.result.agingBucketGroupBean.buckets;
      }
      this.setState({ agingBucketList: agingBucketList });
    }
    if (agingHistory != null) {
      this.setState({ agingHistoryBean: agingHistory });
    }

    if (agingHistory.invoiceDetails != null) {
      let invoiceList = agingHistory.invoiceDetails;
      this.setState({ agingInvoiceList: invoiceList });
    }
    if (agingHistory.creditMemoDetails != null) {
      let creditMemoList = agingHistory.creditMemoDetails;
      this.setState({ creditMemoList: creditMemoList });
    }
    this.setState({
      agingDataList: agingHistory,
      agingData: agingHistory,
    });
  };
  loadCustomerAgingError = (error) => {
    ShowError("Error :" + error);
  };

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowCustomerTransactionPopup: isShowPopup,
      isShowCustomerSalesHistoryPopup: isShowPopup,
      isShowCustomerCurrentAgingPopup: isShowPopup,
      isShowCustomerRecentFabricPopup: isShowPopup,
      isShowCustomerStatisticsPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowCustomerOnOrderPopup: isShowPopup,
      isShowNonMerchandisePopup: isShowPopup,
    });
  };
  closeAlertSubModalCallBack = (isShowPopup) => {
    this.setState({
      isShowInvoiceAmountPopup: isShowPopup,
      isShowInvoiceAppliedAmountPopup: isShowPopup,
      isShowInvoiceAppliedCMAmountPopup: isShowPopup,
      isShowRecentInvoicePopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowCreditMemoAppliedAmountPopup: isShowPopup,
    });
  };
  viewInvoiceModule = (code, rowData) => {
    if (!isEmptyString(code)) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewCreditMemoModule = (code, rowData) => {
    if (!isEmptyString(code)) {
      this.setState({
        isShowCreditMemoModule: true,
        moduleForPopup: (
          <PopupCreditMemoModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewARModule = (code, rowData) => {
    if (!isEmptyString(code)) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewCreditMemoDetails = (val, rowData) => {
    if (val > 0) {
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = rowData.entryEntityNumber;
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        AccountReceivableService.readAccountReceivablePaymentLinesForCreditMemo(
          readrestInput,
          this.readAccountReceivableCreditMemoPageResponse,
          this.readAccountReceivableCreditMemoPageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readAccountReceivableCreditMemoPageResponse = (response) => {
    let readARCreditMemoList =
      response.data.accountReceivablePaymentDetailPageList
        .accountReceivablePaymentDetails;
    if (readARCreditMemoList != null && !isEmptyArray(readARCreditMemoList)) {
      this.setState({ isShowCreditMemoAppliedAmountPopup: true });
      this.setState({ readARCreditMemoList: readARCreditMemoList });
    }
  };
  readAccountReceivableCreditMemoPageError = (error) => {
    ShowError("error :" + error);
  };
  generateMemoPdfReport = () => {
    this.generateCreditMemoReport(1);
  };
  generateMemoExcelReport = () => {
    this.generateCreditMemoReport(2);
  };
  generateCreditMemoReport = (reportType) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let creditNumber = "";
    this.state.readARCreditMemoList.map((list) => {
      creditNumber = list.documentNumber;
    });
    let listrequest =
      new PopupCustomerTransactionCreditMemoDetailsPrintRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.creditNumber = creditNumber;
    listrequest.reportBean = reportBean;

    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.generatePopupCustomerTransactionCreditMemoDetailsPrintReport(
        listrequest,
        this.generateCreditMemoPageResponse,
        this.generateCreditMemoPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateCreditMemoPageResponse = (response) => {
    // let reportFilePath = response.data.reportResult.reportFileID;
    // window.open(this.report_url + reportFilePath);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generateCreditMemoPageError = (error) => {
    ShowError("Erro : " + error);
  };
  viewInvoiceDetails = (val, rowData) => {
    if (val > 0) {
      this.setState({ isShowInvoiceAmountPopup: true });
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = rowData.entryEntityNumber;
      if (SecurityAccessManager.InvoiceMaintenanceView_IsAccessible()) {
        InvoiceService.readInvoice(
          readrestInput,
          this.readInvoicePageResponse,
          this.readInvoicePageError
        );
      }
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readInvoicePageResponse = (response) => {
    let readInvoiceData = response.data.invoice;
    if (readInvoiceData != null) {
      this.setState({ readInvoiceData: readInvoiceData });
    }
  };
  readInvoicePageError = (error) => {
    ShowError("readInvoicePageError :", error);
  };
  viewInvoiceAppliedCMAmountDetails = (val, rowData) => {
    if (val > 0) {
      this.setState({ isShowInvoiceAppliedCMAmountPopup: true });
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = rowData.entryEntityNumber;
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readAccountReceivablePageResponse,
          this.readAccountReceivablePageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  viewInvoiceAppliedAmountDetails = (val, rowData) => {
    if (val > 0) {
      this.setState({ isShowInvoiceAppliedAmountPopup: true });
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = rowData.entryEntityNumber;
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readAccountReceivablePageResponse,
          this.readAccountReceivablePageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readAccountReceivablePageResponse = (response) => {
    let readARAppliedList =
      response.data.accountReceivablePaymentDetailPageList
        .accountReceivablePaymentDetails;
    if (readARAppliedList != null) {
      let readArList = [];
      for (let list of readARAppliedList) {
        if (list.paymentType == 1) {
          list.paymentType = "CHECK";
        } else if (list.paymentType == 2) {
          list.paymentType = "CREDIT_MEMO";
        } else if (list.paymentType == 3) {
          list.paymentType = "CREDIT_CARD";
        } else if (list.paymentType == 4) {
          list.paymentType = "DEBIT_CARD";
        } else if (list.paymentType == 5) {
          list.paymentType = "CASH";
        } else if (list.paymentType == 6) {
          list.paymentType = "CHARGE_BACK";
        } else if (list.paymentType == 8) {
          list.paymentType = "WIRE_TRANSFER";
        } else if (list.paymentType == 9) {
          list.paymentType = "ACH";
        }
        readArList.push(list);
      }
      readARAppliedList = readArList;
      this.setState({ readARAppliedList: readARAppliedList });
    }
  };
  readAccountReceivablePageError = (error) => {
    ShowError("readAccountReceivablePageError :", error);
  };
  viewRecentInvoiceDetails = (val, rowData) => {
    if (val > 0) {
      this.setState({
        isShowRecentInvoicePopup: true,
        recentFabricLineData: rowData,
      });
      let invoiceData = this.state.invoiceData;
      let readrestInput = new FabricStyleDetailInquiryCriteriaBean();
      readrestInput.comapanyCode = invoiceData.companyCode;
      readrestInput.fabricStyleCode = rowData.fabricStyleCode;
      readrestInput.colorCode = rowData.colorCode;
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        ReportService.getFabricStyleInvoiceDetails(
          readrestInput,
          this.loadRecentInvoicePageResponse,
          this.loadRecentInvoicePageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadRecentInvoicePageResponse = (response) => {
    if (response.data != null && response.data.pageList != null) {
      let inquiryList = response.data.pageList.infoBeans;
      if (inquiryList != null) {
        this.setState({ recentInvoiceList: inquiryList });
      }
    }
  };
  loadRecentInvoicePageError = (error) => {
    ShowError("readInvoicloadRecentInvoicePageError :", error);
  };
  //Customer Current Aging OpenInvoice Report
  openInvoiceAgingReport = () => {
    let invoiceData = this.state.invoiceData;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;

    let listRequest = new CustomerAgingOpenInvoicesPrintRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.customerCode = invoiceData.customerCode;
    listRequest.input = reportBean;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.generateCustomerAgingOpenInvoicesPrintReport(
        listRequest,
        this.generateOpenInvoiceCustomerAgingPageResponse,
        this.generateOpenInvoiceCustomerAgingPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateOpenInvoiceCustomerAgingPageResponse = (response) => {
    // let reportFilePath = response.data.reportResult.reportFileID;
    // window.open(this.report_url + reportFilePath);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generateOpenInvoiceCustomerAgingPageError = (error) => {
    ShowError("Erro : " + error);
  };
  //#endRegion

  //Customer Statistics  Full Popup Details

  lnkCustomerStatistics = (e) => {
    this.setState({
      isShowCustomerStatisticsPopup: true,
      //isCollapsible_open: false,
    });
    this.loadCustomerStatisticsList();
  };
  loadCustomerStatisticsList = () => {
    let invoiceData = this.state.invoiceData;
    let criteria = new CustomerStatisticsInquiryCriteriaBean();
    criteria.companyCode = invoiceData.companyCode;
    criteria.customerCode = invoiceData.customerCode;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.inquireCustomerStatisticsData(
        criteria,
        this.loadCustomerStatisticsPageResponse,
        this.loadCustomerStatisticsPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerStatisticsPageResponse = (response) => {
    let inquiryDataList = response.data.result;
    if (inquiryDataList != null) {
      let inquiryData = response.data.result;
      let agingBucketList = [];
      let agingHistoryBean = null;
      let onOrderInfoDetail = [];
      let salesDetail = [];
      let returnCreditMemo = [];
      if (inquiryDataList.agingBucketGroupBean != null)
        agingBucketList = response.data.result.agingBucketGroupBean.buckets;
      if (inquiryDataList.agingHistoryBean != null)
        agingHistoryBean = response.data.result.agingHistoryBean;
      if (inquiryDataList.onOrderInfoDetails != null)
        onOrderInfoDetail = response.data.result.onOrderInfoDetails;
      if (inquiryDataList.salesDetails != null)
        salesDetail = response.data.result.salesDetails;
      if (inquiryDataList.returnCreditMemos != null)
        returnCreditMemo = response.data.result.returnCreditMemos;

      this.setState({
        stAgingBucketList: agingBucketList,
        stAgingHistoryBean: agingHistoryBean,
        onOrderInfoDetail: onOrderInfoDetail,
        salesDetail: salesDetail,
        returnCreditMemo: returnCreditMemo,
        statisticData: inquiryData,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerStatisticsPageError = (error) => {
    ShowError("Error : " + error);
  };
  lnkCustomerOnOrder = () => {
    this.setState({
      isShowCustomerOnOrderPopup: true,
    });
    this.loadCustomerOnOrder();
  };
  loadCustomerOnOrder = () => {
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    let invoiceData = this.props.invoiceData;
    criteria.companyCode = invoiceData.companyCode;
    criteria.customerCode = invoiceData.customerCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestCustomerSalesOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      CustomerService.getCustomerSalesOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadCustomerOnOrderQtyPageResponse,
        this.loadCustomerOnOrderQtyPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerOnOrderQtyPageResponse = (response) => {
    let inquiryDataList = response.data.orderDetailsResult;
    if (inquiryDataList != null) {
      let customerQtyDataList = [];
      if (response.data.orderDetailsResult.onOrderInfoDetails != null)
        customerQtyDataList =
          response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        customerOnOrderList: customerQtyDataList,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerOnOrderQtyPageError = (error) => {
    ShowError("Error : " + error);
  };
  //ExtraCharge Amount Popup
  extraChargeAmountClick = (e, val) => {
    if (e.detail == 1) this.props.extraChargeAmountClick(val);
  };
  addSaveExtraChargeAmount = (e) => {
    if (e.detail == 1) this.props.addSaveExtraChargeAmount();
  };
  onExtraChange = (e) => {
    this.props.onExtraChange(e);
  };
  onExtraChargeLineClick = (rowData) => {
    this.props.onExtraChargeLineClick(rowData);
  };

  addUpdateExtraChargeLine = () => {
    this.props.addUpdateExtraChargeLine();
  };
  clearExtraChargesValues = (e) => {
    if (e.detail == 1) this.props.clearExtraChargesValues();
  };
  deleteExtraCharge = (rowData) => {
    this.props.deleteExtraCharge(rowData);
  };

  extraChargeEnterKeyEventHandler = (e) => {
    this.props.extraChargeEnterKeyEventHandler(e);
  };
  displayAutoCompleteExtraChargeList = (list) => {
    this.props.displayAutoCompleteExtraChargeList(list);
  };
  //Non Merchandise  Amount Popup
  nonMerchandiseAmountClick = (e, val) => {
    if (e.detail == 1) this.props.nonMerchandiseAmountClick(val);
  };
  addSaveNonMerchandiseAmount = (e) => {
    if (e.detail == 1) this.props.addSaveNonMerchandiseAmount();
  };
  onNonMerchandiseChange = (e) => {
    this.props.onNonMerchandiseChange(e);
  };
  onNonMerchandiseReasonChange = (e) => {
    this.props.onNonMerchandiseReasonChange(e);
  };
  onMerchandiseLineClick = (val, rowData) => {
    this.props.onMerchandiseLineClick(val, rowData);
  };

  addUpdateMerchandiseLine = () => {
    this.props.addUpdateMerchandiseLine();
  };
  clearMerchandiseValues = (e) => {
    if (e.detail == 1) this.props.clearMerchandiseValues();
  };
  nonMercEnterKeyEventHandler = (e) => {
    this.props.nonMercEnterKeyEventHandler(e);
  };
  displayAutoCompleteNonMercList = (list) => {
    this.props.displayAutoCompleteNonMercList(list);
  };
  deleteNonMerchandiseLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteNonMerchandiseLine(rowData);
  };
  openCustomerOnOrderInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerOnOrderInq(code);
  };
  openCustomerTransactionsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerTransactionsInq(code);
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerStatisticsInq(code);
  };
  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerSalesHistoryInq(code);
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerMostRecentFabricsInq(code);
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerCurrentAgingInq(code);
  };
  openCustomerInfoInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerInfoInq(code);
  };

  addNewInvoiceLine = (e) => {
    if (e.detail == 1) this.props.addNewInvoiceLine();
  };



  invoiceLineColumns = () => {
    let isModify = this.props.isModifyPosible();
    let disableInvoiceFormFields = this.props.isDisableFields;
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }

    // let disableUpdatableFields = false;

    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        // .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("", "", "", "wt-2", "wt-2")
        .setHeaderDetails(
          true,
          <AddIcon />,
          this.addNewInvoiceLine,
          disableUpdatableFields
        )
      // .setShortCutPopDetails(this.getShortcutComponent, true)
      // .setClickDetails(false, true, this.deleteInvoiceLine, <DeleteIcon />)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.lnkLineDetailsClick, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      // .setClickDetails(true, false, this.lnkCustomerModule,null )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PT#", "sourcePickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPickTicketModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PTLn#", "sourcePickTicketLineNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DiscAmt", "lineDiscountAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "lineNetAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("ReturnQty", "returnQuantity", true, true)
    //     .setStyleDetails("right", "", "", "wt-3", "wt-3")
    // );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("no of pallets", "numberOfPallets", true)
    //     .setStyleDetails("right", "", "", "wt-3", "wt-3")
    //     .setInputDetails(
    //       false,
    //       true,
    //       null,
    //       this.numberOfPalletsOnChange,
    //       null,
    //       this.noOfPalletsOnBlur,
    //       0
    //     )
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("", "", "", "wt-2", "wt-2")
        .setClickDetails(false, true, this.deleteInvoiceLine, <DeleteIcon />)
    );
    return columns;
  };
  render() {
    let invoicedata = new InvoiceBean();
    let isDisabledFields = this.props.isDisabledFields;
    let customerList = this.props.customerList;
    if (customerList == null) {
      customerList = [];
    }
    let isModify = this.props.isModifyPosible();
    let disableInvoiceFormFields = this.props.isDisableFields;
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    invoicedata = this.props.invoiceData;

    // if (
    //   invoicedata.isPaidForceFlag != true &&
    //   invoicedata.taxRequiredFlag != true
    // ) {
    //   disableInvoiceFormFields = true;
    // }
    let lines = [];
    let openInvoiceAmount =
      invoicedata.grandTotalAmount -
      invoicedata.provisionalPaymentAmount -
      invoicedata.netPaidAmount;
    let isPayableInvoice = false;
    isPayableInvoice = this.getIsPayableInvoice();
    let arStarted = openInvoiceAmount < invoicedata.grandTotalAmount;

    let address = new AddressBean();
    if (invoicedata != null) {
      address = invoicedata.address;
      if (address == null) {
        address = new AddressBean();
      }
      if (!isEmptyArray(invoicedata.lines)) {
        invoicedata.lines.map((line) => {
          lines.push(line);
        });
        lines.reverse();
      }
    }
    let invoiceStatus = ModuleUtils.getInvoiceStatusCaption(
      invoicedata.invoiceStatus
    );
    let customerData = this.state.customerData;
    let customerSalesDataList = this.state.customerSalesDataList;
    let inquiryData = this.state.inquiryData;
    let readInvoiceData = this.state.readInvoiceData;
    let readARAppliedList = this.state.readARAppliedList;
    let recentFabricList = this.state.recentFabricList;
    let recentFabricData = this.state.recentFabricData;
    let recentFabricLineData = this.state.recentFabricLineData;
    let summaryData = this.state.summaryData;
    let stAgingHistoryBean = this.state.stAgingHistoryBean;
    let statisticData = this.state.statisticData;
    let agingHistoryBean = this.state.agingHistoryBean;
    let agingData = this.state.agingData;
    let invoiceExtraChargeData = this.state.invoiceExtraChargeData;
    let serviceAmount = this.props.serviceAmount;
    const is3PL = this.props.is3PL;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "280px",
          maxHeight: "280px",
          overflowY: "auto",
        },
      },
    };

    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>

              <Col sm="2">
                <DatePickerComponent_adv
                  name="invoiceDate"
                  value={invoicedata.invoiceDate}
                  onChange={this.onChange}
                  disabled={isDisabledFields}
                  isModifyView={isModify}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>DueDate</FormLabel>
              </Col>

              <Col sm="2">
                <DatePickerComponent_adv
                  name="paymentDueDate"
                  value={invoicedata.paymentDueDate}
                  onChange={this.onChange}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>DeliveryDate</FormLabel>
              </Col>

              <Col sm="2">
                <DatePickerComponent_adv
                  name="deliveryDate"
                  value={invoicedata.deliveryDate}
                  onChange={this.onChange}
                  disabled={isDisabledFields}
                  isModifyView={isModify}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>PO#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="customerPurchaseOrderNumber"
                  onChange={this.onChange}
                  value={invoicedata.customerPurchaseOrderNumber}
                  isModifyView={isModify}
                  disabled={disableUpdatableFields}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="so-align-items-left" sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkCustomerModule(e)}
                >
                  Customer
                </FormLabel>{" "}
                <Col>
                  <ShortCutMenuPopup
                    value={invoicedata.customerCode}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerInfoInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Info{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerOnOrderInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer On-Order{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerTransactionsInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Transactions{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerStatisticsInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Statistics{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerSalesHistoryInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Sales History{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerMostRecentFabricsInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Most Recent Items{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerCurrentAgingInq(
                              e,
                              invoicedata.customerCode
                            )
                          }
                        >
                          {" "}
                          Customer Current Aging{" "}
                        </li>
                      </ul>
                    }
                  />
                </Col>
              </Col>

              <Col sm="2">
                {/* <InputTextbox
                  ref={this.customerCodeRef}
                  name="customerCode"
                  type="text"
                  onChange={this.onChange}
                  disabled={true}
                  value={invoicedata.customerCode}
                  isMandatory={true}
                />{" "} */}
                <InputTextbox
                  onChange={this.props.onCustomerCodeChange}
                  ref={this.customerCodeRef}
                  // readOnly={disableSalesOrderFormFields}
                  // disabled={isDisableFieldUnApprove}
                  name="customerCode"
                  placeholder="Customer"
                  value={invoicedata.customerCode}
                  lookupRequired={invoicedata.isManualEntry}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={
                    this.props.customerCodeEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayAutoCompleteCustomerList
                  }
                  showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={this.props.isCustomerNotFound}
                />
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  disabled={true}
                  value={invoicedata.customerName}
                  isMandatory={true}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel>Currency </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="invoiceCurrencyCode"
                  onChange={this.onChange}
                  disabled={true}
                  value={invoicedata.invoiceCurrencyCode}
                  isMandatory={true}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.viewSalesModule(e, invoicedata.salesOrderNumber)
                  }
                >
                  SalesOrder#{" "}
                </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="salesOrderNumber"
                  onChange={this.onChange}
                  disabled={true}
                  value={invoicedata.salesOrderNumber}
                  isMandatory={true}
                />{" "}
              </Col>
            </Row>
          </div>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel
                className="hyperLinkText"
                onClick={(e) =>
                  this.viewPickTicketModule(e, invoicedata.pickTicketNumber)
                }
              >
                PickTicket#{" "}
              </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="pickTicketNumber"
                onChange={this.onChange}
                disabled={true}
                value={invoicedata.pickTicketNumber}
                isMandatory={true}
              // disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>PaymentTerm </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="paymentTermCode"
                // placeholder="PaymentTerm"
                onChange={this.props.onPaymentTermChange}
                ref={this.paymentTermRef}
                value={invoicedata.paymentTermCode}
                lookupRequired={true}
                lookupHandler={this.props.paymentTermLookupHandler}
                enterKeyEventHandler={
                  this.props.paymentTermEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.paymentTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompletePaymentTermList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePaymentTermList
                }
                disabled={disableInvoiceFormFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Clerk </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesClerkCode"
                onChange={this.onChange}
                value={invoicedata.salesClerkCode}
                disabled={true}
              />{" "}
            </Col>{" "}
            <Col className="align-items-left" sm="1">
              <FormLabel>PreferredCC# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="preferredCreditCardNumber"
                onChange={this.onChange}
                value={invoicedata.preferredCreditCardNumber}
                disabled={true}
              />{" "}
            </Col>
            {/* <Col className="align-items-left" sm="1">
              <FormLabel>Tracking# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="trackingNumber"
                onChange={this.onChange}
                // readOnly={disableInvoiceFormFields}
                value={invoicedata.trackingNumber}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
                isMandatory={true}
              />{" "}
            </Col> */}
            {/* <Col className="align-items-left" sm="1">
              <FormLabel>BusinessDivision </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="businessDivision"
                onChange={this.onChange}
                // readOnly={disableInvoiceFormFields}
                value={invoicedata.businessDivision}
                //isModifyView={isModify}
                disabled={true}
              />{" "}
            </Col> */}
          </Row>
          <Row>
            {/* <Col sm="1">
              <FormLabel>ForcePay</FormLabel>
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="isPaidForceFlag"
                type="checkbox"
                checked={invoicedata.isPaidForceFlag}
                onChange={this.onChange}
                disabled={disableInvoiceFormFields}
              />
            </Col> */}
            <Col sm="1">
              <FormLabel>SalesTax</FormLabel>
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="taxRequiredFlag"
                type="checkbox"
                checked={invoicedata.taxRequiredFlag}
                onChange={this.onChange}
                disabled={disableInvoiceFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>CloseSO</FormLabel>
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="closeSalesOrderFlagAfterInvoiceApproval"
                type="checkbox"
                checked={invoicedata.closeSalesOrderFlagAfterInvoiceApproval}
                onChange={this.onChange}
                disabled={disableInvoiceFormFields}
              />
            </Col>
            {/* <Col sm="1">
              <FormLabel>IsShipped</FormLabel>
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="ShippedFlag"
                type="checkbox"
                checked={invoicedata.ShippedFlag}
                onChange={this.onChange}
                disabled={disableInvoiceFormFields}
              />
            </Col> */}
            {/* <Col sm="1">
              <FormLabel>CommPaid</FormLabel>
            </Col>
            <Col sm="2">
              <InputCheckbox
                name="commissionPaidFlag"
                type="checkbox"
                checked={invoicedata.commissionPaidFlag}
                onChange={this.onChange}
                disabled={true}
              />
            </Col> */}
          </Row>
          {is3PL && (
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.props.viewPOModule(e, invoicedata.purchaseOrderNumber)
                  }
                >
                  P.O
                </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="purchaseOrderNumber"
                  onChange={this.onChange}
                  readOnly={true}
                  value={invoicedata.purchaseOrderNumber}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.props.viewPOReceiptModule(
                      e,
                      invoicedata.purchaseOrderReceiptNumber
                    )
                  }
                >
                  P.O Receipt{" "}
                </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="purchaseOrderReceiptNumber"
                  onChange={this.onChange}
                  readOnly={true}
                  value={invoicedata.purchaseOrderReceiptNumber}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
            </Row>
          )}
        </div>
        <div className="total_amounts_and_table_div col-md-12 col-lg-12">
          <div className="table_div soline_table col-md-12 col-lg-10">
            {/* <Row>
              <Col sm="2" className="title_text_div">
                <FormLabel>Invoice Lines</FormLabel>
              </Col>
              <Col sm="1"></Col>
            </Row> */}
            <Row>
              {/* <Col className="sales_addline_align1" md={0.8}> */}
              {/* {this.props.isShowAddIcon && ( */}
              {/* <Button
                  size="sm"
                  onClick={() => this.addNewInvoiceLine()}
                  disabled={disableUpdatableFields}
                  variant="primary"
                  className="header_buttons enterFocus"
                >
                  <AddIcon />
                </Button> */}
              {/* )} */}
              {/* </Col> */}
              <Col className="" sm="12">
                <div className="div_Custom_4">

                  <CustomTable
                    data={lines}
                    columns={this.invoiceLineColumns()}
                    label={"Invoice Lines"}
                  />
                </div>
              </Col>

              <Col className="sales_addline_align2" sm="12">
                {/* <div className="div_Custom_2">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>
                          <Button
                            size="sm"
                            onClick={(e) => this.addNewInvoiceLine(e)}
                            disabled={this.props.isDisableAddLine}
                            variant="primary"
                            className="header_buttons enterFocus"
                          >
                            <AddIcon />
                          </Button>
                        </th>
                        <th>Ln#</th>
                        {this.props.is3PL ? (
                          <th>Item#</th>
                        ) : (
                          <th>FabricStyle#</th>
                        )}
                        <th>Name</th>
                        <th>Color</th>
                        <th>Price</th>
                        <th>PT#</th>
                        <th>PTLn#</th>
                        <th>UOM</th>
                        <th>InvQty</th>
                        <th>DiscAmt</th>
                        <th>Extension</th>
                  
                      </tr>
                    </thead>
                    {lines != null ? (
                      <tbody>
                        {lines.map((ln, index) => (
                          <tr key={index}>
                            <td>
                              {ln.isFetched != true && (
                                <Button
                                  variant="secondry"
                                  onClick={(e) => this.deleteInvoiceLine(e, ln)}
                                >
                                  <DeleteIcon />
                                </Button>
                              )}
                            </td>

                            <td>
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lnkLineDetailsClick(e, ln.lineNumber, ln)
                                }
                              >
                                {ln.lineNumber}
                              </Button>
                            </td>
                            <td>{ln.fabricStyleCode}</td>
                            <td>{ln.fabricStyleName}</td>
                            <td>{ln.colorCode}</td>
                            <td>{ln.price}</td>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewPickTicketModule(
                                    e,
                                    ln.sourcePickTicketNumber
                                  )
                                }
                              >
                                {ln.sourcePickTicketNumber}
                              </Button>
                            </td>
                            <td>{ln.sourcePickTicketLineNumber}</td>
                            <td>{ln.uomCode}</td>
                            <td>{ln.shippedQuantity}</td>
                            <td>{ln.lineDiscountAmount}</td>
                            <td>{ln.lineNetAmount}</td>
                         
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                  {lines.length != 0 ? null : (
                    <div className="no_Data_small">{"NO DATA"}</div>
                  )}
                </div> */}
                {/* <EditableDataGrid
                  customStyles={dataTableStyles}
                  columnsList={this.columnDefinitions()}
                  dataList={lines}
                /> */}
                {/* <DataGrid
                  columnsList={this.columnDefinitions()}
                  dataList={lines}
                  isLoading={false}
                /> */}
              </Col>
            </Row>
          </div>
          <div className="total_amounts_div col-md-12 col-lg-5">
            <Row>
              <FormLabel className="label_head">Totals </FormLabel>
            </Row>
            <Row>
              <Col sm="4" className="align-items-left">
                <FormLabel>Standard Currency </FormLabel>{" "}
              </Col>

              <Col sm="8">
                <InputTextbox
                  value={invoicedata.invoiceCurrencyCode}
                  onChange={this.onChange}
                  // className="qty_input text-right"
                  // decimalScale={2}
                  name={"invoiceCurrencyCode"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="4" className="align-items-left">
                <FormLabel>SubTotal </FormLabel>{" "}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.subTotalAmount}
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  decimalScale={2}
                  name={"subTotalAmount"}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col sm="2" className="align-items-left">
                <FormLabel>Tax% </FormLabel>{" "}
              </Col>
              <Col sm="5">
                <NumberFormatInputbox
                  value={invoicedata.taxPercentage}
                  onChange={this.onChange}
                  className="text-right"
                  decimalScale={2}
                  name={"taxPercentage"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>

              <Col sm="5">
                <NumberFormatInputbox
                  value={invoicedata.totalTaxAmount}
                  onChange={this.onChange}
                  className="text-right"
                  decimalScale={2}
                  name={"totalTaxAmount"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>
            </Row>

            <Row>
              <Col className="align-items-left" sm="4">
                <FormLabel>DiscAmt </FormLabel>{" "}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  name={"discountAmount"}
                  onChange={this.onHeaderAmountsChange}
                  value={invoicedata.discountAmount}
                  className="text-right"
                  decimalScale={2}
                  disabled={disableUpdatableFields}
                  isModifyView={isModify}
                  isMandatory={true}
                />
              </Col>
            </Row>

            <Row>
              <Col className="align-items-left" sm="4">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.extraChargeAmountClick(
                      e,
                      invoicedata.extraChargesAmount
                    )
                  }
                >
                  ExtChrg
                </FormLabel>{" "}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  name={"extraChargesAmount"}
                  onChange={this.onHeaderAmountsChange}
                  value={invoicedata.extraChargesAmount}
                  className={"text-right"}
                  decimalScale={2}
                  disabled={true}
                  isMandatory={true}
                // isModifyView={isModify}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="4">
                <FormLabel>ShipChrg </FormLabel>{" "}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.shipmentChargesAmount}
                  onChange={this.onHeaderAmountsChange}
                  className="text-right"
                  decimalScale={2}
                  name={"shipmentChargesAmount"}
                  isCustomHandledKeyDown={true}
                  customeOnKeyDown={this.onShipmentChargesAmountKeydown}
                  disabled={disableUpdatableFields}
                  isModifyView={isModify}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              {!is3PL && (
                <Col className="align-items-left" sm="4">
                  <FormLabel
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.nonMerchandiseAmountClick(
                        e,
                        invoicedata.nonMerchandiseTotalAmount
                      )
                    }
                  >
                    Non MerchandiseAmt
                  </FormLabel>{" "}
                </Col>
              )}
              {!is3PL && (
                <Col sm="8">
                  <NumberFormatInputbox
                    value={invoicedata.nonMerchandiseTotalAmount}
                    onChange={this.onHeaderAmountsChange}
                    className="text-right"
                    decimalScale={2}
                    name={"nonMerchandiseTotalAmount"}
                    disabled={true}
                    isMandatory={true}
                  // isModifyView={isModify}
                  />
                </Col>
              )}
            </Row>
            <Row>
              {is3PL && (
                <Col className="align-items-left" sm="4">
                  <FormLabel>Service Amount</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="8">
                  <NumberFormatInputbox
                    value={invoicedata.totalServiceAmount}
                    onChange={this.onHeaderAmountsChange}
                    className="text-right summary_input"
                    decimalScale={2}
                    name={"totalServiceAmount"}
                    disabled={true}
                  />
                </Col>
              )}
            </Row>
            {/* <Row>
              <Col sm="4">
                <FormLabel>TarrifAmount</FormLabel>
              </Col>
              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.tariffAmount}
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  decimalScale={2}
                  name={"tariffAmount"}
                  disabled={true}
                />
              </Col>
            </Row> */}

            <Row>
              <Col sm="4">
                <FormLabel>GrandTotal</FormLabel>
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.grandTotalAmount}
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  decimalScale={2}
                  name={"grandTotalAmount"}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col sm="4">
                <FormLabel>Standard GrandTotal</FormLabel>
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.standardGrandTotalAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"standardGrandTotalAmount"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>
            </Row>

            {/* {arStarted && ( */}
            <Row>
              <Col sm="4">
                {is3PL ? (
                  <FormLabel>TotPaid</FormLabel>
                ) : (
                  <FormLabel>App.Amt</FormLabel>
                )}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.paidOtherAppliedAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"paidOtherAppliedAmount"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="4">
                {is3PL ? (
                  <FormLabel>TotCredit</FormLabel>
                ) : (
                  <FormLabel>AppCredit</FormLabel>
                )}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={invoicedata.paidCreditMemoAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"paidCreditMemoAmount"}
                  disabled={true}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="4">
                <FormLabel>TotDue</FormLabel>{" "}
              </Col>

              <Col sm="8">
                <NumberFormatInputbox
                  value={openInvoiceAmount}
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  decimalScale={2}
                  name={"openInvoiceAmount"}
                  disabled={true}
                />
              </Col>
            </Row>
            {/* )} */}
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        {/* ExtraCharge Popup */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isShowExtraChargePopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.props.closeAlertAmountModalCallBack}
          title={"Extra Charge Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.props.hidePopupAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addSaveExtraChargeAmount(e)}
              >
                Save
              </Button>
            </div>
          }
          content={
            <ExtraChargeDetailForm
              {...this.state}
              invoiceData={this.props.invoiceData}
              invoiceExtraChargeData={this.props.invoiceExtraChargeData}
              showAutoCompleteExtraChargeList={
                this.props.showAutoCompleteExtraChargeList
              }
              extraChargePageListForAutoCompleteList={
                this.props.extraChargePageListForAutoCompleteList
              }
              extraChargeReasons={this.props.extraChargeReasons}
              disableInvoiceFormFields={disableInvoiceFormFields}
              isModifyPosible={this.props.isModifyPosible}
              onExtraChange={this.onExtraChange}
              onExtraChargeLineClick={this.onExtraChargeLineClick}
              addUpdateExtraChargeLine={this.addUpdateExtraChargeLine}
              deleteExtraCharge={this.deleteExtraCharge}
              clearExtraChargesValues={this.clearExtraChargesValues}
              extraChargeEnterKeyEventHandler={
                this.extraChargeEnterKeyEventHandler
              }
              displayAutoCompleteExtraChargeList={
                this.displayAutoCompleteExtraChargeList
              }
              onExtraReasonChange={this.props.onExtraReasonChange}
            />
          }
        />

        {/* NonMerchandise Popup */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.props.isShowNonMerchandisePopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.props.closeAlertAmountModalCallBack}
          title={"Non Merchandise Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlert}
              hideAlertCallBack={this.props.hidePopupAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addSaveNonMerchandiseAmount(e)}
              >
                Save
              </Button>
            </div>
          }
          content={
            <NonMerchandiseDetailForm
              {...this.state}
              disableInvoiceFormFields={disableInvoiceFormFields}
              isModifyPosible={this.props.isModifyPosible}
              onNonMerchandiseChange={this.onNonMerchandiseChange}
              onMerchandiseLineClick={this.onMerchandiseLineClick}
              addUpdateMerchandiseLine={this.addUpdateMerchandiseLine}
              deleteNonMerchandiseLine={this.deleteNonMerchandiseLine}
              invoiceData={this.props.invoiceData}
              merchandiseData={this.props.merchandiseData}
              onNonMerchandiseReasonChange={this.onNonMerchandiseReasonChange}
              nonMercEnterKeyEventHandler={this.nonMercEnterKeyEventHandler}
              displayAutoCompleteNonMercList={
                this.displayAutoCompleteNonMercList
              }
              nonMerchandiseReasons={this.props.nonMerchandiseReasons}
              clearMerchandiseValues={this.clearMerchandiseValues}
              showAutoCompleteNonMercList={
                this.props.showAutoCompleteNonMercList
              }
              nonMercPageListForAutoCompleteList={
                this.props.nonMercPageListForAutoCompleteList
              }
            />
          }
        />
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowRecentInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Customer Recent Invoice Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel>CustomerCode</FormLabel>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    value={invoicedata.customerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>FabricCode</FormLabel>
                </Col>

                <Col sm="2">
                  {recentFabricLineData != null && (
                    <InputTextbox
                      value={recentFabricLineData.fabricStyleCode}
                      disabled={true}
                    />
                  )}
                </Col>

                <Col sm="3">
                  {recentFabricLineData != null && (
                    <InputTextbox
                      value={recentFabricLineData.fabricStyleName}
                      disabled={true}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Total Sales Qty</FormLabel>
                </Col>
                {recentFabricData != null && (
                  <Col sm="2">
                    <InputTextbox
                      value={recentFabricData.allFabricTotalQuantity}
                      disabled={true}
                    />
                  </Col>
                )}

                <Col sm="1">
                  <FormLabel>Total Sales Amt</FormLabel>
                </Col>
                {recentFabricData != null && (
                  <Col sm="2">
                    <InputTextbox
                      value={recentFabricData.allFabricTotalSoldAmount}
                      disabled={true}
                    />
                  </Col>
                )}
              </Row>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice</th>
                    <th>CustomerPO#</th>

                    <th>Price</th>
                    <th>Shipped Qty</th>
                  </tr>
                </thead>
                {this.state.recentInvoiceList != null && (
                  <tbody>
                    {this.state.recentInvoiceList.map((inquiryInfo, index) => (
                      <tr key={index}>
                        <td>{inquiryInfo.invoiceDate}</td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewInvoiceModule(inquiryInfo.invoiceNumber)
                            }
                          >
                            {inquiryInfo.invoiceNumber}
                          </Button>
                        </td>
                        <td>{inquiryInfo.customerPONumber}</td>
                        <td>{inquiryInfo.price}</td>
                        <td>{inquiryInfo.shippedQuantity}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              {this.state.readInvoiceData != null && (
                <div>
                  <Row>
                    <FormLabel> Amount Details</FormLabel>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>SubTotal</FormLabel>
                    </Col>
                    <Col className="summary_text_box" sm="2">
                      <InputTextbox
                        value={readInvoiceData.subTotalAmount}
                        className="summary_input text-right"
                        disabled={true}
                      />
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        //value={cbData.openingBalance}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TaxAmount</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.totalTaxAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>DiscountAmount</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.discountAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>ExtraCharges</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.extraChargesAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>GrandTotal</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.grandTotalAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TotalPaid</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.paidAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>TotalDue</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.totalDueAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedCMAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>AR#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>CreditMemo#</th>
                    <th>AppliedAmount</th>
                    <th>Currency</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {this.state.readARAppliedList != null && (
                  <tbody>
                    {this.state.readARAppliedList
                      .filter((li) => li.paymentType == "CREDIT_MEMO")
                      .map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={() =>
                                this.viewARModule(list.accountReceivableNumber)
                              }
                            >
                              {list.accountReceivableNumber}
                            </Button>
                          </td>
                          <td>{list.paymentPostDate}</td>
                          <td>{list.paymentType}</td>
                          <td>{list.documentNumber}</td>
                          <td>{list.paymentAmount}</td>
                          <td>{list.currencyCode}</td>
                          <td>{list.status}</td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>AR#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Document#</th>
                    <th>AppliedAmount</th>
                    <th>Currency</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {this.state.readARAppliedList != null && (
                  <tbody>
                    {this.state.readARAppliedList
                      .filter(
                        (li) =>
                          li.paymentType != "CREDIT_MEMO" &&
                          li.paymentType != "CHARGE_BACK"
                      )
                      .map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={() =>
                                this.viewARModule(list.accountReceivableNumber)
                              }
                            >
                              {list.accountReceivableNumber}
                            </Button>
                          </td>
                          <td>{list.paymentPostDate}</td>
                          <td>{list.paymentType}</td>
                          <td>{list.documentNumber}</td>
                          <td>{list.paymentAmount}</td>
                          <td>{list.currencyCode}</td>
                          <td>{list.status}</td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowCreditMemoAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={() => this.generateMemoPdfReport()}
              >
                PDF
              </Button>

              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={() => this.generateMemoExcelReport()}
              >
                EXCEL
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>Invoice#</th>
                    <th>AR#</th>
                    <th>PaidAmount</th>
                    <th>Currency</th>
                  </tr>
                </thead>
                {this.state.readARCreditMemoList != null && (
                  <tbody>
                    {this.state.readARCreditMemoList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewInvoiceModule(list.invoiceNumber)
                            }
                          >
                            {list.invoiceNumber}
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewARModule(list.accountReceivableNumber)
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>{list.paymentAmount}</td>
                        <td>{list.currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
      </div>
    );
  }
}

class InvoiceLinePopupForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      pickTicketLookupHandler: null,
    };
    this.pickTicketRef = React.createRef();
    this.pickTicketLineRef = React.createRef();
  }

  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let invoiceData = { ...this.props.invoiceData }
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "PickTicket",
      "",
      invoiceData.customerCode
    );
    this.setState({ pickTicketLookupHandler: pickTicketLookupHandler });
  };
  onRollSelectedChange = (e, val, row) => {

    this.props.onRollSelectedChange(e, val);
  };

  onRollLineShippedQtyChange = (e, row) => {
    this.props.onRollLineShippedQtyChange(e, row);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onRollLineShippedQtyBlur = (e, row) => {
    this.props.onRollLineShippedQtyBlur(e, row);
  };
  rollLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isApplied", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onRollSelectedChange,
          null
        )
        .setDisabled(this.props.isDisabledFields)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AvailQty", "availableQuantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("InvQty", "shippedQuantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          true,
          false,
          this.onRollLineShippedQtyChange,
          null,
          this.onRollLineShippedQtyBlur
        )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VenLot#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchasOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    return columns;
  };
  // RollLineLineDetailsColumnDefinitions = () => {
  //   let columnList = [];
  //   let moduleCaption = this.props.moduleCaption;
  //   let roll = new InvoiceRollLineBean();

  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails("", "isApplied", 0, false, null, false, null)
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.onRollSelectedChange
  //       )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       this.props.is3PL ? "Inventory#" : "RollSKU#",
  //       "rollSkuNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Box#", "boxNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Roll#", "rollNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("AvailQty", "availableQuantity")
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails("InvQty", "shippedQuantity", 0, false, null, false, null)
  //       .setEditableDetails(
  //         true,
  //         "",
  //         this.onRollLineShippedQtyChange,
  //         false,
  //         null,
  //         false,
  //         null,
  //         this.onRollLineShippedQtyBlur
  //       )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("VenLot#", "vendorBatchNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("PO#", "purchasOrderNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PR#",
  //       "purchaseOrderReceiptNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Location", "locationCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Bin#", "binLocation")
  //   );

  //   return columnList;
  // };
  openItemCurrentInvInq = (code) => {
    this.props.openItemCurrentInvInq(code);
  };
  render() {
    let invoiceData = this.props.invoiceData;
    let invoiceLineData = this.props.invoiceLineData;
    let rollLines = [];
    let totalRolls = 0;
    let totalRollList = [];
    if (!isEmpty(invoiceLineData) && !isEmptyArray(invoiceLineData.rollLines)) {
      rollLines = invoiceLineData.rollLines;
      invoiceLineData.rollLines.map((ln) => {
        if (ln.shippedQuantity > 0) {
          totalRollList.push(ln);
        }
      });
      totalRolls = totalRollList.length;
    }

    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableInvoiceFormFields = this.props.isDisableFields;
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    let invoiceStatus = "";
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.invoiceStatus))
      invoiceStatus = ModuleUtils.getInvoiceStatusCaption(
        invoiceData.invoiceStatus
      );

    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "250px",
          maxHeight: "250px",
          overflowY: "auto",
        },
      },
    };
    let is3PL = this.props.is3PL;
    return (
      <div className="sales_line_pop">
        <div className="header_div col-md-12 col-lg-12">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Invoice#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="code"
                  type="text"
                  onChange={this.props.onChange}
                  readOnly={disableInvoiceFormFields}
                  value={invoiceData.code}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Customer</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  //ref={this.customerCodeRef}
                  name="customerCode"
                  type="text"
                  onChange={this.props.onChange}
                  readOnly={true}
                  value={invoiceData.customerCode}
                />{" "}
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.props.onChange}
                  readOnly={true}
                  value={invoiceData.customerName}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel>PO#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="customerPurchaseOrderNumber"
                  onChange={this.props.onChange}
                  readOnly={true}
                  value={invoiceData.customerPurchaseOrderNumber}
                />
              </Col>
            </Row>
          </div>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>SalesOrder# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesOrderNumber"
                onChange={this.props.onChange}
                readOnly={true}
                value={invoiceData.salesOrderNumber}
              />{" "}
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>Status</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="invoiceStatus"
                value={invoiceStatus}
                disabled={true}
              ></InputTextbox>
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>Ln# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                onChange={this.props.onLineChange}
                readOnly={true}
                value={invoiceLineData.lineNumber}
                isMandatory={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>PickTicket# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.pickTicketRef}
                name="sourcePickTicketNumber"
                placeholder="PickTicketNumber"
                onChange={this.props.onPickTicketLineChange}
                value={invoiceLineData.sourcePickTicketNumber}
                lookupRequired={true}
                lookupHandler={this.state.pickTicketLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={
                  this.props.pickTicketCodeEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.pickTicketPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompletePickTicketList
                }
                showAutoCompleteList={this.props.showAutoCompletePickTicketList}
                // disabled={this.props.isPtDisable}
                // disabled={true} // commented for 3pl
                isMandatory={true}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>PTLn# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.pickTicketLineRef}
                name="sourcePickTicketLineNumber"
                placeholder="PickTicketLineNumber"
                onChange={this.props.onPtLineChange}
                value={invoiceLineData.sourcePickTicketLineNumber}
                lookupRequired={this.props.isShowPtLineLookup}
                lookupHandler={this.props.pickTicketLineLookupHandler}
                disabled={this.props.isPtDisable}
                isMandatory={true}
              />{" "}
            </Col>

            <Col className="so-align-items-left" sm="1">
              {is3PL ? (
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.props.lnkFabricStyleModule(e)}
                >
                  Item#
                </FormLabel>
              ) : (
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.props.lnkFabricStyleModule(e)}
                >
                  Fabric#
                </FormLabel>
              )}
              <Col className="so-align-items-left">
                <ShortCutMenuPopup
                  value={invoiceLineData.fabricStyleCode}
                  menuItems={
                    <ul>
                      <li
                        className="shortcut-menu-item"
                        onClick={(e) => this.props.lnkFabricStyleModule(e)}
                      >
                        {" "}
                        Item Info{" "}
                      </li>

                      <li
                        className="shortcut-menu-item"
                        // onClick={this.lnkCustomerFabricSalesModule}
                        onClick={(e) =>
                          this.props.openFabricSalesHistoryInq(
                            e,
                            invoiceLineData.fabricStyleCode
                          )
                        }
                      >
                        {" "}
                        Customer Item Sales History{" "}
                      </li>

                      <li
                        className="shortcut-menu-item"
                        // onClick={this.lnkFabricCurrentInvModule}
                        onClick={(e) =>
                          this.props.openItemCurrentInvInq(
                            e,
                            invoiceLineData.fabricStyleCode
                          )
                        }
                      >
                        {" "}
                        Item Current Inventory Level{" "}
                      </li>

                      <li
                        className="shortcut-menu-item"
                        // onClick={this.lnkFabricInventoryPosition}
                        onClick={(e) =>
                          this.props.openItemInvPositionInq(
                            e,
                            invoiceLineData.fabricStyleCode
                          )
                        }
                      >
                        {" "}
                        Item Inventory Position{" "}
                      </li>

                      <li
                        className="shortcut-menu-item"
                        // onClick={this.lnkFabricPurchaseHistory}
                        onClick={(e) =>
                          this.props.openItemPurchaseHistoryInq(
                            e,
                            invoiceLineData.fabricStyleCode
                          )
                        }
                      >
                        {" "}
                        Item Purchase History{" "}
                      </li>

                      <li
                        className="shortcut-menu-item"
                        // onClick={this.lnkFabricAts}
                        onClick={(e) =>
                          this.props.openAtsInq(
                            e,
                            invoiceLineData.fabricStyleCode
                          )
                        }
                      >
                        {" "}
                        Item ATS{" "}
                      </li>
                    </ul>
                  }
                />
              </Col>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                onChange={this.props.onChange}
                readOnly={true}
                value={invoiceLineData.fabricStyleCode}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleName"
                onChange={this.props.onLineChange}
                readOnly={true}
                value={invoiceLineData.fabricStyleName}
                isMandatory={true}
              />{" "}
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>Color</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="colorCode"
                onChange={this.props.onLineChange}
                readOnly={true}
                value={invoiceLineData.colorCode}
                isMandatory={true}
              />{" "}
            </Col>
          </Row>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>UOM </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="orderUomCode"
                placeholder="UOM"
                onChange={this.props.onLineChange}
                readOnly={true}
                value={invoiceLineData.uomCode}
                isMandatory={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Price </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.price}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"price"}
                disabled={disableInvoiceFormFields}
                isMandatory={true}
              />
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>InvQty</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.shippedQuantity}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"orderQuantity"}
                disabled={true}
                isMandatory={true}
              />
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>TotalAmt</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.lineTotalAmount}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"lineTotalAmount"}
                disabled={true}
              />
            </Col>
          </Row>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Disc%</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.discountPercentage}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"discountPercentage"}
                disabled={true}
              />
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>DiscountAmt</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.lineDiscountAmount}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"lineDiscountAmount"}
                disabled={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Extension</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.lineNetAmount}
                onChange={this.props.onLineChange}
                className="qty_input text-right summary_input"
                decimalScale={2}
                name={"lineNetAmount"}
                disabled={true}
              />
            </Col>

            {/* <Col className="align-items-left" sm="1">
              <FormLabel>Tarrif%</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.tariffPercentage}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"tariffPercentage"}
                disabled={this.props.isTarrifDisable}
              />
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>TarrifAmt</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceLineData.tariffAmount}
                onChange={this.props.onLineChange}
                className="text-right"
                decimalScale={2}
                name={"tariffAmount"}
                disabled={true}
              />
            </Col> */}
          </Row>

          {/* <Row>
          
          </Row> */}

          <div>
            {/* {this.props.is3PL ? (
              <div className="div_Custom_2">
                {" "}
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "rollSkuNumber")
                        }
                      >
                        {this.props.is3PL ? "Inventory#" : "RollSKU#"}
                        {this.props.order === "desc" &&
                        this.props.sortField === "rollSkuNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "boxNumber")
                        }
                      >
                        Box#
                        {this.props.order === "desc" &&
                        this.props.sortField === "boxNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "rollNumber")
                        }
                      >
                        Roll#
                        {this.props.order === "desc" &&
                        this.props.sortField === "rollNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "availableQuantity")
                        }
                      >
                        AvailableQuantity
                        {this.props.order === "desc" &&
                        this.props.sortField === "availableQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "shippedQuantity")
                        }
                      >
                        InvQty
                        {this.props.order === "desc" &&
                        this.props.sortField === "shippedQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "vendorBatchNumber")
                        }
                      >
                        VenLot#
                        {this.props.order === "desc" &&
                        this.props.sortField === "vendorBatchNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "purchasOrderNumber")
                        }
                      >
                        PO#
                        {this.props.order === "desc" &&
                        this.props.sortField === "purchasOrderNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(
                            e,
                            "purchaseOrderReceiptNumber"
                          )
                        }
                      >
                        PR#
                        {this.props.order === "desc" &&
                        this.props.sortField ===
                          "purchaseOrderReceiptNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "locationCode")
                        }
                      >
                        Location
                        {this.props.order === "desc" &&
                        this.props.sortField === "locationCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th>Bin#</th>
                    </tr>
                  </thead>
                  {rollLines != null ? (
                    <tbody>
                      {rollLines.map((ln, index) => (
                        <tr key={index}>
                          <td className="">{ln.rollSkuNumber}</td>
                          <td>{ln.boxNumber}</td>
                          <td>{ln.rollNumber}</td>
                          <td>{ln.availableQuantity}</td>
                          <td>{ln.shippedQuantity}</td>
                          <td>{ln.vendorBatchNumber}</td>
                          <td>{ln.purchasOrderNumber}</td>
                          <td>{ln.purchaseOrderReceiptNumber}</td>
                          <td>{ln.locationCode}</td> <td>{ln.binLocation}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {rollLines.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            ) : (
              <EditableDataGrid
                customStyles={dataTableStyles}
                columnsList={this.RollLineLineDetailsColumnDefinitions()}
                dataList={rollLines}
              />
            
            )} */}
            <CustomTable columns={this.rollLineColumns()} data={rollLines} label={"RollLines"} />
          </div>
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Inv Qty</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  className="summary_input text-right"
                  disabled={true}
                  value={invoiceLineData.shippedQuantity}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                <FormLabel>NoOfRolls</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  className="summary_input text-right"
                  disabled={true}
                  value={totalRolls}
                ></InputTextbox>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class ShippingInformationEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.cityRef = React.createRef();
    this.state = {};
    this.shipToCodeRef = React.createRef();
    this.shipViaCodeRef = React.createRef();
    this.freightMethodCodeRef = React.createRef();
  }

  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.setInputFocus();
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cityList,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.stateList,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countryList,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let shipToLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipTos,
      "ShipTo"
    );
    this.setState({ shipToLookupHandler: shipToLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let freightMethodLookupHandler = new GenericAttributeLookupHandler(
      this.props.freightMethods,
      "FreightMethods"
    );
    this.setState({ freightMethodLookupHandler: freightMethodLookupHandler });
  };

  componentDidUpdate() {
    //
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  addressOnChange = (e) => {
    this.props.addressOnChange(e);
  };
  addNewBoxLine = (e) => {
    if (e.detail == 1) this.props.addNewBoxLine();
  };
  setInputFocus() {
    this.customerCodeRef.current.focus();
  }

  lnkBoxLineDetailsClick = (e, rowData) => {
    if (e.detail == 1) this.props.lnkBoxLineDetailsClick(rowData);
  };

  deleteBoxLine = (e, rowData) => {
    if (e.detail <= 1) this.props.deleteBoxLine(rowData);
  };

  displayAutoCompleteCityList = (list) => {
    this.props.displayAutoCompleteCityList(list);
  };
  cityEnterKeyEventHandler = (e) => {
    this.props.cityEnterKeyEventHandler(e);
  };
  displayAutoCompleteStateList = (list) => {
    this.props.displayAutoCompleteStateList(list);
  };
  stateEnterKeyEventHandler = (e) => {
    this.props.stateEnterKeyEventHandler(e);
  };
  displayAutoCompleteCountryList = (list) => {
    this.props.displayAutoCompleteCountryList(list);
  };
  countryEnterKeyEventHandler = (e) => {
    this.props.countryEnterKeyEventHandler(e);
  };
  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };

  render() {
    let invoiceData = new InvoiceBean();
    let customerList = [];
    customerList = this.props.customerList;
    let isModify = false;
    isModify = this.props.isModifyPosible;
    let disableInvoiceFormFields = this.props.isDisableFields;
    let disableUpdatableFields = false;
    if (!this.props.isViewMode) {
      if (disableInvoiceFormFields) {
        if (isModify) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    } else {
      disableUpdatableFields = true;
    }

    invoiceData = this.props.invoiceData;
    let lines = [];
    let boxDetailLines = [];
    let address = new AddressBean();

    if (invoiceData != null) {
      if (this.props.addressData != null) {
        address = this.props.addressData;
      }

      if (invoiceData.address != null) {
        address = invoiceData.address;
      }

      if (!isEmptyArray(invoiceData.pickTicketLines)) {
        invoiceData.pickTicketLines.map((line) => {
          lines.push(line);
        });
        lines.reverse();
      }
      if (!isEmptyArray(invoiceData.boxDetails)) {
        invoiceData.boxDetails.map((line) => {
          boxDetailLines.push(line);
        });
      }
    }
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "9em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Invoice#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="code"
                  type="text"
                  onChange={this.onChange}
                  value={invoiceData.code}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Customer</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  ref={this.customerCodeRef}
                  name="customerCode"
                  type="text"
                  onChange={this.onChange}
                  value={invoiceData.customerCode}
                  disabled={true}
                />{" "}
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  value={invoiceData.customerName}
                  disabled={true}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel>Currency </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="invoiceCurrencyCode"
                  onChange={this.onChange}
                  value={invoiceData.invoiceCurrencyCode}
                  disabled={true}
                  isMandatory={true}
                />{" "}
              </Col>
            </Row>
          </div>

          <Row>
            <FormLabel className="label_head">Shipping details</FormLabel>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>ShipVia</FormLabel>
            </Col>
            <Col sm="2">
              {/* <InputTextbox
                name="shipViaCode"
                placeholder="ShipVia"
                onChange={this.onChange}
                value={invoiceData.shipViaCode}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "} */}
              <InputTextbox
                ref={this.shipViaCodeRef}
                name="shipViaCode"
                placeholder="shipViaCode"
                onChange={this.props.onShipViaChange}
                // readOnly={disablePickTicketFormFields}
                value={invoiceData.shipViaCode}
                lookupRequired={true}
                lookupHandler={this.state.shipViaLookupHandler}
                enterKeyEventHandler={this.props.shipViaEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipViaPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteShipViaList
                }
                showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>ShipmentCrg</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceData.shipmentChargesAmount}
                onChange={this.props.onHeaderAmountsChange}
                className="text-right"
                decimalScale={2}
                name={"shipmentChargesAmount"}
                disabled={disableInvoiceFormFields}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Fr.Method </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.freightMethodCodeRef}
                name="freightMethodCode"
                placeholder="freightMethodCode"
                onChange={this.props.onFreightMethodChange}
                // readOnly={disablePickTicketFormFields}
                value={invoiceData.freightMethodCode}
                lookupRequired={true}
                lookupHandler={this.state.freightMethodLookupHandler}
                enterKeyEventHandler={
                  this.props.freightMethodEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.freightMethodPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteFreightMethodList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteFreightMethodList
                }
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>{" "}
            <Col sm="1">
              <FormLabel>ShipTo</FormLabel>
            </Col>
            <Col sm="2">
              {/* <InputTextbox
                name="shipToCode"
                placeholder="ShipToCode"
                onChange={this.onChange}
                value={invoiceData.shipToCode}
                //lookupValues={this.props.shipTos}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              /> */}
              <InputTextbox
                ref={this.shipToCodeRef}
                name="shipToCode"
                placeholder="ShipToCode"
                onChange={this.props.onShipToChange}
                value={invoiceData.shipToCode}
                lookupRequired={true}
                lookupHandler={this.state.shipToLookupHandler}
                enterKeyEventHandler={this.props.shipToEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipToPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteShipToList
                }
                showAutoCompleteList={this.props.showAutoCompleteShipToList}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                isMandatory={true}
              />
            </Col>{" "}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>ShipToName</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipToName"
                placeholder="ShipToName"
                onChange={this.onChange}
                value={invoiceData.shipToName}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                isMandatory={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>ShippedBy</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shippedBY"
                placeholder="shippedBY"
                onChange={this.onChange}
                value={invoiceData.shippedBY}
                disabled={disableInvoiceFormFields}
              // isModifyView={isModify}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>ShippedDate</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shippedDate"
                placeholder="shippedDate"
                onChange={this.onChange}
                value={invoiceData.shippedDate}
                disabled={disableInvoiceFormFields}
              // isModifyView={isModify}
              />{" "}
            </Col>
          </Row>

          <div className="pickticket_shipment_main_div">
            <div className="pickticket_shipment_carrier_detail_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">CarrierDetails</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="carrierDetails"
                    type="text"
                    placeholder="CarrierDetails"
                    onChange={this.onChange}
                    value={invoiceData.carrierDetails}
                    disabled={disableInvoiceFormFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_shipping_instructions_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">
                    ShippingInstructions
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="shipmentInstructions"
                    type="text"
                    placeholder="ShipmentInstructions"
                    onChange={this.onChange}
                    value={invoiceData.shipmentInstructions}
                    disabled={disableInvoiceFormFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_cus_shipment_account_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">
                    Shipment AccDetail
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="shipmentInstructions"
                    type="text"
                    placeholder="ShipmentInstructions"
                    onChange={this.onChange}
                    value={invoiceData.shipmentInstructions}
                    disabled={disableInvoiceFormFields}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <Row>
            <FormLabel className="label_head">Address</FormLabel>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Address1</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                placeholder="Address1"
                onChange={this.addressOnChange}
                value={address.address1}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Address2</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                placeholder="Address2"
                onChange={this.addressOnChange}
                value={address.address2}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCityChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={address.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.props.cityEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onStateChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={address.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCountryChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={address.country}
                disabled={disableUpdatableFields}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.countryPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCountryList}
                showAutoCompleteList={this.props.showAutoCompleteCountryList}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Zip</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                placeholder="Zip"
                onChange={this.addressOnChange}
                value={address.zip}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone1#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                placeholder="Phone1"
                onChange={this.addressOnChange}
                value={address.phone1}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone2#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                placeholder="Phone2"
                onChange={this.addressOnChange}
                value={address.phone2}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Mobile#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                placeholder="Mobile"
                onChange={this.addressOnChange}
                value={address.mobilePhone}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>EMail</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                placeholder="EMail"
                onChange={this.addressOnChange}
                value={address.email}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Website</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                placeholder="Website"
                onChange={this.addressOnChange}
                value={address.website}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
          </Row>

          <div className="total_amounts_and_table_div col-md-12 col-lg-12">
            <Row>
              <Col sm="2" className="title_text_div">
                <FormLabel className="table_title">Box Details</FormLabel>
              </Col>
              {/* {this.props.isDisabledFields != true && (
                <Col sm="1">
                 
                </Col>
              )} */}
            </Row>
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>
                    <Button
                      size="sm"
                      onClick={(e) => this.addNewBoxLine(e)}
                      disabled={disableInvoiceFormFields}
                      id="fabric_Add_Button"
                    >
                      <AddIcon />
                    </Button>
                  </th>
                  <th>Box#</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Width</th>
                  <th>COD</th>
                  <th>Insured</th>
                  <th>Tracking#</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {boxDetailLines.map(
                  (bx, i) =>
                    bx.isDeleted != true && (
                      <tr key={i} data-item={bx}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.lnkBoxLineDetailsClick(e, bx)}
                          >
                            {bx.boxLineNumber}
                          </Button>
                        </td>
                        <td>{bx.boxNumber}</td>
                        <td>{bx.weightInLbs}</td>
                        <td>{bx.lengthInInces}</td>
                        <td>{bx.widthInInces}</td>
                        <td>{bx.codValue}</td>
                        <td>{bx.insuredValue}</td>
                        <td>{bx.trackingNumber}</td>
                        <td>
                          <button
                            id="fabric_Add_Button"
                            className="enterFocus"
                            size="sm1"
                            bssize="large"
                            onClick={(e) => this.deleteBoxLine(e, bx)}
                          >
                            <DeleteIcon />
                          </button>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </div>
        </div>{" "}
      </div>
    );
  }
}

class ShippingBoxPopupForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.boxTypeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  componentDidUpdate() {
    //
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  onBoxLineChange = (e) => {
    this.props.onBoxLineChange(e);
  };
  displayAutoCompleteBoxTypeList = (list) => {
    this.props.displayAutoCompleteBoxTypeList(list);
  };
  onBoxTypeChange = (e) => {
    this.props.onBoxTypeChange(e);
  };
  boxTypeEnterKeyEventHandler = (e) => {
    this.props.boxTypeEnterKeyEventHandler(e);
  };

  //#endregion

  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };

  render() {
    let invoiceData = new InvoiceBean();
    invoiceData = this.props.invoiceData;
    let disableInvoiceFormFields = this.props.isDisableFields;
    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    let invoiceBoxLineData = this.props.invoiceBoxLineData;

    return (
      <div>
        {/* <div className="header_div col-md-12 col-lg-12"> */}
        <div className="">
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Invoice#</FormLabel>
            </Col>

            <Col sm="3">
              <InputTextbox
                name="code"
                type="text"
                onChange={this.onChange}
                disabled={true}
                value={invoiceData.code}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Customer</FormLabel>{" "}
            </Col>

            <Col sm="3">
              <InputTextbox
                ref={this.customerCodeRef}
                name="customerCode"
                type="text"
                onChange={this.onChange}
                disabled={true}
                value={invoiceData.customerCode}
              />{" "}
            </Col>

            <Col sm="4">
              <InputTextbox
                name="customerName"
                type="text"
                onChange={this.onChange}
                disabled={true}
                value={invoiceData.customerName}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>PO#</FormLabel>
            </Col>

            <Col sm="3">
              <InputTextbox
                name="customerPurchaseOrderNumber"
                onChange={this.onChange}
                disabled={true}
                value={invoiceData.customerPurchaseOrderNumber}
              />
            </Col>
          </Row>
        </div>

        <Row>
          <Col className="align-items-left title_text_div" sm="2">
            <FormLabel>BoxDetail </FormLabel>{" "}
          </Col>{" "}
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Line# </FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="boxLineNumber"
              onChange={this.onBoxLineChange}
              disabled={true}
              value={invoiceBoxLineData.boxLineNumber}
              isMandatory={true}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Box#</FormLabel>
          </Col>

          <Col sm="3">
            <InputTextbox
              name="boxNumber"
              placeholder="BoxNumber"
              onChange={this.onBoxLineChange}
              disabled={disableInvoiceFormFields}
              value={invoiceBoxLineData.boxNumber}
              isMandatory={true}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>WeightInLbs</FormLabel>
          </Col>

          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.weightInLbs}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"weightInLbs"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          {/* <Col className="align-items-left" sm="1">
            <FormLabel>BoxType</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              onChange={this.onBoxTypeChange}
              ref={this.boxTypeRef}
              name="boxType"
              placeholder="BoxType"
              readOnly={disableUpdatableFields}
              disabled={disableUpdatableFields}
              value={invoiceBoxLineData.boxType}
              lookupRequired={true}
              lookupHandler={this.state.boxTypeLookupHandler}
              enterKeyEventHandler={this.boxTypeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.boxTypePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteBoxTypeList}
              showAutoCompleteList={this.props.showAutoCompleteBoxTypeList}
            />
          </Col> */}

          <Col className="align-items-left" sm="1">
            <FormLabel>LengthInInch</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.lengthInInces}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"lengthInInces"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>HeightInInch</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.heightInInces}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"heightInInces"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>WidthInInch</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.widthInInces}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"widthInInces"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>CODValue</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.codValue}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"codValue"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>InsuredValue</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              value={invoiceBoxLineData.insuredValue}
              onChange={this.onBoxLineChange}
              decimalScale={2}
              name={"insuredValue"}
              disabled={disableInvoiceFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          {/* <Col className="align-items-left" sm="1">
            <FormLabel>CODFunds</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="codFundsCode"
              placeholder="COD Funds"
              onChange={this.onBoxLineChange}
              readOnly={disableUpdatableFields}
              value={invoiceBoxLineData.codFundsCode}
            />{" "}
          </Col> */}
          <Col className="align-items-left" sm="1">
            <FormLabel>Tracking#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="trackingNumber"
              placeholder="Tracking#"
              onChange={this.onBoxLineChange}
              disabled={disableInvoiceFormFields}
              value={invoiceBoxLineData.trackingNumber}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
      </div>
    );
  }
}

class PaymentDetailsForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isShowARModule: false,
      isShowCreditMemoModule: false,
      isShowUnPostedARPopup: false,
      isShowPostedAppliedPopup: false,
      isShowPostedCMPopup: false,
      unPostedArList: [],
      postedAppliedList: [],
      postedCMList: [],
      moduleForPopup: [],
      criteria: new CheckPaymentDetailsPaymentInquiryCriteriaBean(),
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      inquiryData: null,
      checkAppliedInvoiceList: [],
      creditMemoAppliedInvoiceList: [],
      creditMemoList: [],
      reversedCheckList: [],
      creditMemoData: null,
      isShowAllPaymentPopup: false,
      allPaymentList: [],
      error_list: [],
      isShowAlert: false,
      paymentRowData: "",
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  documentNumberClick = (e, val, rowData) => {
    if (e.detail == 1) {
      let invoiceData = this.props.invoiceData;
      let criteria = new CheckPaymentDetailsPaymentInquiryCriteriaBean();
      criteria.companyCode = invoiceData.companyCode;
      criteria.customerCode = invoiceData.customerCode;
      if (rowData.paymentType == 1) {
        criteria.checkNumber = val;
        // criteria.checkDate = rowData.paymentDate;
      } else if (rowData.paymentType == 2) {
        criteria.creditMemoNumber = val;
      } else if (rowData.paymentType == 3 || rowData.paymentType == 4) {
        criteria.cardNumber = val;
      }
      this.loadAllPaymentInquiryList(criteria);
      this.setState({ paymentRowData: rowData });
    }
  };
  loadAllPaymentInquiryList = (criteria) => {
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      ReportService.inquireCheckPaymentHistoryReport(
        criteria,
        this.allPaymentInquiryPageResponse,
        this.allPaymentInquiryPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  allPaymentInquiryPageResponse = (response) => {
    if (response.data != null) {
      let inquiryDataList = response.data.result;

      if (inquiryDataList != null) {
        let inquiryData = response.data.result.infoBean;
        let checkAppliedInvoiceList = [];

        if (!isEmptyArray(response.data.result.checkAppliedInvoices)) {
          checkAppliedInvoiceList = response.data.result.checkAppliedInvoices;
        }
        if (!isEmptyArray(response.data.result.creditMemoAppliedInvoices)) {
          let creditMemoAppliedInvoiceList =
            response.data.result.creditMemoAppliedInvoices;
          this.setState({
            creditMemoAppliedInvoiceList: creditMemoAppliedInvoiceList,
          });
        }

        let creditMemoData = response.data.result.creditMemoBean;
        if (!isEmptyArray(response.data.result.reversedCheckDetails)) {
          let reversedCheckList = response.data.result.reversedCheckDetails;
          this.setState({ reversedCheckList: reversedCheckList });
        }

        this.setState({
          allPaymentList: checkAppliedInvoiceList,
          inquiryData: inquiryData,
          creditMemoData: creditMemoData,
          isShowAllPaymentPopup: true,
        });
      }
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  allPaymentInquiryPageError = (error) => {
    ShowError("Error : " + error);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  paymentDetailsColumnDefinitions = () => {
    let columnList = [];

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber")
        .setSortColumn(true)
        .setColumnType("hyperLink")
        .callHyperLinkCallback(this.viewARModule)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Type", "paymentType") // 1 - Cheque, 2-CreditMemo, 3 -CreditCard, 4- DebitCard , 5- Cash , 6-ChargeBack
        .setColumnType("statusColumn")
        .setStatusCaptionConverter(this.toPaymentType)
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Doc#", "documentNumber")
        .setSortColumn(true)
        .setColumnType("hyperLink")
        .callHyperLinkCallback(this.documentNumberClick)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("AppliedAmt", "paymentAmount")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("PaymentDate", "paymentDate")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("PostDate", "paymentPostDate")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Status", "isApplied")
        .setColumnType("statusColumn")
        .setStatusCaptionConverter(this.toPaymentStatus)
        .setSortColumn(true)
    );

    return columnList;
  };

  toPaymentType = (type) => {
    let finalType = " ";
    if (type == 1) finalType = "Check";
    else if (type == 2) finalType = "CreditMemo";
    else if (type == 3) finalType = "CreditCard";
    else if (type == 4) finalType = "DebitCard";
    else if (type == 5) finalType = "Cash";
    else if (type == 6) finalType = "ChargeBack";
    else if (type == 8) finalType = "Wire Transfer";
    else if (type == 9) finalType = "Ach";

    return finalType;
  };

  toPaymentStatus = (applied) => {
    let finalType = "UnPosted";
    if (applied) finalType = "Posted";

    return finalType;
  };

  unPostedAmountClick = (e, val) => {
    if (e.detail == 1) {
      let invoiceData = this.props.invoiceData;
      let request = new RestReadRequest();
      request.companyCode = invoiceData.companyCode;
      request.code = invoiceData.code;
      if (val > 0) {
        if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
          AccountReceivableService.getUnPostedARDetailsForInvoices(
            request,
            this.getUnPostedARDetailPageResponse,
            this.getUnPostedARDetailPageError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  getUnPostedARDetailPageResponse = (response) => {
    if (response.data != null && response.data.resultBean != null) {
      let unPostedList = response.data.resultBean.unpostedAr;
      if (unPostedList != null || !isEmptyArray(unPostedList)) {
        this.setState({
          unPostedArList: unPostedList,

          isShowUnPostedARPopup: true,
        });
      }
    }
  };
  getUnPostedARDetailPageError = (error) => {
    ShowError("Error :", error);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowUnPostedARPopup: isShowPopup,
      isShowPostedAppliedPopup: isShowPopup,
      isShowPostedCMPopup: isShowPopup,
      isShowAllPaymentPopup: isShowPopup,
    });
  };
  postedCMAmountClick = (e, val) => {
    if (val > 0 && e.detail == 1) {
      let accountReceivableList = this.props.accountReceivablePaymentDetails;
      let postedCMList = [];
      for (let list of accountReceivableList) {
        if (list.paymentType === 2 && list.applied === true) {
          postedCMList.push(list);
        }
      }
      this.setState({ postedCMList: postedCMList, isShowPostedCMPopup: true });
    }
  };
  postedAmountClick = (e, val) => {
    if (val > 0 && e.detail == 1) {
      let accountReceivableList = this.props.accountReceivablePaymentDetails;
      let postedAppliedList = [];
      for (let list of accountReceivableList) {
        if (
          list.paymentType != 6 &&
          list.paymentType != 2 &&
          list.applied === true
        ) {
          postedAppliedList.push(list);
        }
      }
      this.setState({
        postedAppliedList: postedAppliedList,
        isShowPostedAppliedPopup: true,
      });
    }
  };

  render() {
    let invoiceData = new InvoiceBean();
    invoiceData = this.props.invoiceData;
    let accountReceivablePaymentDetails = [];
    if (!isEmptyArray(this.props.accountReceivablePaymentDetails))
      accountReceivablePaymentDetails =
        this.props.accountReceivablePaymentDetails;
    let invoiceStatus = "";
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.invoiceStatus))
      invoiceStatus = ModuleUtils.getInvoiceStatusCaption(
        invoiceData.invoiceStatus
      );

    let grantTotalAmount = invoiceData.grandTotalAmount;
    let postedPaidAmount = invoiceData.netPaidAmount;
    let unPostedPaidAmount =
      invoiceData.provisionalChargeBackAmount +
      invoiceData.provisionalOtherAppliedAmount +
      invoiceData.provisionalCreditMemoAmount;

    let openInvoiceAmount =
      grantTotalAmount - (postedPaidAmount + unPostedPaidAmount);
    let checkAppliedInvoiceList = this.state.checkAppliedInvoiceList;
    let creditMemoAppliedInvoiceList = this.state.creditMemoAppliedInvoiceList;
    let creditMemoList = this.state.creditMemoList;
    let reversedCheckList = this.state.reversedCheckList;
    let creditMemoData = this.state.creditMemoData;
    let inquiryDataList = this.state.allPaymentList;
    let criteria = this.state.criteria;
    let inquiryData = this.state.inquiryData;
    let paymentRowData = this.state.paymentRowData;
    return (
      <div className="header_div">
        <div className="">
          <div className="">
            <Row>
              <Col sm="1">
                <FormLabel>Total(Sales)Amt </FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.grandTotalAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"grandTotalAmount"}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Status </FormLabel>{" "}
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  name="invoiceStatus"
                  value={invoiceStatus}
                  disabled={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <FormLabel>DueAmt </FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={openInvoiceAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"openInvoiceAmount"}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>UnPostedAmountDetails</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.unPostedAmountClick(
                      e,
                      invoiceData.provisionalOtherAppliedAmount
                    )
                  }
                >
                  UnPostedApp
                </FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.provisionalOtherAppliedAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"provisionalOtherAppliedAmount"}
                  disabled={true}
                />
              </Col>

              <Col sm="1">
                <FormLabel>UnPostedCM</FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.provisionalCreditMemoAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"provisionalCreditMemoAmount"}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>TotalUnPosted</FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={unPostedPaidAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"unPostedPaidAmount"}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>PostedAmountDetails</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.postedAmountClick(
                      e,
                      invoiceData.paidOtherAppliedAmount
                    )
                  }
                >
                  PostedApp
                </FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.paidOtherAppliedAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"paidOtherAppliedAmount"}
                  disabled={true}
                />
              </Col>

              <Col sm="1">
                <FormLabel
                  className="hyperLinkText"
                  onClick={(e) =>
                    this.postedCMAmountClick(
                      e,
                      invoiceData.paidCreditMemoAmount
                    )
                  }
                >
                  PostedCM
                </FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.paidCreditMemoAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"provisionalCreditMemoAmount"}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>TotalPaymentAmt</FormLabel>{" "}
              </Col>

              <Col sm="3">
                <NumberFormatInputbox
                  value={invoiceData.netPaidAmount}
                  onChange={this.onChange}
                  className="qty_input text-right"
                  decimalScale={2}
                  name={"netPaidAmount"}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>PaymentDetails</FormLabel>{" "}
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <div className="div_Custom_2">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>AR#</th>
                        <th>Type</th>
                        <th>Doc#</th>
                        <th>AppliedAmt</th>
                        <th>Currency</th>
                        <th>PaymentDate</th>
                        <th>PostDate</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    {accountReceivablePaymentDetails != null ? (
                      <tbody>
                        {accountReceivablePaymentDetails.map((ar, index) => (
                          <tr key={index}>
                            <td className="hyperLinkText">
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewARModule(
                                    e,
                                    ar.accountReceivableNumber
                                  )
                                }
                              >
                                {ar.accountReceivableNumber}
                              </Button>
                            </td>
                            <td>{this.toPaymentType(ar.paymentType)}</td>
                            <td className="hyperLinkText">
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.documentNumberClick(
                                    e,
                                    ar.documentNumber,
                                    ar
                                  )
                                }
                              >
                                {ar.documentNumber}
                              </Button>
                            </td>
                            <td className="text-right">{toCommaSeperatedAmount(ar.paymentAmount)}</td>
                            <td>{ar.currencyCode}</td>
                            <td>
                              {ModuleUtils.getDateFormat_v1(ar.paymentDate)}
                            </td>
                            <td>
                              {ModuleUtils.getDateFormat_v1(ar.paymentPostDate)}
                            </td>
                            <td>{this.toPaymentStatus(ar.isApplied)}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        {/* UnPosted Popup */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowUnPostedARPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel> Details </FormLabel>
                </Col>
              </Row>
              <Table>
                <thead>
                  <th>AR</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Document</th>
                  <th>Applied Amount</th>
                  <th>Currency</th>
                </thead>
                <tbody>
                  {this.state.unPostedArList.map((list, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewARModule(
                              e,
                              list.accountReceivableNumber,
                              list
                            )
                          }
                        >
                          {list.accountReceivableNumber}
                        </Button>
                      </td>
                      <td>
                        {ModuleUtils.getDateFormat_v1(
                          list.accountReceivableDate
                        )}
                      </td>
                      <td>{this.toPaymentType(list.paymentType)}</td>
                      <td>{list.documentNumber}</td>
                      <td>{list.paymentAmount}</td>
                      <td>{list.currencyCode}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          }
        />

        {/* Posted CreditMemo Popup */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPostedCMPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel> Details </FormLabel>
                </Col>
              </Row>
              <Table>
                <thead>
                  <th>AR</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Document</th>
                  <th>Applied Amount</th>
                  <th>Currency</th>
                </thead>
                {this.state.postedCMList && (
                  <tbody>
                    {this.state.postedCMList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewARModule(
                                e,
                                list.accountReceivableNumber,
                                list
                              )
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>
                          {ModuleUtils.getDateFormat_v1(
                            list.accountReceivableDate
                          )}
                        </td>
                        <td>{this.toPaymentType(list.paymentType)}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCreditMemoModule(
                                e,
                                list.documentNumber,
                                list
                              )
                            }
                          >
                            {list.documentNumber}
                          </Button>
                        </td>
                        <td>{list.paymentAmount}</td>
                        <td>{list.currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />

        {/* Posted Applied Popup  */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPostedAppliedPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel> Details </FormLabel>
                </Col>
              </Row>
              <Table>
                <thead>
                  <th>AR</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Document</th>
                  <th>Applied Amount</th>
                  <th>Currency</th>
                </thead>
                {this.state.postedAppliedList && (
                  <tbody>
                    {this.state.postedAppliedList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewARModule(
                                e,
                                list.accountReceivableNumber,
                                list
                              )
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>
                          {ModuleUtils.getDateFormat_v1(
                            list.accountReceivableDate
                          )}
                        </td>
                        <td>{this.toPaymentType(list.paymentType)}</td>
                        <td>{list.documentNumber}</td>
                        <td>{list.paymentAmount}</td>
                        <td>{list.currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />
        {/* All Payment Popup  */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowAllPaymentPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <div>
                {inquiryData != null && (
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={invoiceData.customerCode}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>AR#</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={inquiryData.accountReceivableNumber}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>BankName</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={inquiryData.issuerBankName}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">
                      {" "}
                      <FormLabel>AR Status</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={inquiryData.arStatus}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                )}
                {inquiryData != null &&
                  paymentRowData != null &&
                  paymentRowData.paymentType == 1 && (
                    <Row>
                      <Col sm="1">
                        {" "}
                        <FormLabel>CheckAmount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={inquiryData.checkAmount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>CheckNumber</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={paymentRowData.documentNumber}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  )}{" "}
                {inquiryData != null &&
                  paymentRowData != null &&
                  paymentRowData.paymentType == 2 && (
                    <Row>
                      <Col sm="1">
                        {" "}
                        <FormLabel>CreditMemoAmount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={inquiryData.creditMemoAppliedAmount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>CreditMemoNumber</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={paymentRowData.documentNumber}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  )}
                <br />
                {creditMemoData != null && (
                  <div className="header_div col-md-12 col-lg-12">
                    <FormLabel>OverPaid CreditMemo Details</FormLabel>
                    <br />

                    <Row className="d-flex justify-content-left">
                      <Col sm="1">
                        <FormLabel>CreditMemo#</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.creditMemoNumber}
                          disabled={true}
                        />
                      </Col>

                      <Col sm="1">
                        {" "}
                        <FormLabel>Status</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.status}
                          disabled={true}
                        />
                      </Col>

                      <Col sm="1">
                        {" "}
                        <FormLabel>Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.amount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>

                      <Col sm="1">
                        {" "}
                        <FormLabel>Applied Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.appliedAmount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                <div className="sales_grid_columns">
                  <div className="header_div col-md-12 col-lg-12">
                    <FormLabel> CheckApplied Invoice Details</FormLabel>
                    <div className="customer_transaction_table">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>AR#</th>
                            <th>PO#</th>
                            <th>InvoiceDate</th>
                            <th>Invoice#</th>
                            <th>OpenInvoiceAmt</th>
                            <th>TotalAppliedAmt</th>
                            <th>AppliedAmt</th>
                            <th>CM Applied</th>
                          </tr>
                        </thead>
                        {inquiryDataList != null && (
                          <tbody>
                            {inquiryDataList.map((inquiryInfo, index) => (
                              <tr key={index}>
                                <td>
                                  <Button
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.viewARModule(
                                        e,
                                        inquiryInfo.accountReceivableNumber
                                      )
                                    }
                                  >
                                    {inquiryInfo.accountReceivableNumber}
                                  </Button>
                                </td>
                                <td>
                                  {inquiryInfo.customerPurchaseOrderNumber}
                                </td>
                                <td>
                                  {ModuleUtils.getDateFormat_v1(
                                    inquiryInfo.invoiceDate
                                  )}
                                </td>
                                <td>
                                  <Button
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.viewInvoiceModule(
                                        e,
                                        inquiryInfo.invoiceNumber
                                      )
                                    }
                                  >
                                    {inquiryInfo.invoiceNumber}
                                  </Button>
                                </td>
                                <td>{inquiryInfo.openInvoiceAmount}</td>
                                <td>{inquiryInfo.totalAppliedAmount}</td>
                                <td>{inquiryInfo.appliedAmount}</td>
                                <td>{inquiryInfo.creditMemoAppliedAmount}</td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>
                    </div>
                  </div>

                  <div className="header_div col-md-12 col-lg-12">
                    <FormLabel>
                      {" "}
                      OverPaid CreditMemo Applied Invoice Details
                    </FormLabel>
                    <div className="table_height">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>AR#</th>
                            <th>PO#</th>
                            <th>InvoiceDate</th>
                            <th>Invoice#</th>
                            <th>OpenInvoiceAmt</th>
                            <th>TotalInvoiceAmt</th>
                            <th>PaidAmt</th>
                            <th>AppliedAmt</th>
                            <th>CM Applied</th>
                          </tr>
                        </thead>
                        {creditMemoAppliedInvoiceList != null && (
                          <tbody>
                            {creditMemoAppliedInvoiceList.map(
                              (inquiryInfo, index) => (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewARModule(
                                          e,
                                          inquiryInfo.accountReceivableNumber
                                        )
                                      }
                                    >
                                      {inquiryInfo.accountReceivableNumber}
                                    </Button>
                                  </td>
                                  <td>
                                    {inquiryInfo.customerPurchaseOrderNumber}
                                  </td>
                                  <td>
                                    {ModuleUtils.getDateFormat_v1(
                                      inquiryInfo.invoiceDate
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceModule(
                                          e,
                                          inquiryInfo.invoiceNumber
                                        )
                                      }
                                    >
                                      {inquiryInfo.invoiceNumber}
                                    </Button>
                                  </td>
                                  <td>{inquiryInfo.openInvoiceAmount}</td>
                                  <td>{inquiryInfo.totalInvoiceAmount}</td>
                                  <td>{inquiryInfo.appliedAmount}</td>
                                  <td>{inquiryInfo.creditMemoAppliedAmount}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        )}
                      </Table>
                    </div>

                    <div className="header_div col-md-12 col-lg-12">
                      <FormLabel>
                        {" "}
                        Bounced Check Applied Invoice Details
                      </FormLabel>
                      <div className="table_height">
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th>Invoice#</th>
                              <th>InvoiceDate</th>
                              <th>AR#</th>
                              <th>AR Date</th>
                              <th>Check#</th>
                              <th>AppliedAmt</th>
                            </tr>
                          </thead>

                          {reversedCheckList != null && (
                            <tbody>
                              {reversedCheckList.map((inquiryInfo, index) => (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceModule(
                                          e,
                                          inquiryInfo.invoiceNumber
                                        )
                                      }
                                    >
                                      {inquiryInfo.invoiceNumber}
                                    </Button>
                                  </td>
                                  <td>
                                    {ModuleUtils.getDateFormat_v1(
                                      inquiryInfo.invoiceDate
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={() =>
                                        this.viewARModule(
                                          inquiryInfo.accountReceivableNumber
                                        )
                                      }
                                    >
                                      {inquiryInfo.accountReceivableNumber}
                                    </Button>
                                  </td>
                                  <td>{inquiryInfo.arDate}</td>
                                  <td>{inquiryInfo.checkNumber}</td>
                                  <td>{inquiryInfo.appliedAmount}</td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class ChangesHistoryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  statusTrackColumnDefinitions = () => {
    let columnList = [];

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Date", "createdDate")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Amount", "grandTotalAmount")
        .setSortColumn(true)
    );

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Status", "currentStatus")
        .setColumnType("statusColumn")
        .setStatusCaptionConverter(ModuleUtils.getInvoiceStatusCaption)
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Pre Status", "previousStatus")
        .setColumnType("statusColumn")
        .setStatusCaptionConverter(ModuleUtils.getInvoiceStatusCaption)
        .setSortColumn(true)
    );

    return columnList;
  };
  changesHistoryColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Date", "updatedDate")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Done By", "updatedBy")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Changes", "description")
        .setSortColumn(true)
    );

    return columnList;
  };

  render() {
    let invoiceData = new InvoiceBean();
    invoiceData = this.props.invoiceData;
    let statusTracks = [];
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.statusTracks))
      statusTracks = invoiceData.statusTracks;
    let changeHistoryTracks = [];
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.changeHistoryTracks))
      changeHistoryTracks = invoiceData.changeHistoryTracks;

    return (
      <div className="header_div">
        <div className="so_changes_history_main_div">
          <div className="so_status_history_div">
            <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>StatusTracks</FormLabel>{" "}
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <div className="div_Custom_2">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>PreStatus</th>
                      </tr>
                    </thead>
                    {statusTracks != null ? (
                      <tbody>
                        {statusTracks.map((st, index) => (
                          <tr key={index}>
                            <td>{st.createdDate}</td>
                            <td>{st.invoiceTotalAmount}</td>
                            <td>
                              {ModuleUtils.getInvoiceStatusCaption(
                                st.currentStatus
                              )}
                            </td>
                            <td>
                              {ModuleUtils.getInvoiceStatusCaption(
                                st.previousStatus
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
          <div className="so_changes_history_div">
            <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>ChangesHistory</FormLabel>{" "}
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <div className="div_Custom_2">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Done By</th>
                        <th>Changes</th>
                      </tr>
                    </thead>
                    {changeHistoryTracks != null ? (
                      <tbody>
                        {changeHistoryTracks.map((ch, index) => (
                          <tr key={index}>
                            <td>{ch.updatedDate}</td>
                            <td>{ch.updatedBy}</td>
                            <td>{ch.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class PaymentHistoryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      invoiceData: this.props.invoiceData,
      paymentHistoryList: [],
      isShowSalesModule: false,
      isShowPickticketModule: false,
      isShowARModule: false,
      isShowInvoiceModule: false,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.getPaymentHistory();
  }
  getPaymentHistory = () => {
    let invoiceData = this.state.invoiceData;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = invoiceData.code;
    if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
      AccountReceivableService.getPaymentHistoryDetailsForInvoice(
        request,
        this.getPaymentHistoryPageResponse,
        this.getPaymentHistoryPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getPaymentHistoryPageResponse = (response) => {
   
    if (response.data != null) {
      if (response.data.pageList != null) {
        let paymentHistoryList = response.data.pageList.historyDetails;
        if (paymentHistoryList != null) {
          this.setState({ paymentHistoryList: paymentHistoryList });
        }
      }
    }
  };
  getPaymentHistoryPageError = (error) => {
    ShowError("Error", error);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowARModule: isOpen,
      isShowSalesModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPickticketModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewSalesModule = (e, code) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPickTicketModule = (e, code) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        this.setState({
          isShowPickticketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewDocumentModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (!isEmptyString(code)) {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInvoiceModule: true,
            moduleForPopup: (
              <PopupInvoiceModule
                invoiceCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (
        rowData.documentType === "CREDITMEMO" ||
        rowData.documentType === "CREDITMEMORETURN"
      ) {
        if (!isEmptyString(code)) {
          this.setState({
            isShowCreditMemoModule: true,
            moduleForPopup: (
              <PopupCreditMemoModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.documentType === "CHBOUNCE") {
        if (code !== "" && code !== undefined) {
        }
      } else if (rowData.documentType === "AR") {
        if (!isEmptyString(code)) {
          this.setState({
            isShowARModule: true,
            moduleForPopup: (
              <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
            ),
          });
        }
      }
    }
  };
  paymentHistoryReport = (e) => {
    if (e.detail == 1) {
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let request = new InvoicePaymentHistoryPrintOutRequest();
      request.companyCode = this.companyCode;
      request.invoiceNumber = this.props.invoiceData.code;
      request.reportBean = reportBean;
      if (SecurityAccessManager.InvoiceMaintenance_IsAccessible()) {
        ReportService.generateInvoicePaymentHistoryPrintOutReport(
          request,
          this.generateInvoiceReportResponse,
          this.generateInvoiceReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateInvoiceReportResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generateInvoiceReportError = (error) => {
    ShowError("Error : " + error);
  };

  render() {
    let invoiceData = this.props.invoiceData;
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>CustomerCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={invoiceData.customerCode}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              value={invoiceData.customerName}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>CustomerPO#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={invoiceData.customerPurchaseOrderNumber}
              disabled={true}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="1">
            <FormLabel>InvoiceDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              value={invoiceData.invoiceDate}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel
              className="hyperLinkText"
              onClick={(e) =>
                this.viewSalesModule(e, invoiceData.salesOrderNumber)
              }
            >
              SalesOrder#
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={invoiceData.salesOrderNumber}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel
              className="hyperLinkText"
              onClick={(e) =>
                this.viewPickTicketModule(e, invoiceData.pickTicketNumber)
              }
            >
              PickTicket#
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={invoiceData.pickTicketNumber}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <Button size="sm" onClick={(e) => this.paymentHistoryReport(e)}>
              Print
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Payment History</FormLabel>
          </Col>
        </Row>
        {/* <Row> */}
        <div className="div_Custom_2">
          <Table id="fabrics_tables_default">
            <thead>
              <th>Payment Date</th>
              <th>Document</th>
              <th>Document Type</th>
              <th>Amount</th>
              <th>Memo</th>
              <th>Status</th>
            </thead>
            {this.state.paymentHistoryList ? (
              <tbody>
                {this.state.paymentHistoryList.map((list, index) => (
                  <tr key={index}>
                    <td>{ModuleUtils.getDateFormat_v1(list.date)}</td>
                    <td>
                      <Button
                        className="hyperLinkText"
                        variant="secondry"
                        size="sm"
                        onClick={(e) =>
                          this.viewDocumentModule(e, list.documentNumber, list)
                        }
                      >
                        {list.documentNumber}
                      </Button>
                    </td>
                    <td>{list.documentType}</td>
                    <td className="text-right">
                      {toCommaSeperatedAmount(list.paymentHistoryAmount)}
                    </td>
                    <td>{list.memoDetails}</td>
                    <td>{list.status}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
        </div>
        {/* </Row> */}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickticketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class SalesCommissionForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.salesPersonRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
  }
  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersonList,
      "Sales Person"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCommissionChange = (e) => {
    this.props.onCommissionChange(e);
  };
  onAddorUpdateCommissionClick = (e) => {
    if (e.detail == 1) this.props.onAddorUpdateCommissionClick(e);
    if (this.salesPersonRef.current != null) {
      this.salesPersonRef.current.clear();
    }
  };

  onClearCommissionClick = (e) => {
    if (e.detail == 1) this.props.onClearCommissionClick(e);
  };
  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };

  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };

  deleteCommissionClickCallback = (e, rowData) => {
    if (e.detail == 1) this.props.deleteCommissionClickCallback(rowData);
  };
  handleCommissionLineNumberClick = (e, rowData) => {
    if (e.detail == 1) this.props.handleCommissionLineNumberClick(rowData);
  };

  salesCommissionColumnDefinitions = () => {
    let columnList = [];
    let disablePurchaseOrderFormFields =
      this.props.disablePurchaseOrderFormFields;

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Ln#",
        "lineNumber",
        0,
        true,
        this.handleLineNumberClick,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesPerson",
        "salesPersonCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesPersonName",
        "salesPersonName",
        0,
        false,
        null,
        false,
        null,
        "15em", //min-width
        "25%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Commission%",
        "commissionPercentage",
        0,
        false,
        null,
        false,
        null,
        "5em", //min-width
        "9%" //max-width
      )
    );

    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          <DeleteIcon />,
          // true,
          0,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%" //max-width
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.buttonClickCallback,
          false,
          null
        )
        .setDisabled(disablePurchaseOrderFormFields)
    );
    return columnList;
  };

  render() {
    let invoiceData = new InvoiceBean();
    invoiceData = this.props.invoiceData;

    let salesCommissionData = this.props.salesCommissionData;
    if (salesCommissionData == null) {
      salesCommissionData = new InvoiceCommissionBean();
    }
    let commissions = [];
    if (!isEmpty(invoiceData) && !isEmpty(invoiceData.invoiceCommissions))
      commissions = invoiceData.invoiceCommissions;
    let isDisabledFields = this.props.isDisabledFields;

    // let disableInvoiceFormFields =
    //   this.props.disablePurchaseOrderFormFields;
    let disableInvoiceFormFields = isDisabledFields;
    let salesPersonList = this.props.salesPersonList;
    //let isModify = this.props.isModifyPosible();

    let isModify = false;
    isModify = this.props.isModifyPosible();

    let disableUpdatableFields = false;
    if (!this.props.isViewMode) {
      if (disableInvoiceFormFields) {
        if (isModify) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    } else {
      disableUpdatableFields = true;
    }
    return (
      <div>
        <div>
          {" "}
          <div className="div_Custom_1">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Ln#</th>
                  <th>SalesPersonCode</th>
                  <th>salesPersonName</th>
                  <th>Commission%</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {commissions.map(
                  (cm, index) =>
                    cm.isDeleted != true && (
                      <tr key={index}>
                        <td className="hyperLinkText">
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.handleCommissionLineNumberClick(e, cm)
                            }
                          >
                            {cm.lineNumber}
                          </Button>
                        </td>
                        <td>{cm.salesPersonCode}</td>
                        <td>{cm.salesPersonName}</td>
                        <td>{cm.commissionPercentage}</td>
                        <td>
                          <Button
                            size="sm"
                            onClick={(e) =>
                              this.deleteCommissionClickCallback(e, cm)
                            }
                            disabled={isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Ln#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                onChange={this.onCommissionChange}
                readOnly={true}
                value={salesCommissionData.lineNumber}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>SalesPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonRef}
                onChange={this.salesPersonCodeOnChange}
                //readOnly={disableSalesOrderFormFields}
                disabled={disableUpdatableFields}
                name="salesPersonCode"
                value={salesCommissionData.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                isModifyView={isModify}
                enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.salesPersonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonList
                }
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>SalesPersonName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesPersonName"
                type="text"
                onChange={this.onCommissionChange}
                readOnly={true}
                value={salesCommissionData.salesPersonName}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Commission%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={salesCommissionData.commissionPercentage}
                onChange={this.onCommissionChange}
                className="qty_input text-right"
                decimalScale={2}
                name={"commissionPercentage"}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <Button
                id="fabric_Add_Button"
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onAddorUpdateCommissionClick(e)}
                disabled={disableUpdatableFields}
              >
                Add/Update
              </Button>
              <Button
                id="fabric_Add_Button"
                size="sm"
                onClick={(e) => this.onClearCommissionClick(e)}
                disabled={disableUpdatableFields}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

//Fabric ShortCut Menu

class ExtraChargeDetailForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      invoiceExtraChargeData: this.props.invoiceExtraChargeData,
      // extraChargeReasons: [],
    };
    this.reasonCodeRef = React.createRef();
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let invoiceData = this.props.invoiceData;

    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let extraChargeLookupHandler = new GenericAttributeLookupHandler(
      this.props.extraChargeReasons,
      "ExtraCharge Reason"
    );
    this.setState({ extraChargeLookupHandler: extraChargeLookupHandler });
  };
  onExtraChargeLineClick = (e, rowData) => {
    if (e.detail == 1) this.props.onExtraChargeLineClick(rowData);
  };

  onExtraChange = (e) => {
    this.props.onExtraChange(e);
  };
  onExtraReasonChange = (e) => {
    this.props.onExtraReasonChange(e);
  };
  addUpdateExtraChargeLine = (e) => {
    if (e.detail == 1) this.props.addUpdateExtraChargeLine();
  };

  deleteExtraCharge = (e, rowData) => {
    if (e.detail == 1) this.props.deleteExtraCharge(rowData);
  };

  extraChargeEnterKeyEventHandler = (e) => {
    this.props.extraChargeEnterKeyEventHandler(e);
  };
  displayAutoCompleteExtraChargeList = (list) => {
    this.props.displayAutoCompleteExtraChargeList(list);
  };

  render() {
    let invoiceExtraChargeData = this.props.invoiceExtraChargeData;
    let invoiceData = this.props.invoiceData;
    // let disableInvoiceFormFields = this.props.disableInvoiceFormFields;
    let disableInvoiceFormFields = this.props.isDisabledFields;
    let isModify = false;
    isModify = this.props.isModifyPosible;
    let extraChargeLines = invoiceData.extraCharges;
    if (extraChargeLines == null) {
      extraChargeLines = new Array();
    }
    let disableUpdatableFields = false;
    if (disableInvoiceFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    const textAreaStyle = {
      maxHeight: "10em",
      width: "60em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    return (
      <div>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>CompanyCode</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              type="text"
              value={invoiceData.companyCode}
              onChange={this.onExtraChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Invoice#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              type="text"
              value={invoiceData.code}
              onChange={this.onExtraChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <FormLabel>Extra Charges</FormLabel>
        </Row>
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Ln#</th>
                <th>Reason</th>
                <th>Description</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {extraChargeLines.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.onExtraChargeLineClick(e, ln)}
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.extraChargeReasonCode}</td>
                      <td>{ln.extraChargeReasonName}</td>
                      <td>{ln.extraChargesAmount}</td>
                      <td>
                        <Button onClick={(e) => this.deleteExtraCharge(e, ln)}>
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  )
              )}
            </tbody>
          </Table>
        </div>

        <Row>
          <FormLabel>Extra Charge Line Detail</FormLabel>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Ln#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              type="text"
              value={invoiceExtraChargeData.lineNumber}
              onChange={this.onExtraChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Reason</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="extraChargeReasonCode"
              placeholder="Enter extraChargeReasonCode"
              ref={this.reasonCodeRef}
              onChange={this.onExtraReasonChange}
              value={invoiceExtraChargeData.extraChargeReasonCode}
              lookupHandler={this.state.extraChargeLookupHandler}
              lookupRequired={true}
              valuePropery="code"
              descriptionProperty="description"
              enterKeyEventHandler={this.extraChargeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.extraChargePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteExtraChargeList}
              showAutoCompleteList={this.props.showAutoCompleteExtraChargeList}
              disabled={disableUpdatableFields}
              isModifyView={isModify}
              isMandatory={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>Amount</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"extraChargesAmount"}
              onChange={this.onExtraChange}
              value={invoiceExtraChargeData.extraChargesAmount}
              className="text-right"
              decimalScale={2}
              disabled={disableUpdatableFields}
              isModifyView={isModify}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="1">
            <FormLabel> Description </FormLabel>
          </Col>
          <Col sm="5">
            <textarea
              style={textAreaStyle}
              className="form-control enterFocus"
              type="text"
              name="extraChargeReasonName"
              onChange={this.onExtraChange}
              value={invoiceExtraChargeData.extraChargeReasonName}
              disabled={disableUpdatableFields}
              isModifyView={isModify}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addUpdateExtraChargeLine(e)}
            >
              Add/Update
            </Button>
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons"
              onClick={(e) => this.props.clearExtraChargesValues(e)}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

class NonMerchandiseDetailForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      merchandiseData: this.props.merchandiseData,
    };
    this.reasonCodeRef = React.createRef();
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let invoiceData = this.props.invoiceData;

    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let merchandiseLookupHandler = new GenericAttributeLookupHandler(
      this.props.nonMerchandiseReasons,
      "Non Merchandise Reason"
    );
    this.setState({ merchandiseLookupHandler: merchandiseLookupHandler });
  };
  onMerchandiseLineClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.onMerchandiseLineClick(val, rowData);
  };

  onNonMerchandiseChange = (e) => {
    this.props.onNonMerchandiseChange(e);
  };
  onNonMerchandiseReasonChange = (e) => {
    this.props.onNonMerchandiseReasonChange(e);
  };
  addUpdateMerchandiseLine = (e) => {
    if (e.detail == 1) this.props.addUpdateMerchandiseLine();
  };
  deleteNonMerchandiseLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteNonMerchandiseLine(rowData);
  };
  clearMerchandiseValues = () => {
    this.props.clearMerchandiseValues();
  };

  nonMercEnterKeyEventHandler = (e) => {
    this.props.nonMercEnterKeyEventHandler(e);
  };
  displayAutoCompleteNonMercList = (list) => {
    this.props.displayAutoCompleteNonMercList(list);
  };
  merchandiseColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Line#",
        "lineNumber",
        0,
        true,
        this.onMerchandiseLineClick
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Reason#", "reasonCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Description", "reasonName")
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails("Amount", "lineTotalAmount")
    );
    return columnList;
  };

  render() {
    let merchandiseData = this.props.merchandiseData;
    let invoiceData = this.props.invoiceData;
    let disableInvoiceFormFields = this.props.disableInvoiceFormFields;
    let isModify = this.props.isModifyPosible;
    let lines = invoiceData.nonMerchandiseLines;
    if (lines == null) {
      lines = new Array();
    }
    const textAreaStyle = {
      maxHeight: "10em",
      width: "60em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    return (
      <div>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>CompanyCode</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              type="text"
              value={invoiceData.companyCode}
              onChange={this.onNonMerchandiseChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Invoice#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              type="text"
              value={invoiceData.code}
              onChange={this.onNonMerchandiseChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <FormLabel>Non Merchandise Lines</FormLabel>
        </Row>

        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Ln#</th>
                <th>Reason</th>
                <th>Description</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lines.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.onMerchandiseLineClick(e, ln.lineNumber, ln)
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.reasonCode}</td>
                      <td>{ln.reasonName}</td>
                      <td>{ln.lineTotalAmount}</td>
                      <td>
                        <Button
                          onClick={(e) => this.deleteNonMerchandiseLine(e, ln)}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  )
              )}
            </tbody>
          </Table>
        </div>

        <Row>
          <FormLabel>Non Merchandise Line Detail</FormLabel>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Ln#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              type="text"
              value={merchandiseData.lineNumber}
              onChange={this.onNonMerchandiseChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Reason</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="reasonCode"
              placeholder="Enter ReasonCode"
              ref={this.reasonCodeRef}
              onChange={this.onNonMerchandiseReasonChange}
              value={merchandiseData.reasonCode}
              lookupHandler={this.state.merchandiseLookupHandler}
              lookupRequired={true}
              valuePropery="code"
              descriptionProperty="description"
              enterKeyEventHandler={this.nonMercEnterKeyEventHandler}
              autoCompleteListData={
                this.props.nonMercPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteNonMercList}
              showAutoCompleteList={this.props.showAutoCompleteNonMercList}
              isMandatory={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>Amount</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"lineTotalAmount"}
              onChange={this.onNonMerchandiseChange}
              value={merchandiseData.lineTotalAmount}
              className="text-right"
              decimalScale={2}
              disabled={disableInvoiceFormFields}
              isModifyView={isModify}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="2">
            <FormLabel> Description </FormLabel>
          </Col>
          <Col sm="5">
            <textarea
              style={textAreaStyle}
              className="form-control enterFocus"
              type="text"
              name="reasonName"
              onChange={this.onNonMerchandiseChange}
              value={merchandiseData.reasonName}
              disabled={disableInvoiceFormFields}
              isModifyView={isModify}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addUpdateMerchandiseLine(e)}
            >
              Add/Update
            </Button>
          </Col>
          <Col sm="1">
            <Button
              className="header_buttons"
              size="sm"
              onClick={(e) => this.props.clearMerchandiseValues(e)}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
class InvoicePaymentPopupForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
    this.reasonCodeRef = React.createRef();
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let invoiceData = this.props.invoiceData;

    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let paymentTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTypes,
      "Payment Types"
    );
    this.setState({ paymentTypeLookupHandler: paymentTypeLookupHandler });
  };

  onCardDetailsChange = (e) => {
    this.props.onCardDetailsChange(e);
  };

  onARChange = (e) => {
    this.props.onARChange(e);
  };

  onCheckDetailsChange = (e) => {
    this.props.onCheckDetailsChange(e);
  };

  onWireTransferDetailsChange = (e) => {
    this.props.onWireTransferDetailsChange(e);
  };

  onChange = (e) => {
    this.props.onChange(e);
  };
  onARPaymentTypeChange = (e) => {
    this.props.onARPaymentTypeChange(e);
  };

  onPaymentTypeChange = (e) => {
    this.props.onPaymentTypeChange(e);
  };
  paymentTypeEnterKeyEventHandler = (e) => {
    this.props.paymentTypeEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTypeList = (list) => {
    this.props.displayAutoCompletePaymentTypeList(list);
  };

  render() {
    let invoiceData = this.props.invoiceData;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    invoiceData.arDate = currentDate;
    let disableInvoiceFormFields = this.props.disableInvoiceFormFields;
    let isModify = this.props.isModifyPosible;
    let disableUpdatableFields = false;
    let cardDetail = this.props.cardDetail;
    let arData = this.props.arData;
    let checkDetail = this.props.checkDetail;
    let wireTransferDetail = this.props.wireTransferDetail;
    let payment_width = "100";
    let openInvoiceAmount =
      invoiceData.grandTotalAmount -
      invoiceData.provisionalPaymentAmount -
      invoiceData.netPaidAmount;
    let status = null;
    if (!isEmpty(invoiceData) && !isEmptyArray(invoiceData.invoiceStatus))
      status = ModuleUtils.getInvoiceStatusCaption(invoiceData.invoiceStatus);
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "12em",
      resize: "none",
      padding: "5px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div className="sales_line_pop">
        <div>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Invoice#</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="code"
                type="text"
                onChange={this.onChange}
                readOnly={true}
                value={invoiceData.code}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Customer</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                ref={this.customerCodeRef}
                name="customerCode"
                type="text"
                onChange={this.onChange}
                readOnly={true}
                value={invoiceData.customerCode}
              />{" "}
            </Col>

            <Col sm="3">
              <InputTextbox
                name="customerName"
                type="text"
                onChange={this.onChange}
                readOnly={true}
                value={invoiceData.customerName}
              />{" "}
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>Status</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="status"
                className="summary_input"
                onChange={this.onChange}
                readOnly={true}
                value={status}
              />
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>Currency</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="invoiceCurrencyCode"
                placeholder="Currency"
                onChange={this.onChange}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                value={invoiceData.invoiceCurrencyCode}
                isMandatory={true}
              />
            </Col>
          </Row>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>ARDate</FormLabel>
            </Col>

            <Col sm="2">
              <DatePickerComponent
                name="arDate"
                onChange={this.onChange}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                value={invoiceData.arDate}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>PaymentType</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onPaymentTypeChange}
                ref={this.paymentTypeRef}
                name="paymentTypeCode"
                placeholder="paymentTypeCode"
                value={arData.paymentTypeCode}
                lookupRequired={true}
                lookupHandler={this.state.paymentTypeLookupHandler}
                enterKeyEventHandler={this.paymentTypeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.paymentTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePaymentTypeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePaymentTypeList
                }
                disabled={disableUpdatableFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>GrandTotalAmt </FormLabel>{" "}
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={invoiceData.grandTotalAmount}
                onChange={this.onChange}
                className="qty_input text-right"
                decimalScale={2}
                name={"grandTotalAmount"}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Open InvoiceAmt </FormLabel>{" "}
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={openInvoiceAmount}
                onChange={this.onChange}
                className="qty_input text-right"
                decimalScale={2}
                name={"openInvoiceAmount"}
                disabled={true}
              />
            </Col>
          </Row>
          <br />
        </div>

        <div className="invPay_gridAlign">
          <div className="invPay_align1">
            <div className="invPay_align2">
              {this.props.isCheckPayment && (
                <div>
                  <div className="inv_caption"> Check Details </div>
                  {/* <div className="checkDetails header_div "> */}
                  <div>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Check#</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="checkNumber"
                          type="text"
                          placeholder="Enter Check Number"
                          value={checkDetail.checkNumber}
                          onChange={this.onCheckDetailsChange}
                          isMandatory={true}
                        />
                      </Col>

                      <Col sm="2">
                        <FormLabel>CheckDate</FormLabel>
                      </Col>

                      <Col sm="4">
                        <DatePickerComponent
                          name="checkDate"
                          value={checkDetail.checkDate}
                          onChange={this.onCheckDetailsChange}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>BankName</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="issuedBankName"
                          type="text"
                          placeholder="Enter BankName"
                          value={checkDetail.issuedBankName}
                          onChange={this.onCheckDetailsChange}
                        />
                      </Col>
                      <Col sm="2">
                        <FormLabel>CheckAmt</FormLabel>
                      </Col>

                      <Col sm="4">
                        <NumberFormatInputbox
                          name={"checkAmount"}
                          onChange={this.onCheckDetailsChange}
                          placeholder="Enter CheckAmount"
                          value={checkDetail.checkAmount}
                          className="text-right"
                          decimalScale={2}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
              {this.props.isCashPayment && (
                <div>
                  <div className="inv_caption"> Cash Details </div>
                  <div>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Amount</FormLabel>
                      </Col>

                      <Col sm="4">
                        <NumberFormatInputbox
                          name={"cashAmount"}
                          onChange={this.onARChange}
                          placeholder="Enter Amount"
                          value={arData.cashAmount}
                          className="text-right"
                          decimalScale={2}
                          isMandatory={true}
                        // onBlur={this.onTenderAmountBlur}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              )}

              {this.props.isCardPayment && (
                <div>
                  <div className="inv_caption"> Card Details </div>
                  <div>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Card#</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="cardNumber"
                          type="text"
                          placeholder="Enter Card Numbers"
                          value={cardDetail.cardNumber}
                          onChange={
                            this.props.onCustomerCreditCardDetailsChange
                          }
                          isMandatory={true}
                          lookupRequired={this.props.isShowCustomerCreditCardLookup}
                          lookupHandler={
                            this.props.customerCreditCardLookUpHandler
                          }

                        />
                      </Col>

                      <Col sm="2">
                        <FormLabel>CardType</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="cardType"
                          placeholder="Enter CardType"
                          onChange={this.onCardDetailsChange}
                          value={cardDetail.cardType}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Exp Month</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="expiryMonth"
                          type="text"
                          placeholder="Enter Expiry Month"
                          value={cardDetail.expiryMonth}
                          onChange={this.onCardDetailsChange}
                          isMandatory={true}
                        />
                      </Col>
                      <Col sm="2">
                        <FormLabel>Exp Year</FormLabel>
                      </Col>
                      <Col sm="4">
                        <InputTextbox
                          name="expiryYear"
                          type="text"
                          placeholder="Enter Expire Year"
                          value={cardDetail.expiryYear}
                          onChange={this.onCardDetailsChange}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>

                    <Row>
                      {/* <Col sm="2">
                        <FormLabel>CVV #</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="cvvNumber"
                          type="text"
                          placeholder="Enter CVVNumber"
                          value={cardDetail.cvvNumber}
                          onChange={this.onCardDetailsChange}
                          isMandatory={true}
                        />
                      </Col> */}
                      <Col sm="2">
                        <FormLabel>CardAmt</FormLabel>
                      </Col>
                      <Col sm="4">
                        <NumberFormatInputbox
                          name={"cardAmount"}
                          onChange={this.onCardDetailsChange}
                          placeholder="Enter CardAmount"
                          value={cardDetail.cardAmount}
                          className="text-right"
                          decimalScale={2}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>DebitCard</FormLabel>
                      </Col>
                      <Col sm="4">
                        <InputCheckbox
                          name="isDebitCard"
                          type="checkbox"
                          checked={cardDetail.isDebitCard}
                          onChange={this.onCardDetailsChange}
                          isMandatory={true}
                        />
                      </Col>

                      <Col sm="2">
                        <FormLabel>Payment Required</FormLabel>
                      </Col>
                      <Col sm="4">
                        <InputCheckbox
                          name="isPaymentProcessRequired"
                          type="checkbox"
                          checked={cardDetail.isPaymentProcessRequired}
                          onChange={this.onCardDetailsChange}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              )}

              {this.props.isWirePayment && (
                <div>
                  <div className="label_head"> WireTransfer Details </div>
                  <div>
                    <Row>
                      <Col sm="2">
                        <FormLabel>WireTransfer Ref#</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="wireTransferReferenceNumber"
                          type="text"
                          placeholder="Enter Transfer Number"
                          value={wireTransferDetail.wireTransferReferenceNumber}
                          onChange={this.onWireTransferDetailsChange}
                          isMandatory={true}
                        />
                      </Col>

                      <Col sm="2">
                        <FormLabel>WireTransfer Date</FormLabel>
                      </Col>

                      <Col sm="4">
                        <DatePickerComponent_adv
                          name="wireTransferDate"
                          value={wireTransferDetail.wireTransferDate}
                          onChange={this.onWireTransferDetailsChange}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>BankName</FormLabel>
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="issuedBankName"
                          type="text"
                          placeholder="Enter BankName"
                          value={wireTransferDetail.issuedBankName}
                          onChange={this.onWireTransferDetailsChange}
                        />
                      </Col>
                      <Col sm="2">
                        <FormLabel>Amt</FormLabel>
                      </Col>

                      <Col sm="4">
                        <NumberFormatInputbox
                          name={"wireTransferAmount"}
                          onChange={this.onWireTransferDetailsChange}
                          placeholder="Enter CheckAmount"
                          value={wireTransferDetail.wireTransferAmount}
                          className="text-right"
                          decimalScale={2}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
              {this.props.isAchPayment && <div>

              </div>}
            </div>
          </div>
          <div>
            <FormLabel>Comments</FormLabel>

            <Row>
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="comments"
                type="text"
                onChange={this.onChange}
                value={invoiceData.comments}
                disabled={disableUpdatableFields}
              />
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class ServiceDetailsForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() { }
  serviceLineOnchange = (e) => {
    this.props.serviceLineOnchange(e);
  };
  invoiceUomOnChange = (e) => {
    this.props.invoiceUomOnChange(e);
  };
  invoiceUomEnterKeyEvent = (e) => {
    this.props.invoiceUomEnterKeyEvent(e);
  };
  serviceOnChange = (e) => {
    this.props.serviceOnChange(e);
  };
  serviceEnterKeyEvent = (e) => {
    this.props.serviceEnterKeyEvent(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayInvoiceUomAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayInvoiceUomAutoCompleteList(showAutoCompleteList);
  };
  displayServiceAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayServiceAutoCompleteList(showAutoCompleteList);
  };
  editService = (e, data, rowData) => {
    if (e.detail == 1) this.props.editService(data, rowData);
  };
  addLines = (e, rowData) => {
    if (e.detail == 1) this.props.addLines(rowData);
  };
  clearLines = (e) => {
    if (e.detail == 1) this.props.clearLines();
  };
  deleteService = (e, rowData) => {
    if (e.detail == 1) this.props.deleteService(rowData);
  };
  onHeaderAmountsChange = (e) => {
    this.props.onHeaderAmountsChange(e);
  };
  render() {
    let invoiceData = this.props.invoiceData;
    let invoiceServiceLineList = [];
    if (!isEmptyArray(this.props.invoiceData.serviceLines)) {
      invoiceServiceLineList = this.props.invoiceData.serviceLines;
    }
    let serviceDetail = this.props.invoiceServiceLineData;
    return (
      <div className="header_div">
        <div>
          <Row>
            <Col className="align-items-left" sm="2">
              <FormLabel>Service Lines</FormLabel>
            </Col>
          </Row>
          <div className="div_Custom_1">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Line#</th>
                  <th>Service</th>
                  <th>Description</th>
                  <th>Uom</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              {invoiceServiceLineList != null ? (
                <tbody>
                  {invoiceServiceLineList.map((ln, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.editService(e, ln.lineNumber, ln)
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.serviceCode}</td>
                      <td>{ln.serviceName}</td>
                      <td>{ln.uomCode}</td>
                      <td className="summary_input text-right">
                        {ln.quantity}
                      </td>
                      <td className="summary_input text-right">
                        {ln.unitPrice}
                      </td>
                      <td className="summary_input text-right">{ln.amount}</td>
                      <td className="">
                        {ModuleUtils.getInvoiceServiceLineStatusCaption(
                          ln.lineStatus
                        )}
                      </td>
                      <td className="text-center">
                        {!ln.isFetched && (
                          <Button
                            size="sm"
                            onClick={(e) => this.deleteService(e, ln)}
                          >
                            <DeleteIcon />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {invoiceServiceLineList.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
        <div className="div_inline">
          <div className="div_75_no_overflow_no_height">
            <Row>
              <Col className="align-items-left" sm="">
                <FormLabel>Service Line Detail</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Ln#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="lineNumber"
                  type="text"
                  onChange={this.serviceLineOnchange}
                  readOnly={true}
                  value={serviceDetail.lineNumber}
                  disabled={true}
                  isMandatory={true}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Service</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.serviceOnChange}
                  placeholder="serviceCode"
                  name="serviceCode"
                  value={serviceDetail.serviceCode}
                  lookupRequired={true}
                  lookupHandler={this.props.serviceLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.serviceEnterKeyEvent}
                  autoCompleteListData={
                    this.props.servicePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayServiceAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteServiceList
                  }
                  disabled={this.props.isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="serviceName"
                  onChange={this.serviceLineOnchange}
                  // readOnly={true}
                  value={serviceDetail.serviceName}
                  disabled={this.props.isDisabledFields}
                  isMandatory={true}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>UOM</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="uomCode"
                  onChange={this.serviceLineOnchange}
                  readOnly={true}
                  value={serviceDetail.uomCode}
                  disabled={true}
                  isMandatory={true}
                />{" "}
              </Col>
            </Row>
            <Row>
              {/* <Col sm="1">
                {" "}
                <FormLabel>UOM</FormLabel>{" "}
              </Col> */}
              {/* <Col sm="2"> */}
              {/* <InputTextbox
                  onChange={this.invoiceUomOnChange}
                  placeholder="uomCode"
                  name="uomCode"
                  value={serviceDetail.uomCode}
                  lookupRequired={true}
                  lookupHandler={this.props.uomLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.invoiceUomEnterKeyEvent}
                  autoCompleteListData={
                    this.props.invoiceUomPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayInvoiceUomAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteInvoiceUomList
                  }
                  disabled={this.props.isDisabledFields}
                /> */}
              {/* </Col> */}
              <Col sm="1">
                {" "}
                <FormLabel>Price</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={serviceDetail.unitPrice}
                  onChange={this.serviceLineOnchange}
                  className=" text-right"
                  decimalScale={2}
                  name={"unitPrice"}
                  isMandatory={true}
                // readOnly={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Qty</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={serviceDetail.quantity}
                  onChange={this.serviceLineOnchange}
                  className=" text-right"
                  decimalScale={2}
                  name={"quantity"}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Amount</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={serviceDetail.amount}
                  onChange={this.serviceLineOnchange}
                  className="summary_input text-right"
                  decimalScale={2}
                  name={"amount"}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addLines(e)}
                >
                  Add/Update
                </Button>
                <Button
                  id="fabric_Add_Button"
                  size="sm1"
                  onClick={(e) => this.clearLines(e)}
                >
                  Clear
                </Button>
              </Col>
            </Row>
          </div>
          <div className="div_25_no_overflow_no_height">
            <div>
              <Row>
                <Col sm="">
                  {" "}
                  <FormLabel>Amount Details</FormLabel>{" "}
                </Col>
              </Row>
            </div>
            <div className="header_div">
              <Row>
                <Col>
                  <FormLabel>Tot Service Amount</FormLabel>
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={invoiceData.totalServiceAmount}
                    onChange={this.onHeaderAmountsChange}
                    className="text-right summary_input"
                    decimalScale={2}
                    name={"totalServiceAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>GrandTotal Amount</FormLabel>
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={invoiceData.grandTotalAmount}
                    onChange={this.onHeaderAmountsChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"grandTotalAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function InvoiceMaintenanceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InvoiceList {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default InvoiceMaintenanceModule;
